/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ErrorResponseElement {
  errorClass?: string;
  errorType?: string;
  errorMessage?: string;
  fieldName?: string;
  errorKey?: string;
  errorArgs?: object[];
  upstreamError?: UpstreamErrorResponse;
}

export type ServiceErrorResponseDto = object;

export interface SsoErrorResponseDto {
  errors?: ErrorResponseElement[];
}

export interface UpstreamErrorResponse {
  requestUrl?: string;
  /** @format int32 */
  statusCode?: number;
  serviceResponse?: ServiceErrorResponseDto;
}

export interface SsoAbstractResponseDtoVoid {
  payloadType?: string;
  payload?: object;
}

export interface UploadUnitTeamPictureDto {
  /** @minLength 1 */
  filename?: string;
  /** @minLength 1 */
  content?: string;
}

export interface SsoAbstractResponseDtoUploadUnitTeamPictureResponseDto {
  payloadType?: string;
  payload?: UploadUnitTeamPictureResponseDto;
}

export interface UploadUnitTeamPictureResponseDto {
  msg?: string;
  aux?: string;
  /** @minLength 1 */
  unitTeamPictureImageUri?: string;
  /** @minLength 1 */
  unitTeamPictureImageUrl?: string;
}

export interface UpdateTeamNameDto {
  /** @minLength 1 */
  newTeamName?: string;
}

export interface SsoAbstractResponseDtoSsoMessageResponseDto {
  payloadType?: string;
  payload?: SsoMessageResponseDto;
}

export interface SsoMessageResponseDto {
  msg?: string;
  aux?: string;
}

export interface TeamMfaConfigDto {
  mfaRequired?: boolean;
}

export interface GroupMembershipDto {
  groupId?: string;
  groupName?: string;
}

export interface SsoAbstractResponseDtoTeamMemberDto {
  payloadType?: string;
  payload?: TeamMemberDto;
}

export interface TeamMemberAllowedSitesDto {
  /** @uniqueItems true */
  allowedSiteIds?: number[];
  allowedAllSites?: boolean;
}

export interface TeamMemberDto {
  memberUserId?: string;
  memberId?: string;
  memberEmail?: string;
  memberFirstName?: string;
  memberLastName?: string;
  memberImageUri?: string;
  memberImageUrl?: string;
  memberStatus?: TeamMemberDtoMemberStatusEnum;
  groups?: GroupMembershipDto[];
  /** @uniqueItems true */
  memberRoles?: TeamMemberDtoMemberRolesEnum[];
  /** @format date-time */
  memberSince?: string;
  memberAllowedSites?: TeamMemberAllowedSitesDto;
  memberAccessType?: TeamMemberDtoMemberAccessTypeEnum;
  enabledMfa?: boolean;
}

export interface EnableSsoRequestDto {
  ssoProtocolType?: EnableSsoRequestDtoSsoProtocolTypeEnum;
}

export interface SsoAbstractResponseDtoUserSsoConfigurationDto {
  payloadType?: string;
  payload?: UserSsoConfigurationDto;
}

export interface UserSsoConfigurationDto {
  id?: string;
  registrationId?: string;
  domain?: string;
  protocol?: UserSsoConfigurationDtoProtocolEnum;
  isActive?: boolean;
  samlConfiguration?: UwSamlConfigurationDto;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateModified?: string;
  oAuthConfiguration?: UwUserOAuthConfigurationDto;
}

export interface UwSamlConfigurationDto {
  entityId?: string;
  metadataUriType?: UwSamlConfigurationDtoMetadataUriTypeEnum;
  metadataUrl?: string;
  identityProvider?: UwSamlConfigurationDtoIdentityProviderEnum;
  replyUrl?: string;
}

export interface UwUserOAuthConfigurationDto {
  issuerUrl?: string;
  identityProvider?: UwUserOAuthConfigurationDtoIdentityProviderEnum;
  clientIdSuffix?: string;
  clientSecretSuffix?: string;
  redirectUrl?: string;
  /** @uniqueItems true */
  scope?: string[];
}

export interface UpdateSamlPartDto {
  entityId?: string;
  metadataUriType?: UpdateSamlPartDtoMetadataUriTypeEnum;
  metadataUrl?: string;
  federationXmlBase64?: string;
  identityProvider?: UpdateSamlPartDtoIdentityProviderEnum;
  valid?: boolean;
}

export interface UpdateProtocolDto {
  protocol: UpdateProtocolDtoProtocolEnum;
}

export interface UpdateOAuthPartByUserDto {
  identityProvider: UpdateOAuthPartByUserDtoIdentityProviderEnum;
  clientId?: string;
  clientSecret?: string;
  issuerUri?: string;
}

export interface CreateServiceAccountEmailConfigurationDto {
  clientId?: EmailConfigurationClientIdentifier;
  rules: EmailConfigurationRule[];
}

export interface EmailConfigurationClientIdentifier {
  tag: EmailConfigurationClientIdentifierTagEnum;
  /** @minLength 1 */
  identifier?: string;
}

export interface EmailConfigurationRule {
  category: EmailConfigurationRuleCategoryEnum;
  to?: string;
  /** @uniqueItems true */
  bccs?: string[];
  /** @uniqueItems true */
  replyTos?: string[];
}

export interface EmailConfigurationDto {
  /** @minLength 1 */
  accountId?: string;
  /** @minLength 1 */
  email?: string;
  emailConfig: EmailConfigurationPayload;
}

export interface EmailConfigurationPayload {
  rules: EmailConfigurationRule[];
}

export interface SsoAbstractResponseDtoEmailConfigurationDto {
  payloadType?: string;
  payload?: EmailConfigurationDto;
}

export interface UpdateServiceAccountInfoDto {
  /** @minLength 1 */
  newSlug: string;
}

export interface PublicAccountInfoDto {
  accountId?: string;
  accountCode?: string;
  name?: string;
  slug?: string;
  /** @uniqueItems true */
  allowedLoginMechanisms?: PublicAccountInfoDtoAllowedLoginMechanismsEnum[];
  registrationOrigin?: PublicAccountInfoDtoRegistrationOriginEnum;
  /** @format date-time */
  updatedAt?: string;
  isSsoActive?: boolean;
  oauthRegistrationId?: string;
  accountDomain?: string;
  protocolType?: PublicAccountInfoDtoProtocolTypeEnum;
  settings?: ServiceAccountSettingsResponseDto;
}

export interface ServiceAccountSettingsResponseDto {
  isGTMDisabled?: boolean;
}

export interface SsoAbstractResponseDtoPublicAccountInfoDto {
  payloadType?: string;
  payload?: PublicAccountInfoDto;
}

export interface ApiKeyStateDto {
  state: ApiKeyStateDtoStateEnum;
}

export interface SsoAbstractResponseDtoApiKeyStateDto {
  payloadType?: string;
  payload?: ApiKeyStateDto;
}

export interface UpdateUserInfoDto {
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
}

export interface CreateServiceAccountEmailConfigurationSystemDto {
  /** @minLength 1 */
  accountId?: string;
  clientId?: EmailConfigurationClientIdentifier;
  rules: EmailConfigurationRule[];
}

export interface AuthorizationGrantType {
  value?: string;
}

export interface ClientAuthenticationMethod {
  value?: string;
}

export interface OAuthProviderConfigurationDto {
  providerType?: OAuthProviderConfigurationDtoProviderTypeEnum;
  issuerUri?: string;
  authorizationUri?: string;
  tokenUri?: string;
  userInfoUri?: string;
  userNameAttribute?: string;
  jwkSetUri?: string;
  springProvider?: OAuthProviderConfigurationDtoSpringProviderEnum;
}

export interface SsoAbstractResponseDtoSsoConfigurationDto {
  payloadType?: string;
  payload?: SsoConfigurationDto;
}

export interface SsoConfigurationDto {
  id?: string;
  configurationType?: SsoConfigurationDtoConfigurationTypeEnum;
  registrationId?: string;
  domain?: string;
  protocol?: SsoConfigurationDtoProtocolEnum;
  isActive?: boolean;
  samlConfiguration?: UwSamlConfigurationDto;
  /** @format int64 */
  dateCreated?: number;
  /** @format int64 */
  dateModified?: number;
  modifierInfo?: PublicAccountInfoDto;
  oAuthConfiguration?: UwOAuthConfigurationDto;
}

export interface UwOAuthConfigurationDto {
  providerConfiguration?: OAuthProviderConfigurationDto;
  identityProvider?: UwOAuthConfigurationDtoIdentityProviderEnum;
  clientIdSuffix?: string;
  clientSecretSuffix?: string;
  redirectUrl?: string;
  /** @uniqueItems true */
  scope?: string[];
  authorizationGrantType?: AuthorizationGrantType;
  clientAuthenticationMethod?: ClientAuthenticationMethod;
}

export interface UpdateOAuthPartDto {
  identityProvider: UpdateOAuthPartDtoIdentityProviderEnum;
  clientId?: string;
  clientSecret?: string;
  /** @uniqueItems true */
  scope?: string[];
  authorizationGrantType: AuthorizationGrantType;
  clientAuthenticationMethod: ClientAuthenticationMethod;
  providerType: UpdateOAuthPartDtoProviderTypeEnum;
  issuerUri?: string;
  authorizationUri?: string;
  tokenUri?: string;
  userInfoUri?: string;
  userNameAttribute?: string;
  jwkSetUri?: string;
  springProvider?: UpdateOAuthPartDtoSpringProviderEnum;
  valid?: boolean;
}

export interface EnableSsoAdminRequestDto {
  ssoProtocolType?: EnableSsoAdminRequestDtoSsoProtocolTypeEnum;
}

export interface UpdateRegistrationIdDto {
  registrationId?: string;
}

export interface SocialConfigurationDto {
  id?: string;
  registrationId?: string;
  identityProvider?: SocialConfigurationDtoIdentityProviderEnum;
  isActive?: boolean;
  clientIdSuffix?: string;
  clientSecretSuffix?: string;
  /** @uniqueItems true */
  scope?: string[];
  authorizationGrantType?: AuthorizationGrantType;
  clientAuthenticationMethod?: ClientAuthenticationMethod;
  providerType?: SocialConfigurationDtoProviderTypeEnum;
  issuerUri?: string;
  authorizationUri?: string;
  tokenUri?: string;
  userInfoUri?: string;
  userNameAttribute?: string;
  jwkSetUri?: string;
  redirectUrl?: string;
  springProvider?: SocialConfigurationDtoSpringProviderEnum;
  modifierInfo?: PublicAccountInfoDto;
}

export interface SsoAbstractResponseDtoSocialConfigurationDto {
  payloadType?: string;
  payload?: SocialConfigurationDto;
}

export interface NewUnitOwnerDto {
  /** @minLength 1 */
  firstName?: string;
  /** @minLength 1 */
  lastName?: string;
  /** @minLength 1 */
  email?: string;
}

export interface SsoAbstractResponseDtoUnitDto {
  payloadType?: string;
  payload?: UnitDto;
}

export interface TeamMembersDto {
  teamId?: string;
  teamName?: string;
  teamImageUri?: string;
  teamImageUrl?: string;
  mfaRequired?: boolean;
  teamMembers?: TeamMemberDto[];
}

export interface UnitDto {
  id?: string;
  accountCode?: string;
  slug?: string;
  name?: string;
  icon?: string;
  label?: string;
  teamMembers?: TeamMembersDto;
  /** @format int32 */
  teamMembersCount?: number;
  settings?: ServiceAccountSettingsResponseDto;
}

export interface UpdateUnitTeamMemberPermissionsDto {
  /** @minLength 1 */
  memberId?: string;
  /** @uniqueItems true */
  roles: UpdateUnitTeamMemberPermissionsDtoRolesEnum[];
}

export interface ResendTeamMemberInviteDto {
  /** @minLength 1 */
  resendToTeamMemberId?: string;
  resendInviteSiteUrl?: string;
  /** @uniqueItems true */
  resendInviteSiteUrls?: string[];
}

export interface InviteTeamMemberDto {
  /** @minLength 1 */
  newMemberFirstName?: string;
  newMemberLastName?: string;
  /** @minLength 1 */
  newMemberEmail?: string;
  newMemberSiteUrl?: string;
  noSitesFlow?: boolean;
  newMemberAllowedSites?: TeamMemberAllowedSitesDto;
  /** @uniqueItems true */
  newMemberSiteUrls?: string[];
  memberAccessType?: InviteTeamMemberDtoMemberAccessTypeEnum;
}

export interface UnitCreationDto {
  /** @minLength 1 */
  name?: string;
  icon?: string;
  label?: string;
}

export interface SwitchTeamDto {
  accountId?: string;
  accountCode?: string;
  slug?: string;
  /** @format int64 */
  siteId?: number;
}

export interface AuthTokenDto {
  accessToken?: string;
  refreshToken?: string;
  /** @uniqueItems true */
  userRoles?: AuthTokenDtoUserRolesEnum[];
}

export interface SsoAbstractResponseDtoAuthTokenDto {
  payloadType?: string;
  payload?: AuthTokenDto;
}

export interface UploadAccountPictureDto {
  /** @minLength 1 */
  filename?: string;
  /** @minLength 1 */
  content?: string;
}

export interface SsoAbstractResponseDtoUploadAccountPictureResponseDto {
  payloadType?: string;
  payload?: UploadAccountPictureResponseDto;
}

export interface UploadAccountPictureResponseDto {
  profilePictureImageUri?: string;
  profilePictureImageUrl?: string;
}

export interface UpdateMemberPermissionsDto {
  /** @minLength 1 */
  accountMemberId?: string;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  accountMemberRoles?: UpdateMemberPermissionsDtoAccountMemberRolesEnum[];
}

export interface UnsuspendTeamMemberDto {
  unsuspendTeamMemberId?: string;
}

export interface TeamMemberLoginDto {
  selectedTeamId?: string;
  selectedTeamSlug?: string;
}

export interface SuspendTeamMemberDto {
  suspendTeamMemberId?: string;
}

export interface ResendTeamInviteDto {
  resendInviteTeamMemberId?: string;
}

export interface RemoveTeamMemberDto {
  suspendTeamMemberId?: string;
}

export interface RejectTeamInviteDto {
  /** @minLength 1 */
  rejectingTeamMemberId?: string;
}

export interface InviteTeamMembersDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  inviteMemberEmails?: string[];
}

export interface InviteTeamMembersResponseDto {
  inviteMemberResults?: Record<string, SsoMessageResponseDto>;
}

export interface SsoAbstractResponseDtoInviteTeamMembersResponseDto {
  payloadType?: string;
  payload?: InviteTeamMembersResponseDto;
}

export interface CancelTeamInviteDto {
  /** @minLength 1 */
  cancelTeamMemberId?: string;
}

export interface AcceptTeamInviteDto {
  /** @minLength 1 */
  acceptingTeamMemberId?: string;
}

export interface Ca11YTeamMemberLoginDto {
  selectedTeamId?: string;
  selectedTeamSlug?: string;
}

export interface Ca11YRejectTeamInviteDto {
  /** @minLength 1 */
  rejectingTeamMemberId?: string;
}

export interface Ca11YAcceptTeamInviteDto {
  /** @minLength 1 */
  acceptingTeamMemberId?: string;
}

export interface UpdateIpWhitelistDto {
  /** @minItems 1 */
  whitelistedIps: string[];
}

export interface UploadUserPictureDto {
  /** @minLength 1 */
  filename?: string;
  /** @minLength 1 */
  content?: string;
}

export interface SsoAbstractResponseDtoUploadUserPictureResponseDto {
  payloadType?: string;
  payload?: UploadUserPictureResponseDto;
}

export interface UploadUserPictureResponseDto {
  msg?: string;
  aux?: string;
  profilePictureImageUri?: string;
  profilePictureImageUrl?: string;
}

export interface UpdateUserTimeZoneDto {
  /** @minLength 1 */
  updateTimeZoneName: string;
}

export interface RemoveUserPictureDto {
  removeUserPictureUrl?: string;
}

export interface ConfirmVirtualMfaDto {
  /** @minLength 1 */
  verificationCode?: string;
  /** @minLength 1 */
  deviceName?: string;
}

export interface ConfirmVirtualMfaResponseDto {
  recoveryCodes?: string[];
  authToken?: AuthTokenDto;
}

export interface SsoAbstractResponseDtoConfirmVirtualMfaResponseDto {
  payloadType?: string;
  payload?: ConfirmVirtualMfaResponseDto;
}

export interface ConfirmEmailMfaDto {
  /** @minLength 1 */
  verificationCode?: string;
}

export interface SsoAbstractResponseDtoSsoMfaActivationResultResponseDto {
  payloadType?: string;
  payload?: SsoMfaActivationResultResponseDto;
}

export interface SsoMfaActivationResultResponseDto {
  msg?: string;
  aux?: string;
  authToken?: AuthTokenDto;
}

export interface ChangePasswordDto {
  /** @minLength 1 */
  newPassword?: string;
  /** @minLength 1 */
  oldPassword?: string;
}

export interface ChangeEmailDto {
  /** @minLength 1 */
  changeEmailValue: string;
  /** @minLength 1 */
  changeEmailPassword: string;
}

export interface OrganizationCreationDto {
  organizationName: string;
  slug?: string;
  laTenantId?: string;
}

export interface Ca11YMembershipDto {
  myMembershipId?: string;
  myMembershipTeamOwnerAccountId?: string;
  myMembershipTeamOwnerEmail?: string;
  myMembershipTeamName?: string;
  myMembershipTeamOwnerPictureUrl?: string;
  myMembershipTeamOwnerPictureUri?: string;
  type?: Ca11YMembershipDtoTypeEnum;
  myMembershipTeamOwnerInfo?: PublicAccountInfoDto;
  /** @uniqueItems true */
  myMembershipPermissions?: Ca11YMembershipDtoMyMembershipPermissionsEnum[];
  /** @uniqueItems true */
  myMembershipRoles?: Ca11YMembershipDtoMyMembershipRolesEnum[];
  myMembershipStatus?: Ca11YMembershipDtoMyMembershipStatusEnum;
  myMembershipInvitationStatus?: Ca11YMembershipDtoMyMembershipInvitationStatusEnum;
  myMembershipIsSuspended?: boolean;
}

export interface SsoAbstractResponseDtoCa11YMembershipDto {
  payloadType?: string;
  payload?: Ca11YMembershipDto;
}

export interface Ca11YUnsuspendTeamMemberDto {
  unsuspendTeamMemberId?: string;
}

export interface Ca11YSuspendTeamMemberDto {
  suspendTeamMemberId?: string;
}

export interface Ca11YResendTeamInviteDto {
  resendInviteTeamMemberId?: string;
}

export interface Ca11YRemoveTeamMemberDto {
  removeTeamMemberId?: string;
}

export interface Ca11YInviteSingleTeamMemberDto {
  /** @minLength 1 */
  email?: string;
  firstName?: string;
  lastName?: string;
}

export interface Ca11YInviteManyTeamMembersDto {
  /**
   * @maxItems 1000
   * @minItems 0
   */
  members?: Ca11YInviteTeamMemberByEmailDto[];
}

export interface Ca11YInviteTeamMemberByEmailDto {
  /** @minLength 1 */
  email?: string;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  permissions?: Ca11YInviteTeamMemberByEmailDtoPermissionsEnum[];
}

export interface Ca11YCancelTeamInviteDto {
  /** @minLength 1 */
  cancelTeamMemberId?: string;
}

export interface JwtRestriction {
  roleName?: JwtRestrictionRoleNameEnum;
  /** @uniqueItems true */
  roleScope?: string[];
}

export interface NewApiKeyDto {
  sitesExpectedSize?: NewApiKeyDtoSitesExpectedSizeEnum;
  /** @minLength 1 */
  userComment?: string;
  /** @minItems 1 */
  restrictions?: JwtRestriction[];
}

export interface NewApiKeyResponseDto {
  createdApiKeyId?: string;
  createdForSsoUserId?: string;
}

export interface SsoAbstractResponseDtoNewApiKeyResponseDto {
  payloadType?: string;
  payload?: NewApiKeyResponseDto;
}

export interface CreateGroupDto {
  /** @minLength 1 */
  name?: string;
  /** @uniqueItems true */
  sites?: number[];
  allSites?: boolean;
  /** @uniqueItems true */
  members?: string[];
}

export interface ManageGroupDto {
  id?: string;
  name?: string;
  /** @uniqueItems true */
  sites?: number[];
  allSites?: boolean;
  members?: TeamMemberDto[];
  customRoles?: boolean;
  /** @uniqueItems true */
  groupRoles?: ManageGroupDtoGroupRolesEnum[];
}

export interface SsoAbstractResponseDtoManageGroupDto {
  payloadType?: string;
  payload?: ManageGroupDto;
}

export interface UpdateEmailSubscriptionsBySystemDto {
  /** @minLength 1 */
  subscriptionEmail?: string;
  subscriptionStatuses: Record<string, UpdateEmailSubscriptionsBySystemDtoSubscriptionStatusesEnum>;
}

export interface EmailSubscriptionStatusDto {
  subscriptionEmail?: string;
  userSubscribedForEmails?: Record<string, EmailSubscriptionStatusDtoUserSubscribedForEmailsEnum>;
}

export interface SsoAbstractResponseDtoEmailSubscriptionStatusDto {
  payloadType?: string;
  payload?: EmailSubscriptionStatusDto;
}

export interface PasswordResetEmailRequestDto {
  /** @minLength 1 */
  resetPasswordEmail?: string;
  resetCodeDeliveryType: PasswordResetEmailRequestDtoResetCodeDeliveryTypeEnum;
  redirectUrl?: string;
}

export interface LoginByEmailRequestDto {
  /** @minLength 1 */
  trustedUserEmail: string;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  trustedUserLoginScopes: LoginByEmailRequestDtoTrustedUserLoginScopesEnum[];
}

export interface AccessCodeDto {
  accessToken?: string;
  refreshToken?: string;
  /** @uniqueItems true */
  userRoles?: AccessCodeDtoUserRolesEnum[];
  authCode?: string;
}

export interface SsoAbstractResponseDtoAccessCodeDto {
  payloadType?: string;
  payload?: AccessCodeDto;
}

export interface LoginByAccountRequestDto {
  /** @minLength 1 */
  trustedAccountId: string;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  trustedUserLoginScopes: LoginByAccountRequestDtoTrustedUserLoginScopesEnum[];
}

export interface UserAccountRequestParamsDto {
  /** @minItems 1 */
  userAccountIds?: string[];
}

export interface SsoAbstractResponseDtoUserAccountListDto {
  payloadType?: string;
  payload?: UserAccountListDto;
}

export interface UserAccountDto {
  userAccountId?: string;
  userAccountCode?: string;
}

export interface UserAccountListDto {
  userAccountList?: UserAccountDto[];
}

export interface GoogleMeasurementRequestDto {
  /** @minItems 1 */
  googleMeasurementRequestEvents?: GoogleMeasurementRequestEventDto[];
  /** @minLength 1 */
  googleMeasurementRequestClientId?: string;
  googleMeasurementRequestDebug?: boolean;
}

export interface GoogleMeasurementRequestEventDto {
  /** @minLength 1 */
  googleMeasurementRequestEventName?: string;
  googleMeasurementRequestEventParams?: Record<string, string>;
}

export interface GoogleActivityDto {
  googleActivityValidationMessages?: GoogleValidationMessageDto[];
  googleActivityResult?: boolean;
}

export interface GoogleValidationMessageDto {
  validationMessageFieldPath?: string;
  validationMessageDescription?: string;
  validationMessageValidationCode?: string;
}

export interface SsoAbstractResponseDtoGoogleActivityDto {
  payloadType?: string;
  payload?: GoogleActivityDto;
}

export interface CheckEmailStatusDto {
  /** @minLength 1 */
  subscriptionEmail?: string;
}

export interface EmailStatusDto {
  subscriptionEmail?: string;
  userSubscribedForEmails?: Record<string, EmailStatusDtoUserSubscribedForEmailsEnum>;
  emailCredibilityStatus?: EmailStatusDtoEmailCredibilityStatusEnum;
}

export interface SsoAbstractResponseDtoEmailStatusDto {
  payloadType?: string;
  payload?: EmailStatusDto;
}

export interface EmailAttachmentDto {
  attachmentType?: EmailAttachmentDtoAttachmentTypeEnum;
  authType: string;
}

export type S3EmailAttachmentDto = EmailAttachmentDto & {
  contentId?: string;
};

export interface SendEmailAttachmentDto {
  filename?: string;
  content?: string;
}

export interface SendEmailDto {
  type?: SendEmailDtoTypeEnum;
  uwMessageId?: string;
  /** @minLength 1 */
  from?: string;
  /** @minLength 1 */
  to?: string;
  /** @minLength 1 */
  subject?: string;
  /** @uniqueItems true */
  replyTo?: string[];
  /** @minLength 1 */
  html?: string;
  /**
   * @deprecated
   * @uniqueItems true
   */
  cc?: string[];
  /** @uniqueItems true */
  bcc?: string[];
  attachments?: SendEmailAttachmentDto[];
  attachmentsV2?: (EmailAttachmentDto | S3EmailAttachmentDto)[];
  templateName?: string;
}

export interface AddAccountNotificationDto {
  /** @minLength 1 */
  newNotificationUserEmail?: string;
  newNotificationCtx: AddAccountNotificationDtoNewNotificationCtxEnum;
  /** @minLength 1 */
  newNotificationType?: string;
  newNotificationPayload?: Record<string, object>;
}

export interface IsTeamMemberDto {
  /** @minLength 1 */
  emailAddress?: string;
  teamScope: IsTeamMemberDtoTeamScopeEnum;
  teamAccountId?: string;
  teamAccountCode?: string;
}

export interface IsTeamMemberResponseDto {
  belongsToTheTeam?: boolean;
}

export interface SsoAbstractResponseDtoIsTeamMemberResponseDto {
  payloadType?: string;
  payload?: IsTeamMemberResponseDto;
}

export interface UpdateEmailSubscriptionDto {
  subscriptionType: UpdateEmailSubscriptionDtoSubscriptionTypeEnum;
  subscriptionStatus: UpdateEmailSubscriptionDtoSubscriptionStatusEnum;
}

export interface UpdateEmailSubscriptionsDto {
  /** @minLength 1 */
  subscriptionEmail?: string;
  /** @minLength 1 */
  subscriptionChecksum?: string;
  /** @minItems 1 */
  subscriptionsSettings: UpdateEmailSubscriptionDto[];
}

export interface ToggleEmailSubscriptionDto {
  /** @minLength 1 */
  subscriptionEmail?: string;
  /** @minLength 1 */
  subscriptionChecksum?: string;
  subscriptionType: ToggleEmailSubscriptionDtoSubscriptionTypeEnum;
  subscriptionStatus: ToggleEmailSubscriptionDtoSubscriptionStatusEnum;
}

export interface EmailSubscriptionDto {
  /** @minLength 1 */
  subscriptionEmail?: string;
  /** @minLength 1 */
  subscriptionChecksum?: string;
}

export interface UserSignupDto {
  /** @minLength 1 */
  signUpEmail?: string;
  /** @minLength 1 */
  signUpFirstName?: string;
  signUpLastName?: string;
  /** @minLength 1 */
  signUpPassword?: string;
  signUpPhone?: string;
  signUpLaTenantId?: string;
  userPicture?: UploadUserPictureDto;
  signUpSendWelcomeEmail?: boolean;
  signUpContactAccountType?: boolean;
  signUpOrigin?: UserSignupDtoSignUpOriginEnum;
  subscriptionStatuses?: Record<string, UserSignupDtoSubscriptionStatusesEnum>;
}

export interface SsoAbstractResponseDtoUserSignupResponseDto {
  payloadType?: string;
  payload?: UserSignupResponseDto;
}

export interface UserSignupResponseDto {
  signUpUserName?: string;
  signUpSsoUserId?: string;
  signUpLaTenantId?: string;
  signUpSsoAccountSlug?: string;
  signUpAccountCode?: string;
  providedUserName?: string;
  signUpUserPictureUri?: string;
  signUpUserPictureUrl?: string;
  signUpContactAccountType?: boolean;
  authToken?: AuthTokenDto;
}

export interface ResetPasswordDto {
  /** @minLength 1 */
  resetPasswordCode?: string;
  /** @minLength 1 */
  resetNewPassword?: string;
}

export interface ResetContactPasswordDto {
  /** @minLength 1 */
  resetPasswordCode?: string;
}

export interface UserExistsRequestDto {
  /** @minLength 1 */
  serviceUserEmail?: string;
}

export interface SsoDemoValidationDto {
  /** @minLength 1 */
  demoValidationString?: string;
}

export interface ExchangeLinkedinAuthCodeDto {
  /** @minLength 1 */
  linkedinAuthorizationCode?: string;
  /** @minLength 1 */
  accessTokenRedirectUrl?: string;
}

export interface LinkedinUserInfoDto {
  linkedinFirstName?: string;
  linkedinLastName?: string;
  linkedinImageUrl?: string;
  linkedinEmail?: string;
  linkedinAccessToken?: string;
}

export interface SsoAbstractResponseDtoLinkedinUserInfoDto {
  payloadType?: string;
  payload?: LinkedinUserInfoDto;
}

export interface NewApiKeyRequestDto {
  sitesExpectedSize?: NewApiKeyRequestDtoSitesExpectedSizeEnum;
  /** @minLength 1 */
  userComment?: string;
  /** @minItems 1 */
  restrictions?: JwtRestriction[];
  /** @minLength 1 */
  firstName?: string;
  /** @minLength 1 */
  lastName?: string;
  /** @minLength 1 */
  phoneNumber?: string;
  /** @minLength 1 */
  businessEmail?: string;
  /** @minLength 1 */
  companyName?: string;
  /** @minLength 1 */
  companyUrl?: string;
}

export interface UpdateEmailSubscriptionsByMasterDto {
  /** @minLength 1 */
  subscriptionEmail?: string;
  subscriptionStatuses: Record<string, UpdateEmailSubscriptionsByMasterDtoSubscriptionStatusesEnum>;
}

export interface SetPasswordByMasterDto {
  /** @minLength 1 */
  setPasswordForAccountId: string;
  /** @minLength 1 */
  setPasswordValue?: string;
}

export interface LoginAsRequestDto {
  /** @minLength 1 */
  targetUserEmail?: string;
}

export interface AdminLoginAsAuthTokenDto {
  accessToken?: string;
  refreshToken?: string;
  /** @uniqueItems true */
  userRoles?: AdminLoginAsAuthTokenDtoUserRolesEnum[];
  uwSsoTmpAuthCode?: string;
}

export interface SsoAbstractResponseDtoAdminLoginAsAuthTokenDto {
  payloadType?: string;
  payload?: AdminLoginAsAuthTokenDto;
}

export interface LoginAsOrganizationRequestDto {
  /** @minLength 1 */
  targetAccountId?: string;
  ssoRequestOrigin: LoginAsOrganizationRequestDtoSsoRequestOriginEnum;
}

export interface GetEmailSubscriptionsByMasterDto {
  /** @minLength 1 */
  subscriptionEmail?: string;
}

export interface ChangeRoleByMasterDto {
  /** @minLength 1 */
  changeRoleForAccountId: string;
  changeRoleValue: ChangeRoleByMasterDtoChangeRoleValueEnum;
}

export interface EmailVerificationParamsDto {
  emailVerificationObligatory: EmailVerificationParamsDtoEmailVerificationObligatoryEnum;
}

export interface SocialConfigurationCreationDto {
  /** @minLength 1 */
  registrationId?: string;
  identityProvider: SocialConfigurationCreationDtoIdentityProviderEnum;
  clientId?: string;
  clientSecret?: string;
  /** @uniqueItems true */
  scope?: string[];
  authorizationGrantType: AuthorizationGrantType;
  clientAuthenticationMethod: ClientAuthenticationMethod;
  providerType: SocialConfigurationCreationDtoProviderTypeEnum;
  issuerUri?: string;
  authorizationUri?: string;
  tokenUri?: string;
  userInfoUri?: string;
  userNameAttribute?: string;
  jwkSetUri?: string;
  springProvider?: SocialConfigurationCreationDtoSpringProviderEnum;
  valid?: boolean;
}

export interface ResetPasswordByMasterDto {
  /** @minLength 1 */
  resetPasswordForAccountId: string;
}

export interface UserRemoveDto {
  /** @minLength 1 */
  removeEmail?: string;
}

export interface SimulateUserDeletingDto {
  /** @minLength 1 */
  removalReason: string;
}

export interface ChangeEmailByAdminDto {
  /** @minLength 1 */
  changeEmailAccountId: string;
  /** @minLength 1 */
  changeEmailValue: string;
  /** @minLength 1 */
  changeFirstName: string;
  /** @minLength 1 */
  changeLastName: string;
}

export interface ServiceAccountSettingsDto {
  /** @minLength 1 */
  accountId?: string;
  isGTMDisabled?: boolean;
}

export interface UnitUpdateDto {
  newName?: string;
  newIcon?: string;
  newLabel?: string;
}

export interface ChangeDefaultTeamDto {
  /** @minLength 1 */
  newDefaultAccountId?: string;
  teamScope: ChangeDefaultTeamDtoTeamScopeEnum;
}

export interface UpdateGroupDto {
  newName?: string;
  /** @uniqueItems true */
  newRoles?: UpdateGroupDtoNewRolesEnum[];
}

export interface UpdateGroupSitesDto {
  /** @uniqueItems true */
  newSites?: number[];
  allSites?: boolean;
  /** @uniqueItems true */
  allAccountSites?: number[];
}

export interface UpdateGroupMembersDto {
  /** @uniqueItems true */
  newMembers: string[];
  /** @uniqueItems true */
  allAccountSites: number[];
}

export interface RemoveSitesFromAllGroupsDto {
  /** @minItems 1 */
  siteIdsToRemove?: number[];
}

export interface RemoveSiteForAllMembersDto {
  /** @format int64 */
  siteId: number;
}

export interface SsoAbstractResponseDtoUnitsDto {
  payloadType?: string;
  payload?: UnitsDto;
}

export interface UnitsDto {
  units?: UnitDto[];
}

export interface SsoAbstractResponseDtoTeamMembersDto {
  payloadType?: string;
  payload?: TeamMembersDto;
}

export interface MemberSearchResponseDto {
  foundMembers?: TeamMemberDto[];
}

export interface SsoAbstractResponseDtoMemberSearchResponseDto {
  payloadType?: string;
  payload?: MemberSearchResponseDto;
}

export interface MyMembershipDto {
  myMembershipId?: string;
  myMembershipTeamOwnerAccountId?: string;
  myMembershipTeamOwnerEmail?: string;
  myMembershipTeamName?: string;
  myMembershipTeamOwnerPictureUrl?: string;
  myMembershipTeamOwnerInfo?: PublicAccountInfoDto;
  /** @uniqueItems true */
  myMembershipPermissions?: MyMembershipDtoMyMembershipPermissionsEnum[];
  /** @uniqueItems true */
  myMembershipRoles?: MyMembershipDtoMyMembershipRolesEnum[];
  myMembershipStatus?: MyMembershipDtoMyMembershipStatusEnum;
  myMembershipInvitationStatus?: MyMembershipDtoMyMembershipInvitationStatusEnum;
  myMembershipIsSuspended?: boolean;
}

export interface MyMembershipsDto {
  participationTeams?: MyMembershipDto[];
}

export interface SsoAbstractResponseDtoMyMembershipsDto {
  payloadType?: string;
  payload?: MyMembershipsDto;
}

export interface MyTeamMemberDto {
  memberId?: string;
  userId?: string;
  userEmail?: string;
  memberFirstName?: string;
  memberLastName?: string;
  memberPicturePath?: string;
  /** @uniqueItems true */
  memberRoles?: MyTeamMemberDtoMemberRolesEnum[];
  memberStatus?: MyTeamMemberDtoMemberStatusEnum;
  invitationStatus?: MyTeamMemberDtoInvitationStatusEnum;
  memberIsSuspended?: boolean;
  lockedByEmailDomainMismatch?: boolean;
  /** @format date-time */
  dateCreated?: string;
  enabledMfa?: boolean;
}

export interface MyTeamMembersDto {
  teamName?: string;
  teamId?: string;
  teamImageUri?: string;
  teamImageUrl?: string;
  mfaRequired?: boolean;
  myTeamMembers?: MyTeamMemberDto[];
}

export interface SsoAbstractResponseDtoMyTeamMembersDto {
  payloadType?: string;
  payload?: MyTeamMembersDto;
}

export interface MyWidgetMembershipsDto {
  membershipTeams?: TeamMembershipDto[];
}

export interface SsoAbstractResponseDtoMyWidgetMembershipsDto {
  payloadType?: string;
  payload?: MyWidgetMembershipsDto;
}

export interface TeamMembershipDto {
  myMembershipId?: string;
  myMembershipTeamOwnerAccountId?: string;
  myMembershipTeamOwnerEmail?: string;
  myMembershipTeamName?: string;
  myMembershipTeamOwnerPictureUrl?: string;
  myMembershipTeamOwnerInfo?: PublicAccountInfoDto;
  memberAccessType?: TeamMembershipDtoMemberAccessTypeEnum;
  /** @format int32 */
  teamMembersCount?: number;
  /** @format int32 */
  teamGroupsCount?: number;
  parentAccountName?: string;
}

export interface Ca11YMembershipsDto {
  participationTeams?: Ca11YMembershipDto[];
}

export interface SsoAbstractResponseDtoCa11YMembershipsDto {
  payloadType?: string;
  payload?: Ca11YMembershipsDto;
}

export interface SsoAbstractResponseDtoTempAuthCodeDto {
  payloadType?: string;
  payload?: TempAuthCodeDto;
}

export interface TempAuthCodeDto {
  uwSsoTempAuthCode?: string;
}

export interface AccountNotificationDto {
  notificationId?: string;
  notificationCtx?: AccountNotificationDtoNotificationCtxEnum;
  notificationType?: string;
  notificationPayload?: Record<string, object>;
  /** @format date-time */
  notificationDate?: string;
}

export interface PendingAccountNotificationsDto {
  accountNotifications?: AccountNotificationDto[];
}

export interface SsoAbstractResponseDtoPendingAccountNotificationsDto {
  payloadType?: string;
  payload?: PendingAccountNotificationsDto;
}

export interface AccountEmailMfaInfo {
  emailMfaEmailAddress?: string;
}

export interface AccountMfaInfoDto {
  enabledVirtualMfa?: AccountVirtualMfaInfo;
  enabledEmailMfa?: AccountEmailMfaInfo;
}

export interface AccountVirtualMfaInfo {
  virtualMfaDeviceName?: string;
}

export interface SsoAbstractResponseDtoAccountMfaInfoDto {
  payloadType?: string;
  payload?: AccountMfaInfoDto;
}

export interface InitializeVirtualMfaResponseDto {
  qrCodeBase64?: string;
}

export interface SsoAbstractResponseDtoInitializeVirtualMfaResponseDto {
  payloadType?: string;
  payload?: InitializeVirtualMfaResponseDto;
}

export interface SsoAbstractResponseDtoSsoServiceUserInfoDto {
  payloadType?: string;
  payload?: SsoServiceUserInfoDto;
}

export interface SsoServiceUserInfoDto {
  userId?: string;
  userEmail?: string;
  accountCode?: string;
  userFirstName?: string;
  userLastName?: string;
  accountName?: string;
  slug?: string;
  userPhone?: string;
  userType?: SsoServiceUserInfoDtoUserTypeEnum;
  /** @uniqueItems true */
  userRoles?: SsoServiceUserInfoDtoUserRolesEnum[];
  /** @format date-time */
  userCreatedOn?: string;
  /** @format date-time */
  userUpdatedOn?: string;
  profilePictureImageUri?: string;
  profilePictureImageUrl?: string;
  hasStrictLoginIps?: boolean;
  whitelistedIps?: string[];
  enabledVirtualMfa?: boolean;
  enabledEmailMfa?: boolean;
  credibilityStatus?: SsoServiceUserInfoDtoCredibilityStatusEnum;
  isSsoActive?: boolean;
  accountDomain?: string;
  /** @uniqueItems true */
  allowedLoginMechanisms?: SsoServiceUserInfoDtoAllowedLoginMechanismsEnum[];
  oauthRegistrationId?: string;
  protocolType?: SsoServiceUserInfoDtoProtocolTypeEnum;
  emailVerificationStatus?: SsoServiceUserInfoDtoEmailVerificationStatusEnum;
  registrationType?: SsoServiceUserInfoDtoRegistrationTypeEnum;
  registrationOrigin?: SsoServiceUserInfoDtoRegistrationOriginEnum;
  defaultCa11yOrganizationId?: string;
}

export interface Ca11YTeamMemberDto {
  memberId?: string;
  userId?: string;
  userEmail?: string;
  memberFirstName?: string;
  memberLastName?: string;
  memberPicturePath?: string;
  /** @uniqueItems true */
  memberRoles?: Ca11YTeamMemberDtoMemberRolesEnum[];
  memberStatus?: Ca11YTeamMemberDtoMemberStatusEnum;
  invitationStatus?: Ca11YTeamMemberDtoInvitationStatusEnum;
  memberIsSuspended?: boolean;
  lockedByEmailDomainMismatch?: boolean;
  /** @format date-time */
  dateCreated?: string;
  enabledMfa?: boolean;
}

export interface Ca11YTeamMembersDto {
  teamName?: string;
  teamId?: string;
  teamImageUri?: string;
  teamImageUrl?: string;
  mfaRequired?: boolean;
  myTeamMembers?: Ca11YTeamMemberDto[];
}

export interface SsoAbstractResponseDtoCa11YTeamMembersDto {
  payloadType?: string;
  payload?: Ca11YTeamMembersDto;
}

export interface ExtendedJWTUserDetailsDto {
  /** @format uuid */
  sessionID?: string;
  ssoUserId?: string;
  accountCode?: string;
  userType?: ExtendedJwtUserDetailsDtoUserTypeEnum;
  username?: string;
  firstName?: string;
  lastName?: string;
  targetSsoUserId?: string;
  targetAccountCode?: string;
  targetAccountSlug?: string;
  authenticatedUserId?: string;
  /** @uniqueItems true */
  targetAccounts?: TargetAccountRecord[];
  hasExtendedToken?: boolean;
  /** @uniqueItems true */
  loginScopes?: ExtendedJwtUserDetailsDtoLoginScopesEnum[];
  loginType?: ExtendedJwtUserDetailsDtoLoginTypeEnum;
  loginMechanism?: ExtendedJwtUserDetailsDtoLoginMechanismEnum;
  /** @uniqueItems true */
  authorities?: JWTGrantedAuthority[];
  /** @uniqueItems true */
  restrictions?: JwtRestriction[];
  enabledMfa?: boolean;
  checksum?: string;
}

export interface JWTGrantedAuthority {
  authority?: string;
}

export interface SsoAbstractResponseDtoExtendedJWTUserDetailsDto {
  payloadType?: string;
  payload?: ExtendedJWTUserDetailsDto;
}

export interface TargetAccountRecord {
  targetSsoUserId?: string;
  targetAccountCode?: string;
  targetAccountSlug?: string;
  /** @uniqueItems true */
  restrictions?: JwtRestriction[];
  requiredMfa?: boolean;
  allowedAllSites?: boolean;
}

export interface ApiKeyUserResponseDto {
  id?: string;
  secretKey?: string;
  companyName?: string;
  email?: string;
  phoneNumber?: string;
  status?: ApiKeyUserResponseDtoStatusEnum;
  state?: ApiKeyUserResponseDtoStateEnum;
  sitesExpectedSize?: ApiKeyUserResponseDtoSitesExpectedSizeEnum;
  userComment?: string;
  restrictions?: JwtRestriction[];
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateLastUsed?: string;
}

export interface ApiKeysForUserDto {
  apiKeys?: ApiKeyUserResponseDto[];
}

export interface SsoAbstractResponseDtoApiKeysForUserDto {
  payloadType?: string;
  payload?: ApiKeysForUserDto;
}

export interface ManageGroupsDto {
  groups?: ManageGroupDto[];
}

export interface SsoAbstractResponseDtoManageGroupsDto {
  payloadType?: string;
  payload?: ManageGroupsDto;
}

export interface ScannerGrantedMemberDto {
  memberId?: string;
  teamId?: string;
  ownerUserId?: string;
  memberUserId?: string;
  /** @uniqueItems true */
  memberRoles?: ScannerGrantedMemberDtoMemberRolesEnum[];
  memberStatus?: ScannerGrantedMemberDtoMemberStatusEnum;
  suspendedMember?: boolean;
  invitationStatus?: ScannerGrantedMemberDtoInvitationStatusEnum;
  /** @format date-time */
  dateCreated?: string;
}

export interface SsoAbstractResponseDtoScannerGrantedMemberDto {
  payloadType?: string;
  payload?: ScannerGrantedMemberDto;
}

export interface ScannerTeamMembersResponseDto {
  grantedMembers?: ScannerGrantedMemberDto[];
}

export interface SsoAbstractResponseDtoScannerTeamMembersResponseDto {
  payloadType?: string;
  payload?: ScannerTeamMembersResponseDto;
}

export interface Ca11YGrantedMemberDto {
  memberId?: string;
  teamId?: string;
  ownerUserId?: string;
  memberUserId?: string;
  /** @uniqueItems true */
  memberRoles?: Ca11YGrantedMemberDtoMemberRolesEnum[];
  memberStatus?: Ca11YGrantedMemberDtoMemberStatusEnum;
  suspendedMember?: boolean;
  invitationStatus?: Ca11YGrantedMemberDtoInvitationStatusEnum;
  /** @format date-time */
  dateCreated?: string;
}

export interface SsoAbstractResponseDtoCa11YGrantedMemberDto {
  payloadType?: string;
  payload?: Ca11YGrantedMemberDto;
}

export interface Ca11YTeamMembersResponseDto {
  grantedMembers?: Ca11YGrantedMemberDto[];
}

export interface SsoAbstractResponseDtoCa11YTeamMembersResponseDto {
  payloadType?: string;
  payload?: Ca11YTeamMembersResponseDto;
}

export interface ServiceUserSystemInfoDto {
  accountId?: string;
  accountSlug?: string;
  accountCode?: string;
  accountName?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  /** @format date-time */
  registeredAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  lastLoginAt?: string;
  contactAccountType?: boolean;
  registrationOrigin?: ServiceUserSystemInfoDtoRegistrationOriginEnum;
}

export interface SsoAbstractResponseDtoServiceUserSystemInfoDto {
  payloadType?: string;
  payload?: ServiceUserSystemInfoDto;
}

export interface AboutMe {
  handle?: string;
  bio?: string;
  avatar?: string;
}

export interface Avatar {
  url?: string;
  type?: string;
}

export interface Category {
  sector?: string;
  industryGroup?: string;
  industry?: string;
  subIndustry?: string;
  sicCode?: string;
  naicsCode?: string;
}

export interface ClearbitEnrichedDto {
  email?: string;
  companyInfo?: Company;
  personInfo?: Person;
  ssoInfo?: SsoInfo;
  enrichmentStatus?: ClearbitEnrichedDtoEnrichmentStatusEnum;
  errorMsg?: string;
}

export interface Company {
  id?: string;
  name?: string;
  legalName?: string;
  domain?: string;
  domainAliases?: string[];
  site?: Site;
  category?: Category;
  tags?: string[];
  description?: string;
  /** @format int32 */
  foundedYear?: number;
  location?: string;
  timeZone?: string;
  /** @format int64 */
  utcOffset?: number;
  geo?: Geo;
  logo?: string;
  facebook?: Facebook;
  linkedin?: LinkedIn;
  twitter?: Twitter;
  crunchbase?: Crunchbase;
  emailProvider?: boolean;
  type?: string;
  ticker?: string;
  identifiers?: Identifiers;
  phone?: string;
  metrics?: Metrics;
  indexedAt?: string;
  tech?: string[];
  techCategories?: string[];
  parent?: Parent;
  ultimateParent?: UltimateParent;
}

export interface Crunchbase {
  handle?: string;
}

export interface Employment {
  name?: string;
  title?: string;
  domain?: string;
  role?: string;
  subRole?: string;
  seniority?: string;
}

export interface Facebook {
  handle?: string;
}

export interface Geo {
  city?: string;
  state?: string;
  stateCode?: string;
  country?: string;
  countryCode?: string;
  /** @format double */
  lat?: number;
  /** @format double */
  lng?: number;
}

export interface Github {
  handle?: string;
  /** @format int64 */
  id?: number;
  avatar?: string;
  company?: string;
  blog?: string;
  /** @format int64 */
  followers?: number;
  /** @format int64 */
  following?: number;
}

export interface GooglePlus {
  handle?: string;
}

export interface Gravatar {
  handle?: string;
  urls?: Url[];
  avatar?: string;
  avatars?: Avatar[];
}

export interface Identifiers {
  usEIN?: string;
}

export interface LinkedIn {
  handle?: string;
}

export interface Metrics {
  /** @format int64 */
  alexaUsRank?: number;
  /** @format int64 */
  alexaGlobalRank?: number;
  trafficRank?: string;
  /** @format int64 */
  employees?: number;
  employeesRange?: string;
  /** @format int64 */
  marketCap?: number;
  /** @format int64 */
  raised?: number;
  /** @format int64 */
  annualRevenue?: number;
  estimatedAnnualRevenue?: string;
  /** @format int64 */
  fiscalYearEnd?: number;
}

export interface Name {
  fullName?: string;
  givenName?: string;
  familyName?: string;
}

export interface Parent {
  domain?: string;
}

export interface Person {
  id?: string;
  name?: Name;
  email?: string;
  location?: string;
  timeZone?: string;
  /** @format int64 */
  utcOffset?: number;
  geo?: Geo;
  site?: string;
  avatar?: string;
  bio?: string;
  employment?: Employment;
  facebook?: Facebook;
  github?: Github;
  twitter?: Twitter;
  linkedin?: LinkedIn;
  gravatar?: Gravatar;
  fuzzy?: boolean;
  emailProvider?: boolean;
  indexedAt?: string;
  phone?: string;
  inactiveAt?: string;
  aboutme?: AboutMe;
  gender?: string;
  googleplus?: GooglePlus;
}

export interface Site {
  title?: string;
  h1?: string;
  metaDescription?: string;
  phoneNumbers?: string[];
  emailAddresses?: string[];
}

export interface SsoAbstractResponseDtoClearbitEnrichedDto {
  payloadType?: string;
  payload?: ClearbitEnrichedDto;
}

export interface SsoInfo {
  firstName?: string;
  lastName?: string;
  phone?: string;
}

export interface Twitter {
  handle?: string;
  id?: string;
  bio?: string;
  /** @format int64 */
  followers?: number;
  /** @format int64 */
  following?: number;
  /** @format int64 */
  statuses?: number;
  /** @format int64 */
  favorites?: number;
  location?: string;
  site?: string;
  avatar?: string;
}

export interface UltimateParent {
  domain?: string;
}

export interface Url {
  value?: string;
  title?: string;
}

export interface ServiceAccountSystemInfoDto {
  accountId?: string;
  accountCode?: string;
  name?: string;
  slug?: string;
  laTenantId?: string;
  /** @uniqueItems true */
  allowedLoginMechanisms?: ServiceAccountSystemInfoDtoAllowedLoginMechanismsEnum[];
  registrationOrigin?: ServiceAccountSystemInfoDtoRegistrationOriginEnum;
  /** @format date-time */
  updatedAt?: string;
  isSsoActive?: boolean;
  oauthRegistrationId?: string;
  accountDomain?: string;
  protocolType?: ServiceAccountSystemInfoDtoProtocolTypeEnum;
  settings?: ServiceAccountSettingsResponseDto;
}

export interface SsoAbstractResponseDtoServiceAccountSystemInfoDto {
  payloadType?: string;
  payload?: ServiceAccountSystemInfoDto;
}

export interface SsoAbstractResponseDtoString {
  payloadType?: string;
  payload?: string;
}

export interface RsaPublicKeyDto {
  rsaPublicKey?: string;
  rsaPublicKeyWithHeaders?: string;
}

export interface SsoAbstractResponseDtoRsaPublicKeyDto {
  payloadType?: string;
  payload?: RsaPublicKeyDto;
}

export interface PopupLoginResult {
  status?: PopupLoginResultStatusEnum;
  authCode?: string;
  state?: string;
  errorMessage?: string;
  responseErrorType?: string;
}

export interface SsoAbstractResponseDtoPopupLoginResult {
  payloadType?: string;
  payload?: PopupLoginResult;
}

export interface SsoAbstractResponseDtoSsoPlatformVersionDto {
  payloadType?: string;
  payload?: SsoPlatformVersionDto;
}

export interface SsoPlatformVersionDto {
  about?: string;
  version?: string;
  compatible?: boolean;
}

export interface AvailableTimeZonesDto {
  availableTimeZoneNames?: string[];
}

export interface SsoAbstractResponseDtoAvailableTimeZonesDto {
  payloadType?: string;
  payload?: AvailableTimeZonesDto;
}

export interface SsoAbstractResponseDtoSsoHealthDto {
  payloadType?: string;
  payload?: SsoHealthDto;
}

export interface SsoHealthDto {
  health?: string;
}

export interface SsoAbstractResponseDtoUserPasswordDto {
  payloadType?: string;
  payload?: UserPasswordDto;
}

export interface UserPasswordDto {
  generatedPassword?: string;
}

export interface SanctionedOriginResponseDto {
  isSanctionedCountry?: boolean;
}

export interface SsoAbstractResponseDtoSanctionedOriginResponseDto {
  payloadType?: string;
  payload?: SanctionedOriginResponseDto;
}

export interface IpCountryExchangeResultDto {
  ipAddress?: string;
  countryCode?: string;
  country?: string;
  city?: string;
}

export interface SsoAbstractResponseDtoIpCountryExchangeResultDto {
  payloadType?: string;
  payload?: IpCountryExchangeResultDto;
}

export interface AdminEmailVerificationInfoDto {
  emailVerificationStatus?: AdminEmailVerificationInfoDtoEmailVerificationStatusEnum;
  postponedEmailDtoList?: PostponedEmailDto[];
}

export interface PostponedEmailDto {
  type?: PostponedEmailDtoTypeEnum;
  templateName?: string;
  /** @format date-time */
  timeStamp?: string;
}

export interface SsoAbstractResponseDtoAdminEmailVerificationInfoDto {
  payloadType?: string;
  payload?: AdminEmailVerificationInfoDto;
}

export interface SsoAbstractResponseDtoUserEmailVerificationCodeInfoDto {
  payloadType?: string;
  payload?: UserEmailVerificationCodeInfoDto;
}

export interface UserEmailVerificationCodeInfoDto {
  userId?: string;
  email?: string;
  code?: string;
  verificationObligation?: UserEmailVerificationCodeInfoDtoVerificationObligationEnum;
  verificationReason?: UserEmailVerificationCodeInfoDtoVerificationReasonEnum;
}

export interface SsoAbstractResponseDtoSsoConfigurationsDto {
  payloadType?: string;
  payload?: SsoConfigurationsDto;
}

export interface SsoConfigurationsDto {
  configurations?: SsoConfigurationDto[];
}

export interface SocialConfigurationsDto {
  configurations?: SocialConfigurationDto[];
}

export interface SsoAbstractResponseDtoSocialConfigurationsDto {
  payloadType?: string;
  payload?: SocialConfigurationsDto;
}

export interface ServiceUserAdminInfoDto {
  accountId?: string;
  accountCode?: string;
  accountSlug?: string;
  accountName?: string;
  userMfaInfoDto?: UserSensitiveMfaInfoDto;
  userId?: string;
  email?: string;
  deletedByAdmin?: boolean;
  removalReason?: string;
}

export interface SsoAbstractResponseDtoServiceUserAdminInfoDto {
  payloadType?: string;
  payload?: ServiceUserAdminInfoDto;
}

export interface UserSensitiveMfaInfoDto {
  virtualMfaSecretKey?: string;
  emailMfaVerificationCode?: string;
}

export interface EmailNotificationAdmInfoDto {
  emailTemplateName?: string;
  sentEmailId?: string;
  emailMessageId?: string;
  emailEvents?: EmailNotificationEventAdmInfoDto[];
}

export interface EmailNotificationEventAdmInfoDto {
  emailEventType?: EmailNotificationEventAdmInfoDtoEmailEventTypeEnum;
  /** @format date-time */
  emailEventDate?: string;
}

export interface EmailNotificationsAdminResponseDto {
  emailNotifications?: EmailNotificationAdmInfoDto[];
}

export interface SsoAbstractResponseDtoEmailNotificationsAdminResponseDto {
  payloadType?: string;
  payload?: EmailNotificationsAdminResponseDto;
}

export interface SentEmailS3ItemDto {
  sentEmailId?: string;
  to?: string;
  subject?: string;
  body?: string;
  from?: string;
  /** @uniqueItems true */
  BCCs?: string[];
  /** @uniqueItems true */
  replyTo?: string[];
  attachmentNames?: string[];
  templateName?: string;
  /** @uniqueItems true */
  bccs?: string[];
}

export interface SsoAbstractResponseDtoSentEmailS3ItemDto {
  payloadType?: string;
  payload?: SentEmailS3ItemDto;
}

export interface ApiKeyAdminResponseDto {
  id?: string;
  secretKey?: string;
  companyName?: string;
  email?: string;
  phoneNumber?: string;
  status?: ApiKeyAdminResponseDtoStatusEnum;
  state?: ApiKeyAdminResponseDtoStateEnum;
  sitesExpectedSize?: ApiKeyAdminResponseDtoSitesExpectedSizeEnum;
  userComment?: string;
  restrictions?: JwtRestriction[];
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateLastUsed?: string;
}

export interface ApiKeysAdminDto {
  thisPageItems?: ApiKeyAdminResponseDto[];
  /** @format int64 */
  totalNumber?: number;
  moreAvailable?: boolean;
  /** @format int32 */
  lastPageIndex?: number;
  pageItemType?: string;
}

export interface SsoAbstractResponseDtoApiKeysAdminDto {
  payloadType?: string;
  payload?: ApiKeysAdminDto;
}

export interface SsoAbstractResponseDtoApiKeyAdminResponseDto {
  payloadType?: string;
  payload?: ApiKeyAdminResponseDto;
}

export interface ApiKeysForUserIdByAdminDto {
  apiKeys?: ApiKeyAdminResponseDto[];
}

export interface SsoAbstractResponseDtoApiKeysForUserIdByAdminDto {
  payloadType?: string;
  payload?: ApiKeysForUserIdByAdminDto;
}

export interface DeleteAccountNotificationsDto {
  /**
   * @maxItems 20
   * @minItems 0
   * @uniqueItems true
   */
  deleteAccNotificationIds?: string[];
}

export interface Ca11YUpdateMemberPermissionsDto {
  /** @minLength 1 */
  accountMemberId?: string;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  accountMemberRoles?: Ca11YUpdateMemberPermissionsDtoAccountMemberRolesEnum[];
}

export interface UserLoginDto {
  username?: any;
  password?: any;
  verificationCode?: any;
  mfaMethod?: UserLoginDtoMfaMethodEnum;
  accountId?: any;
  accountCode?: any;
  slug?: any;
  siteId?: any;
}

export enum TeamMemberDtoMemberStatusEnum {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
}

export enum TeamMemberDtoMemberRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum TeamMemberDtoMemberAccessTypeEnum {
  INVITED_AS_MEMBER = 'INVITED_AS_MEMBER',
  INVITED_AS_ADMIN = 'INVITED_AS_ADMIN',
  ORIGINAlOWNER = 'ORIGINAl_OWNER',
}

export enum EnableSsoRequestDtoSsoProtocolTypeEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
}

export enum UserSsoConfigurationDtoProtocolEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
}

export enum UwSamlConfigurationDtoMetadataUriTypeEnum {
  S3XML = 'S3_XML',
  URL = 'URL',
}

export enum UwSamlConfigurationDtoIdentityProviderEnum {
  AZURE = 'AZURE',
  OKTA = 'OKTA',
}

export enum UwUserOAuthConfigurationDtoIdentityProviderEnum {
  OKTA = 'OKTA',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  IDAPTIVE = 'IDAPTIVE',
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  PINGONE = 'PINGONE',
  F5APM = 'F5_APM',
}

export enum UpdateSamlPartDtoMetadataUriTypeEnum {
  S3XML = 'S3_XML',
  URL = 'URL',
}

export enum UpdateSamlPartDtoIdentityProviderEnum {
  AZURE = 'AZURE',
  OKTA = 'OKTA',
}

export enum UpdateProtocolDtoProtocolEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
}

export enum UpdateOAuthPartByUserDtoIdentityProviderEnum {
  OKTA = 'OKTA',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  IDAPTIVE = 'IDAPTIVE',
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  PINGONE = 'PINGONE',
  F5APM = 'F5_APM',
}

export enum EmailConfigurationClientIdentifierTagEnum {
  WIDGET_SITE = 'WIDGET_SITE',
  SCANNER_SITE = 'SCANNER_SITE',
}

export enum EmailConfigurationRuleCategoryEnum {
  GENERAL = 'GENERAL',
  BILLING = 'BILLING',
  REPORT_A_PROBLEM = 'REPORT_A_PROBLEM',
  SCANNING_REPORT = 'SCANNING_REPORT',
}

export enum PublicAccountInfoDtoAllowedLoginMechanismsEnum {
  CREDENTIALS_LOGIN = 'CREDENTIALS_LOGIN',
  SOCIAL_LOGIN = 'SOCIAL_LOGIN',
  SSO_LOGIN = 'SSO_LOGIN',
  API_KEY_LOGIN = 'API_KEY_LOGIN',
  SYSTEM_LOGIN = 'SYSTEM_LOGIN',
}

export enum PublicAccountInfoDtoRegistrationOriginEnum {
  CA11Y = 'CA11Y',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  UNKNOWN = 'UNKNOWN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  TEST = 'TEST',
  WIX = 'WIX',
  WORDPRESS = 'WORDPRESS',
  SHOPIFY = 'SHOPIFY',
  SITE_GENERAL = 'SITE_GENERAL',
  SITE = 'SITE',
  SSO = 'SSO',
  SITE_COMPANY_FORM = 'SITE_COMPANY_FORM',
  SITE_CONTACT_US_FORM = 'SITE_CONTACT_US_FORM',
  SITE_RESELLER_FORM = 'SITE_RESELLER_FORM',
  SITE_WEBINAR_FORM = 'SITE_WEBINAR_FORM',
  SITE_SUPPORT_FORM = 'SITE_SUPPORT_FORM',
  SITE_CODE = 'SITE_CODE',
  MANAGE_SIGN_UP = 'MANAGE_SIGN_UP',
  INSPECTOR_SIGN_UP = 'INSPECTOR_SIGN_UP',
  API_REQUEST = 'API_REQUEST',
  AUDIT = 'AUDIT',
  BIG_COMMERCE = 'BIG_COMMERCE',
  DUDA = 'DUDA',
  MAGENTO = 'MAGENTO',
  JOOMLA = 'JOOMLA',
  SEMRUSH = 'SEMRUSH',
  SQUAREUP = 'SQUAREUP',
  SHORTPOINT = 'SHORTPOINT',
  DRUPAL = 'DRUPAL',
  ENVATO = 'ENVATO',
  CAFE24 = 'CAFE24',
  WHITEPAPER_REQUEST = 'WHITEPAPER_REQUEST',
  FACEBOOK_LEAD_AD = 'FACEBOOK_LEAD_AD',
  HANDBOOK = 'HANDBOOK',
  VPAT = 'VPAT',
  PDF = 'PDF',
  WEBINAR_FEEDBACK = 'WEBINAR_FEEDBACK',
  AFFILIATE_SIGNUP_FORM = 'AFFILIATE_SIGNUP_FORM',
  AFFILIATE_MEETING = 'AFFILIATE_MEETING',
  WEBSUMMIT_SIGNUP = 'WEBSUMMIT_SIGNUP',
  COLLISION_SIGNUP = 'COLLISION_SIGNUP',
  STATEMENT_GENERATOR_FORM = 'STATEMENT_GENERATOR_FORM',
  DEMO_REQUEST_FORM = 'DEMO_REQUEST_FORM',
  DEMO_REQUEST_SHORT_FORM = 'DEMO_REQUEST_SHORT_FORM',
  CONTACT_AN_EXPERT = 'CONTACT_AN_EXPERT',
  MANAGED_ACCESSIBILITY = 'MANAGED_ACCESSIBILITY',
  MS_OFFICE_FORM = 'MS_OFFICE_FORM',
  ENTERPRISE_REQUEST = 'ENTERPRISE_REQUEST',
  SCANNER_SIGNUP = 'SCANNER_SIGNUP',
  TUNINGS_REQUEST = 'TUNINGS_REQUEST',
  CALENDLY = 'CALENDLY',
  LINKEDIN_OUTREACH = 'LINKEDIN_OUTREACH',
  LEGAL_SUPPORT = 'LEGAL_SUPPORT',
  SCANNER_SLG = 'SCANNER_SLG',
  ONBOARDING = 'ONBOARDING',
  UNIT_REGISTRATION = 'UNIT_REGISTRATION',
  DASHBOARD = 'DASHBOARD',
  LEVEL_ACCESS = 'LEVEL_ACCESS',
  HUSKY = 'HUSKY',
}

export enum PublicAccountInfoDtoProtocolTypeEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
}

export enum ApiKeyStateDtoStateEnum {
  ACTIVE = 'ACTIVE',
  NO_ACTIVE = 'NO_ACTIVE',
}

export enum OAuthProviderConfigurationDtoProviderTypeEnum {
  ISSUER_URI = 'ISSUER_URI',
  FULL_DEFINITION = 'FULL_DEFINITION',
  SPRING_DEFAULT_PROVIDER = 'SPRING_DEFAULT_PROVIDER',
}

export enum OAuthProviderConfigurationDtoSpringProviderEnum {
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  FACEBOOK = 'FACEBOOK',
  OKTA = 'OKTA',
}

export enum SsoConfigurationDtoConfigurationTypeEnum {
  SSO = 'SSO',
  SOCIAL = 'SOCIAL',
}

export enum SsoConfigurationDtoProtocolEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
}

export enum UwOAuthConfigurationDtoIdentityProviderEnum {
  OKTA = 'OKTA',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  IDAPTIVE = 'IDAPTIVE',
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  PINGONE = 'PINGONE',
  F5APM = 'F5_APM',
}

export enum UpdateOAuthPartDtoIdentityProviderEnum {
  OKTA = 'OKTA',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  IDAPTIVE = 'IDAPTIVE',
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  PINGONE = 'PINGONE',
  F5APM = 'F5_APM',
}

export enum UpdateOAuthPartDtoProviderTypeEnum {
  ISSUER_URI = 'ISSUER_URI',
  FULL_DEFINITION = 'FULL_DEFINITION',
  SPRING_DEFAULT_PROVIDER = 'SPRING_DEFAULT_PROVIDER',
}

export enum UpdateOAuthPartDtoSpringProviderEnum {
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  FACEBOOK = 'FACEBOOK',
  OKTA = 'OKTA',
}

export enum EnableSsoAdminRequestDtoSsoProtocolTypeEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
}

export enum SocialConfigurationDtoIdentityProviderEnum {
  OKTA = 'OKTA',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  IDAPTIVE = 'IDAPTIVE',
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  PINGONE = 'PINGONE',
  F5APM = 'F5_APM',
}

export enum SocialConfigurationDtoProviderTypeEnum {
  ISSUER_URI = 'ISSUER_URI',
  FULL_DEFINITION = 'FULL_DEFINITION',
  SPRING_DEFAULT_PROVIDER = 'SPRING_DEFAULT_PROVIDER',
}

export enum SocialConfigurationDtoSpringProviderEnum {
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  FACEBOOK = 'FACEBOOK',
  OKTA = 'OKTA',
}

export enum UpdateUnitTeamMemberPermissionsDtoRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum InviteTeamMemberDtoMemberAccessTypeEnum {
  INVITED_AS_MEMBER = 'INVITED_AS_MEMBER',
  INVITED_AS_ADMIN = 'INVITED_AS_ADMIN',
  ORIGINAlOWNER = 'ORIGINAl_OWNER',
}

export enum AuthTokenDtoUserRolesEnum {
  ROLE_MASTER = 'ROLE_MASTER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
}

export enum UpdateMemberPermissionsDtoAccountMemberRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum Ca11YMembershipDtoTypeEnum {
  PERSONAL = 'PERSONAL',
  DETACHED = 'DETACHED',
}

export enum Ca11YMembershipDtoMyMembershipPermissionsEnum {
  ACCOUNT_FULL_ACCESS = 'ACCOUNT_FULL_ACCESS',
  SCANNER_VIEW_SITES = 'SCANNER_VIEW_SITES',
  SCANNER_MANAGE_SITES = 'SCANNER_MANAGE_SITES',
  SCANNER_MANAGE_MEMBERS = 'SCANNER_MANAGE_MEMBERS',
  SCANNER_MANAGE_BILLING = 'SCANNER_MANAGE_BILLING',
  SCANNER_MANAGE_INTEGRATIONS = 'SCANNER_MANAGE_INTEGRATIONS',
  WIDGET_APPEARANCE_MANAGE = 'WIDGET_APPEARANCE_MANAGE',
  WIDGET_EXPOSED_API_ACCESS = 'WIDGET_EXPOSED_API_ACCESS',
  WIDGET_INVOICE_VIEW = 'WIDGET_INVOICE_VIEW',
  WIDGET_SUBSCRIPTIONS_VIEW = 'WIDGET_SUBSCRIPTIONS_VIEW',
  WIDGET_PAYMENT_METHOD_VIEW = 'WIDGET_PAYMENT_METHOD_VIEW',
  WIDGET_SUBSCRIPTIONS_MANAGE = 'WIDGET_SUBSCRIPTIONS_MANAGE',
  WIDGET_PAYMENT_METHOD_MANAGE = 'WIDGET_PAYMENT_METHOD_MANAGE',
  WIDGET_UPDATE_TUNING = 'WIDGET_UPDATE_TUNING',
  WIDGET_UPDATE_ADDON = 'WIDGET_UPDATE_ADDON',
  VIEW_SITES = 'VIEW_SITES',
  MANAGE_SITES = 'MANAGE_SITES',
  UNIT_WRITE = 'UNIT_WRITE',
  BILLING_VIEW = 'BILLING_VIEW',
  BILLING_WRITE = 'BILLING_WRITE',
  BILLING_SUBSCRIPTION = 'BILLING_SUBSCRIPTION',
  TEAM_VIEW = 'TEAM_VIEW',
  TEAM_WRITE = 'TEAM_WRITE',
  TEAM_INVITE_MEMBER = 'TEAM_INVITE_MEMBER',
  TEAM_DELETE_MEMBER = 'TEAM_DELETE_MEMBER',
  TEAM_UPDATE_PERMISSION = 'TEAM_UPDATE_PERMISSION',
  UPDATE_SITES_SCOPE = 'UPDATE_SITES_SCOPE',
  SCANS_VIEW = 'SCANS_VIEW',
  IMAGE_ALTS_VIEW = 'IMAGE_ALTS_VIEW',
  PDFS_VIEW = 'PDFS_VIEW',
  CA11YVIEWPROJECTS = 'CA11Y_VIEW_PROJECTS',
  CA11YMANAGEPROJECTS = 'CA11Y_MANAGE_PROJECTS',
  CA11YMANAGEMEMBERS = 'CA11Y_MANAGE_MEMBERS',
  CA11YMANAGEBILLING = 'CA11Y_MANAGE_BILLING',
  CA11YMANAGEINTEGRATIONS = 'CA11Y_MANAGE_INTEGRATIONS',
  LABS_CONFIG_READ = 'LABS_CONFIG_READ',
  LABS_CONFIG_WRITE = 'LABS_CONFIG_WRITE',
  LABS_CONFIG_PUBLISH = 'LABS_CONFIG_PUBLISH',
  LABS_CONFIG_DELETE = 'LABS_CONFIG_DELETE',
  WIDGET_VIEW_SITES = 'WIDGET_VIEW_SITES',
  WIDGET_MANAGE_SITES = 'WIDGET_MANAGE_SITES',
  ACCOUNT_INFO_WRITE = 'ACCOUNT_INFO_WRITE',
  SUPPORT_INFO_VIEW = 'SUPPORT_INFO_VIEW',
  REPORT_GENERATE = 'REPORT_GENERATE',
  LIVE_SITE_TRANSLATION_VIEW = 'LIVE_SITE_TRANSLATION_VIEW',
  ADDONS_VIEW = 'ADDONS_VIEW',
  A11YSERVICESVIEW = 'A11Y_SERVICES_VIEW',
  DEVELOPER_RESOURCES_VIEW = 'DEVELOPER_RESOURCES_VIEW',
  NOTIFICATIONS_VIEW = 'NOTIFICATIONS_VIEW',
  AGENCY_RESOURCES_VIEW = 'AGENCY_RESOURCES_VIEW',
  REG_TRACKER_VIEW = 'REG_TRACKER_VIEW',
}

export enum Ca11YMembershipDtoMyMembershipRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum Ca11YMembershipDtoMyMembershipStatusEnum {
  OWNER = 'OWNER',
  ACTIVE_MEMBER = 'ACTIVE_MEMBER',
  NON_ACTIVE_MEMBER = 'NON_ACTIVE_MEMBER',
}

export enum Ca11YMembershipDtoMyMembershipInvitationStatusEnum {
  INVITATION_SENT = 'INVITATION_SENT',
  INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
  INVITATION_REJECTED = 'INVITATION_REJECTED',
  INVITATION_WITHDRAWN = 'INVITATION_WITHDRAWN',
}

export enum Ca11YInviteTeamMemberByEmailDtoPermissionsEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum JwtRestrictionRoleNameEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum NewApiKeyDtoSitesExpectedSizeEnum {
  EXPECTEDSIZESITES110 = 'EXPECTED_SIZE_SITES_1_10',
  EXPECTEDSIZESITES10100 = 'EXPECTED_SIZE_SITES_10_100',
  EXPECTEDSIZESITES1001000 = 'EXPECTED_SIZE_SITES_100_1000',
  EXPECTEDSIZESITES1000PLUS = 'EXPECTED_SIZE_SITES_1000_PLUS',
}

export enum ManageGroupDtoGroupRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum UpdateEmailSubscriptionsBySystemDtoSubscriptionStatusesEnum {
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum EmailSubscriptionStatusDtoUserSubscribedForEmailsEnum {
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum PasswordResetEmailRequestDtoResetCodeDeliveryTypeEnum {
  LINK = 'LINK',
  CODE = 'CODE',
  NONE = 'NONE',
}

export enum LoginByEmailRequestDtoTrustedUserLoginScopesEnum {
  SCANNER_SCOPE = 'SCANNER_SCOPE',
  WIDGET_SCOPE = 'WIDGET_SCOPE',
  CA11YSCOPE = 'CA11Y_SCOPE',
}

export enum AccessCodeDtoUserRolesEnum {
  ROLE_MASTER = 'ROLE_MASTER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
}

export enum LoginByAccountRequestDtoTrustedUserLoginScopesEnum {
  SCANNER_SCOPE = 'SCANNER_SCOPE',
  WIDGET_SCOPE = 'WIDGET_SCOPE',
  CA11YSCOPE = 'CA11Y_SCOPE',
}

export enum EmailStatusDtoUserSubscribedForEmailsEnum {
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum EmailStatusDtoEmailCredibilityStatusEnum {
  EMAIL_CREDIBLE = 'EMAIL_CREDIBLE',
  EMAIL_UNCREDIBLE = 'EMAIL_UNCREDIBLE',
}

export enum EmailAttachmentDtoAttachmentTypeEnum {
  INLINE_ATTACHMENT = 'INLINE_ATTACHMENT',
  S3ATTACHMENT = 'S3_ATTACHMENT',
}

export enum SendEmailDtoTypeEnum {
  MANDATORY = 'MANDATORY',
  TRANSACTIONAL = 'TRANSACTIONAL',
  MARKETING = 'MARKETING',
  DEVELOPER_NOTIFICATION = 'DEVELOPER_NOTIFICATION',
  ADMIN_NOTIFICATION = 'ADMIN_NOTIFICATION',
  PROMO = 'PROMO',
  OPERATIONAL = 'OPERATIONAL',
}

export enum AddAccountNotificationDtoNewNotificationCtxEnum {
  TEST = 'TEST',
  SCAN = 'SCAN',
  CA11Y = 'CA11Y',
}

export enum IsTeamMemberDtoTeamScopeEnum {
  WIDGET_MANAGE_TEAM = 'WIDGET_MANAGE_TEAM',
  SCANNER_TEAM = 'SCANNER_TEAM',
  CA11YTEAM = 'CA11Y_TEAM',
}

export enum UpdateEmailSubscriptionDtoSubscriptionTypeEnum {
  MANDATORY = 'MANDATORY',
  TRANSACTIONAL = 'TRANSACTIONAL',
  MARKETING = 'MARKETING',
  DEVELOPER_NOTIFICATION = 'DEVELOPER_NOTIFICATION',
  ADMIN_NOTIFICATION = 'ADMIN_NOTIFICATION',
  PROMO = 'PROMO',
  OPERATIONAL = 'OPERATIONAL',
}

export enum UpdateEmailSubscriptionDtoSubscriptionStatusEnum {
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum ToggleEmailSubscriptionDtoSubscriptionTypeEnum {
  MANDATORY = 'MANDATORY',
  TRANSACTIONAL = 'TRANSACTIONAL',
  MARKETING = 'MARKETING',
  DEVELOPER_NOTIFICATION = 'DEVELOPER_NOTIFICATION',
  ADMIN_NOTIFICATION = 'ADMIN_NOTIFICATION',
  PROMO = 'PROMO',
  OPERATIONAL = 'OPERATIONAL',
}

export enum ToggleEmailSubscriptionDtoSubscriptionStatusEnum {
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum UserSignupDtoSignUpOriginEnum {
  CA11Y = 'CA11Y',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  UNKNOWN = 'UNKNOWN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  TEST = 'TEST',
  WIX = 'WIX',
  WORDPRESS = 'WORDPRESS',
  SHOPIFY = 'SHOPIFY',
  SITE_GENERAL = 'SITE_GENERAL',
  SITE = 'SITE',
  SSO = 'SSO',
  SITE_COMPANY_FORM = 'SITE_COMPANY_FORM',
  SITE_CONTACT_US_FORM = 'SITE_CONTACT_US_FORM',
  SITE_RESELLER_FORM = 'SITE_RESELLER_FORM',
  SITE_WEBINAR_FORM = 'SITE_WEBINAR_FORM',
  SITE_SUPPORT_FORM = 'SITE_SUPPORT_FORM',
  SITE_CODE = 'SITE_CODE',
  MANAGE_SIGN_UP = 'MANAGE_SIGN_UP',
  INSPECTOR_SIGN_UP = 'INSPECTOR_SIGN_UP',
  API_REQUEST = 'API_REQUEST',
  AUDIT = 'AUDIT',
  BIG_COMMERCE = 'BIG_COMMERCE',
  DUDA = 'DUDA',
  MAGENTO = 'MAGENTO',
  JOOMLA = 'JOOMLA',
  SEMRUSH = 'SEMRUSH',
  SQUAREUP = 'SQUAREUP',
  SHORTPOINT = 'SHORTPOINT',
  DRUPAL = 'DRUPAL',
  ENVATO = 'ENVATO',
  CAFE24 = 'CAFE24',
  WHITEPAPER_REQUEST = 'WHITEPAPER_REQUEST',
  FACEBOOK_LEAD_AD = 'FACEBOOK_LEAD_AD',
  HANDBOOK = 'HANDBOOK',
  VPAT = 'VPAT',
  PDF = 'PDF',
  WEBINAR_FEEDBACK = 'WEBINAR_FEEDBACK',
  AFFILIATE_SIGNUP_FORM = 'AFFILIATE_SIGNUP_FORM',
  AFFILIATE_MEETING = 'AFFILIATE_MEETING',
  WEBSUMMIT_SIGNUP = 'WEBSUMMIT_SIGNUP',
  COLLISION_SIGNUP = 'COLLISION_SIGNUP',
  STATEMENT_GENERATOR_FORM = 'STATEMENT_GENERATOR_FORM',
  DEMO_REQUEST_FORM = 'DEMO_REQUEST_FORM',
  DEMO_REQUEST_SHORT_FORM = 'DEMO_REQUEST_SHORT_FORM',
  CONTACT_AN_EXPERT = 'CONTACT_AN_EXPERT',
  MANAGED_ACCESSIBILITY = 'MANAGED_ACCESSIBILITY',
  MS_OFFICE_FORM = 'MS_OFFICE_FORM',
  ENTERPRISE_REQUEST = 'ENTERPRISE_REQUEST',
  SCANNER_SIGNUP = 'SCANNER_SIGNUP',
  TUNINGS_REQUEST = 'TUNINGS_REQUEST',
  CALENDLY = 'CALENDLY',
  LINKEDIN_OUTREACH = 'LINKEDIN_OUTREACH',
  LEGAL_SUPPORT = 'LEGAL_SUPPORT',
  SCANNER_SLG = 'SCANNER_SLG',
  ONBOARDING = 'ONBOARDING',
  UNIT_REGISTRATION = 'UNIT_REGISTRATION',
  DASHBOARD = 'DASHBOARD',
  LEVEL_ACCESS = 'LEVEL_ACCESS',
  HUSKY = 'HUSKY',
}

export enum UserSignupDtoSubscriptionStatusesEnum {
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum NewApiKeyRequestDtoSitesExpectedSizeEnum {
  EXPECTEDSIZESITES110 = 'EXPECTED_SIZE_SITES_1_10',
  EXPECTEDSIZESITES10100 = 'EXPECTED_SIZE_SITES_10_100',
  EXPECTEDSIZESITES1001000 = 'EXPECTED_SIZE_SITES_100_1000',
  EXPECTEDSIZESITES1000PLUS = 'EXPECTED_SIZE_SITES_1000_PLUS',
}

export enum UpdateEmailSubscriptionsByMasterDtoSubscriptionStatusesEnum {
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum AdminLoginAsAuthTokenDtoUserRolesEnum {
  ROLE_MASTER = 'ROLE_MASTER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
}

export enum LoginAsOrganizationRequestDtoSsoRequestOriginEnum {
  WIDGET_ORIGIN = 'WIDGET_ORIGIN',
  SCANNER_ORIGIN = 'SCANNER_ORIGIN',
  CA11YORIGIN = 'CA11Y_ORIGIN',
  UNKNOWN_ORIGIN = 'UNKNOWN_ORIGIN',
}

export enum ChangeRoleByMasterDtoChangeRoleValueEnum {
  SITE_USER = 'SITE_USER',
  SITE_ADMIN = 'SITE_ADMIN',
  SITE_MASTER = 'SITE_MASTER',
}

export enum EmailVerificationParamsDtoEmailVerificationObligatoryEnum {
  MANDATORY_VERIFICATION = 'MANDATORY_VERIFICATION',
  OPTIONAL_VERIFICATION = 'OPTIONAL_VERIFICATION',
}

export enum SocialConfigurationCreationDtoIdentityProviderEnum {
  OKTA = 'OKTA',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  IDAPTIVE = 'IDAPTIVE',
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  PINGONE = 'PINGONE',
  F5APM = 'F5_APM',
}

export enum SocialConfigurationCreationDtoProviderTypeEnum {
  ISSUER_URI = 'ISSUER_URI',
  FULL_DEFINITION = 'FULL_DEFINITION',
  SPRING_DEFAULT_PROVIDER = 'SPRING_DEFAULT_PROVIDER',
}

export enum SocialConfigurationCreationDtoSpringProviderEnum {
  GOOGLE = 'GOOGLE',
  GITHUB = 'GITHUB',
  FACEBOOK = 'FACEBOOK',
  OKTA = 'OKTA',
}

export enum ChangeDefaultTeamDtoTeamScopeEnum {
  WIDGET_MANAGE_TEAM = 'WIDGET_MANAGE_TEAM',
  SCANNER_TEAM = 'SCANNER_TEAM',
  CA11YTEAM = 'CA11Y_TEAM',
}

export enum UpdateGroupDtoNewRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum MyMembershipDtoMyMembershipPermissionsEnum {
  ACCOUNT_FULL_ACCESS = 'ACCOUNT_FULL_ACCESS',
  SCANNER_VIEW_SITES = 'SCANNER_VIEW_SITES',
  SCANNER_MANAGE_SITES = 'SCANNER_MANAGE_SITES',
  SCANNER_MANAGE_MEMBERS = 'SCANNER_MANAGE_MEMBERS',
  SCANNER_MANAGE_BILLING = 'SCANNER_MANAGE_BILLING',
  SCANNER_MANAGE_INTEGRATIONS = 'SCANNER_MANAGE_INTEGRATIONS',
  WIDGET_APPEARANCE_MANAGE = 'WIDGET_APPEARANCE_MANAGE',
  WIDGET_EXPOSED_API_ACCESS = 'WIDGET_EXPOSED_API_ACCESS',
  WIDGET_INVOICE_VIEW = 'WIDGET_INVOICE_VIEW',
  WIDGET_SUBSCRIPTIONS_VIEW = 'WIDGET_SUBSCRIPTIONS_VIEW',
  WIDGET_PAYMENT_METHOD_VIEW = 'WIDGET_PAYMENT_METHOD_VIEW',
  WIDGET_SUBSCRIPTIONS_MANAGE = 'WIDGET_SUBSCRIPTIONS_MANAGE',
  WIDGET_PAYMENT_METHOD_MANAGE = 'WIDGET_PAYMENT_METHOD_MANAGE',
  WIDGET_UPDATE_TUNING = 'WIDGET_UPDATE_TUNING',
  WIDGET_UPDATE_ADDON = 'WIDGET_UPDATE_ADDON',
  VIEW_SITES = 'VIEW_SITES',
  MANAGE_SITES = 'MANAGE_SITES',
  UNIT_WRITE = 'UNIT_WRITE',
  BILLING_VIEW = 'BILLING_VIEW',
  BILLING_WRITE = 'BILLING_WRITE',
  BILLING_SUBSCRIPTION = 'BILLING_SUBSCRIPTION',
  TEAM_VIEW = 'TEAM_VIEW',
  TEAM_WRITE = 'TEAM_WRITE',
  TEAM_INVITE_MEMBER = 'TEAM_INVITE_MEMBER',
  TEAM_DELETE_MEMBER = 'TEAM_DELETE_MEMBER',
  TEAM_UPDATE_PERMISSION = 'TEAM_UPDATE_PERMISSION',
  UPDATE_SITES_SCOPE = 'UPDATE_SITES_SCOPE',
  SCANS_VIEW = 'SCANS_VIEW',
  IMAGE_ALTS_VIEW = 'IMAGE_ALTS_VIEW',
  PDFS_VIEW = 'PDFS_VIEW',
  CA11YVIEWPROJECTS = 'CA11Y_VIEW_PROJECTS',
  CA11YMANAGEPROJECTS = 'CA11Y_MANAGE_PROJECTS',
  CA11YMANAGEMEMBERS = 'CA11Y_MANAGE_MEMBERS',
  CA11YMANAGEBILLING = 'CA11Y_MANAGE_BILLING',
  CA11YMANAGEINTEGRATIONS = 'CA11Y_MANAGE_INTEGRATIONS',
  LABS_CONFIG_READ = 'LABS_CONFIG_READ',
  LABS_CONFIG_WRITE = 'LABS_CONFIG_WRITE',
  LABS_CONFIG_PUBLISH = 'LABS_CONFIG_PUBLISH',
  LABS_CONFIG_DELETE = 'LABS_CONFIG_DELETE',
  WIDGET_VIEW_SITES = 'WIDGET_VIEW_SITES',
  WIDGET_MANAGE_SITES = 'WIDGET_MANAGE_SITES',
  ACCOUNT_INFO_WRITE = 'ACCOUNT_INFO_WRITE',
  SUPPORT_INFO_VIEW = 'SUPPORT_INFO_VIEW',
  REPORT_GENERATE = 'REPORT_GENERATE',
  LIVE_SITE_TRANSLATION_VIEW = 'LIVE_SITE_TRANSLATION_VIEW',
  ADDONS_VIEW = 'ADDONS_VIEW',
  A11YSERVICESVIEW = 'A11Y_SERVICES_VIEW',
  DEVELOPER_RESOURCES_VIEW = 'DEVELOPER_RESOURCES_VIEW',
  NOTIFICATIONS_VIEW = 'NOTIFICATIONS_VIEW',
  AGENCY_RESOURCES_VIEW = 'AGENCY_RESOURCES_VIEW',
  REG_TRACKER_VIEW = 'REG_TRACKER_VIEW',
}

export enum MyMembershipDtoMyMembershipRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum MyMembershipDtoMyMembershipStatusEnum {
  OWNER = 'OWNER',
  ACTIVE_MEMBER = 'ACTIVE_MEMBER',
  NON_ACTIVE_MEMBER = 'NON_ACTIVE_MEMBER',
}

export enum MyMembershipDtoMyMembershipInvitationStatusEnum {
  INVITATION_SENT = 'INVITATION_SENT',
  INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
  INVITATION_REJECTED = 'INVITATION_REJECTED',
  INVITATION_WITHDRAWN = 'INVITATION_WITHDRAWN',
}

export enum MyTeamMemberDtoMemberRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum MyTeamMemberDtoMemberStatusEnum {
  OWNER = 'OWNER',
  ACTIVE_MEMBER = 'ACTIVE_MEMBER',
  NON_ACTIVE_MEMBER = 'NON_ACTIVE_MEMBER',
}

export enum MyTeamMemberDtoInvitationStatusEnum {
  INVITATION_SENT = 'INVITATION_SENT',
  INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
  INVITATION_REJECTED = 'INVITATION_REJECTED',
  INVITATION_WITHDRAWN = 'INVITATION_WITHDRAWN',
}

export enum TeamMembershipDtoMemberAccessTypeEnum {
  INVITED_AS_MEMBER = 'INVITED_AS_MEMBER',
  INVITED_AS_ADMIN = 'INVITED_AS_ADMIN',
  ORIGINAlOWNER = 'ORIGINAl_OWNER',
}

export enum AccountNotificationDtoNotificationCtxEnum {
  TEST = 'TEST',
  SCAN = 'SCAN',
  CA11Y = 'CA11Y',
}

export enum SsoServiceUserInfoDtoUserTypeEnum {
  SITE_USER = 'SITE_USER',
  SITE_ADMIN = 'SITE_ADMIN',
  SITE_MASTER = 'SITE_MASTER',
}

export enum SsoServiceUserInfoDtoUserRolesEnum {
  ROLE_MASTER = 'ROLE_MASTER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
}

export enum SsoServiceUserInfoDtoCredibilityStatusEnum {
  EMAIL_CREDIBLE = 'EMAIL_CREDIBLE',
  EMAIL_UNCREDIBLE = 'EMAIL_UNCREDIBLE',
}

export enum SsoServiceUserInfoDtoAllowedLoginMechanismsEnum {
  CREDENTIALS_LOGIN = 'CREDENTIALS_LOGIN',
  SOCIAL_LOGIN = 'SOCIAL_LOGIN',
  SSO_LOGIN = 'SSO_LOGIN',
  API_KEY_LOGIN = 'API_KEY_LOGIN',
  SYSTEM_LOGIN = 'SYSTEM_LOGIN',
}

export enum SsoServiceUserInfoDtoProtocolTypeEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
}

export enum SsoServiceUserInfoDtoEmailVerificationStatusEnum {
  MANDATORY_VERIFIED = 'MANDATORY_VERIFIED',
  MANDATORY_NOT_VERIFIED = 'MANDATORY_NOT_VERIFIED',
  OPTIONAL_VERIFIED = 'OPTIONAL_VERIFIED',
  OPTIONAL_NOT_VERIFIED = 'OPTIONAL_NOT_VERIFIED',
}

export enum SsoServiceUserInfoDtoRegistrationTypeEnum {
  USER_REGISTRATION = 'USER_REGISTRATION',
  MEMBER_INVITATION = 'MEMBER_INVITATION',
}

export enum SsoServiceUserInfoDtoRegistrationOriginEnum {
  CA11Y = 'CA11Y',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  UNKNOWN = 'UNKNOWN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  TEST = 'TEST',
  WIX = 'WIX',
  WORDPRESS = 'WORDPRESS',
  SHOPIFY = 'SHOPIFY',
  SITE_GENERAL = 'SITE_GENERAL',
  SITE = 'SITE',
  SSO = 'SSO',
  SITE_COMPANY_FORM = 'SITE_COMPANY_FORM',
  SITE_CONTACT_US_FORM = 'SITE_CONTACT_US_FORM',
  SITE_RESELLER_FORM = 'SITE_RESELLER_FORM',
  SITE_WEBINAR_FORM = 'SITE_WEBINAR_FORM',
  SITE_SUPPORT_FORM = 'SITE_SUPPORT_FORM',
  SITE_CODE = 'SITE_CODE',
  MANAGE_SIGN_UP = 'MANAGE_SIGN_UP',
  INSPECTOR_SIGN_UP = 'INSPECTOR_SIGN_UP',
  API_REQUEST = 'API_REQUEST',
  AUDIT = 'AUDIT',
  BIG_COMMERCE = 'BIG_COMMERCE',
  DUDA = 'DUDA',
  MAGENTO = 'MAGENTO',
  JOOMLA = 'JOOMLA',
  SEMRUSH = 'SEMRUSH',
  SQUAREUP = 'SQUAREUP',
  SHORTPOINT = 'SHORTPOINT',
  DRUPAL = 'DRUPAL',
  ENVATO = 'ENVATO',
  CAFE24 = 'CAFE24',
  WHITEPAPER_REQUEST = 'WHITEPAPER_REQUEST',
  FACEBOOK_LEAD_AD = 'FACEBOOK_LEAD_AD',
  HANDBOOK = 'HANDBOOK',
  VPAT = 'VPAT',
  PDF = 'PDF',
  WEBINAR_FEEDBACK = 'WEBINAR_FEEDBACK',
  AFFILIATE_SIGNUP_FORM = 'AFFILIATE_SIGNUP_FORM',
  AFFILIATE_MEETING = 'AFFILIATE_MEETING',
  WEBSUMMIT_SIGNUP = 'WEBSUMMIT_SIGNUP',
  COLLISION_SIGNUP = 'COLLISION_SIGNUP',
  STATEMENT_GENERATOR_FORM = 'STATEMENT_GENERATOR_FORM',
  DEMO_REQUEST_FORM = 'DEMO_REQUEST_FORM',
  DEMO_REQUEST_SHORT_FORM = 'DEMO_REQUEST_SHORT_FORM',
  CONTACT_AN_EXPERT = 'CONTACT_AN_EXPERT',
  MANAGED_ACCESSIBILITY = 'MANAGED_ACCESSIBILITY',
  MS_OFFICE_FORM = 'MS_OFFICE_FORM',
  ENTERPRISE_REQUEST = 'ENTERPRISE_REQUEST',
  SCANNER_SIGNUP = 'SCANNER_SIGNUP',
  TUNINGS_REQUEST = 'TUNINGS_REQUEST',
  CALENDLY = 'CALENDLY',
  LINKEDIN_OUTREACH = 'LINKEDIN_OUTREACH',
  LEGAL_SUPPORT = 'LEGAL_SUPPORT',
  SCANNER_SLG = 'SCANNER_SLG',
  ONBOARDING = 'ONBOARDING',
  UNIT_REGISTRATION = 'UNIT_REGISTRATION',
  DASHBOARD = 'DASHBOARD',
  LEVEL_ACCESS = 'LEVEL_ACCESS',
  HUSKY = 'HUSKY',
}

export enum Ca11YTeamMemberDtoMemberRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum Ca11YTeamMemberDtoMemberStatusEnum {
  OWNER = 'OWNER',
  ACTIVE_MEMBER = 'ACTIVE_MEMBER',
  NON_ACTIVE_MEMBER = 'NON_ACTIVE_MEMBER',
}

export enum Ca11YTeamMemberDtoInvitationStatusEnum {
  INVITATION_SENT = 'INVITATION_SENT',
  INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
  INVITATION_REJECTED = 'INVITATION_REJECTED',
  INVITATION_WITHDRAWN = 'INVITATION_WITHDRAWN',
}

export enum ExtendedJwtUserDetailsDtoUserTypeEnum {
  SITE_USER = 'SITE_USER',
  SITE_ADMIN = 'SITE_ADMIN',
  SITE_MASTER = 'SITE_MASTER',
}

export enum ExtendedJwtUserDetailsDtoLoginScopesEnum {
  SCANNER_SCOPE = 'SCANNER_SCOPE',
  WIDGET_SCOPE = 'WIDGET_SCOPE',
  CA11YSCOPE = 'CA11Y_SCOPE',
}

export enum ExtendedJwtUserDetailsDtoLoginTypeEnum {
  USER_LOGIN = 'USER_LOGIN',
  ADMIN_LOGIN_AS = 'ADMIN_LOGIN_AS',
  MEMBER_LOGIN_AS = 'MEMBER_LOGIN_AS',
}

export enum ExtendedJwtUserDetailsDtoLoginMechanismEnum {
  CREDENTIALS_LOGIN = 'CREDENTIALS_LOGIN',
  SOCIAL_LOGIN = 'SOCIAL_LOGIN',
  SSO_LOGIN = 'SSO_LOGIN',
  API_KEY_LOGIN = 'API_KEY_LOGIN',
  SYSTEM_LOGIN = 'SYSTEM_LOGIN',
}

export enum ApiKeyUserResponseDtoStatusEnum {
  APPROVED_KEY = 'APPROVED_KEY',
  REJECTED_KEY = 'REJECTED_KEY',
  PENDING_KEY = 'PENDING_KEY',
}

export enum ApiKeyUserResponseDtoStateEnum {
  ACTIVE = 'ACTIVE',
  NO_ACTIVE = 'NO_ACTIVE',
}

export enum ApiKeyUserResponseDtoSitesExpectedSizeEnum {
  EXPECTEDSIZESITES110 = 'EXPECTED_SIZE_SITES_1_10',
  EXPECTEDSIZESITES10100 = 'EXPECTED_SIZE_SITES_10_100',
  EXPECTEDSIZESITES1001000 = 'EXPECTED_SIZE_SITES_100_1000',
  EXPECTEDSIZESITES1000PLUS = 'EXPECTED_SIZE_SITES_1000_PLUS',
}

export enum ScannerGrantedMemberDtoMemberRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum ScannerGrantedMemberDtoMemberStatusEnum {
  OWNER = 'OWNER',
  ACTIVE_MEMBER = 'ACTIVE_MEMBER',
  NON_ACTIVE_MEMBER = 'NON_ACTIVE_MEMBER',
}

export enum ScannerGrantedMemberDtoInvitationStatusEnum {
  INVITATION_SENT = 'INVITATION_SENT',
  INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
  INVITATION_REJECTED = 'INVITATION_REJECTED',
  INVITATION_WITHDRAWN = 'INVITATION_WITHDRAWN',
}

export enum Ca11YGrantedMemberDtoMemberRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum Ca11YGrantedMemberDtoMemberStatusEnum {
  OWNER = 'OWNER',
  ACTIVE_MEMBER = 'ACTIVE_MEMBER',
  NON_ACTIVE_MEMBER = 'NON_ACTIVE_MEMBER',
}

export enum Ca11YGrantedMemberDtoInvitationStatusEnum {
  INVITATION_SENT = 'INVITATION_SENT',
  INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
  INVITATION_REJECTED = 'INVITATION_REJECTED',
  INVITATION_WITHDRAWN = 'INVITATION_WITHDRAWN',
}

export enum ServiceUserSystemInfoDtoRegistrationOriginEnum {
  CA11Y = 'CA11Y',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  UNKNOWN = 'UNKNOWN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  TEST = 'TEST',
  WIX = 'WIX',
  WORDPRESS = 'WORDPRESS',
  SHOPIFY = 'SHOPIFY',
  SITE_GENERAL = 'SITE_GENERAL',
  SITE = 'SITE',
  SSO = 'SSO',
  SITE_COMPANY_FORM = 'SITE_COMPANY_FORM',
  SITE_CONTACT_US_FORM = 'SITE_CONTACT_US_FORM',
  SITE_RESELLER_FORM = 'SITE_RESELLER_FORM',
  SITE_WEBINAR_FORM = 'SITE_WEBINAR_FORM',
  SITE_SUPPORT_FORM = 'SITE_SUPPORT_FORM',
  SITE_CODE = 'SITE_CODE',
  MANAGE_SIGN_UP = 'MANAGE_SIGN_UP',
  INSPECTOR_SIGN_UP = 'INSPECTOR_SIGN_UP',
  API_REQUEST = 'API_REQUEST',
  AUDIT = 'AUDIT',
  BIG_COMMERCE = 'BIG_COMMERCE',
  DUDA = 'DUDA',
  MAGENTO = 'MAGENTO',
  JOOMLA = 'JOOMLA',
  SEMRUSH = 'SEMRUSH',
  SQUAREUP = 'SQUAREUP',
  SHORTPOINT = 'SHORTPOINT',
  DRUPAL = 'DRUPAL',
  ENVATO = 'ENVATO',
  CAFE24 = 'CAFE24',
  WHITEPAPER_REQUEST = 'WHITEPAPER_REQUEST',
  FACEBOOK_LEAD_AD = 'FACEBOOK_LEAD_AD',
  HANDBOOK = 'HANDBOOK',
  VPAT = 'VPAT',
  PDF = 'PDF',
  WEBINAR_FEEDBACK = 'WEBINAR_FEEDBACK',
  AFFILIATE_SIGNUP_FORM = 'AFFILIATE_SIGNUP_FORM',
  AFFILIATE_MEETING = 'AFFILIATE_MEETING',
  WEBSUMMIT_SIGNUP = 'WEBSUMMIT_SIGNUP',
  COLLISION_SIGNUP = 'COLLISION_SIGNUP',
  STATEMENT_GENERATOR_FORM = 'STATEMENT_GENERATOR_FORM',
  DEMO_REQUEST_FORM = 'DEMO_REQUEST_FORM',
  DEMO_REQUEST_SHORT_FORM = 'DEMO_REQUEST_SHORT_FORM',
  CONTACT_AN_EXPERT = 'CONTACT_AN_EXPERT',
  MANAGED_ACCESSIBILITY = 'MANAGED_ACCESSIBILITY',
  MS_OFFICE_FORM = 'MS_OFFICE_FORM',
  ENTERPRISE_REQUEST = 'ENTERPRISE_REQUEST',
  SCANNER_SIGNUP = 'SCANNER_SIGNUP',
  TUNINGS_REQUEST = 'TUNINGS_REQUEST',
  CALENDLY = 'CALENDLY',
  LINKEDIN_OUTREACH = 'LINKEDIN_OUTREACH',
  LEGAL_SUPPORT = 'LEGAL_SUPPORT',
  SCANNER_SLG = 'SCANNER_SLG',
  ONBOARDING = 'ONBOARDING',
  UNIT_REGISTRATION = 'UNIT_REGISTRATION',
  DASHBOARD = 'DASHBOARD',
  LEVEL_ACCESS = 'LEVEL_ACCESS',
  HUSKY = 'HUSKY',
}

export enum ClearbitEnrichedDtoEnrichmentStatusEnum {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  NOT_FOUND = 'NOT_FOUND',
  FAILED = 'FAILED',
}

export enum ServiceAccountSystemInfoDtoAllowedLoginMechanismsEnum {
  CREDENTIALS_LOGIN = 'CREDENTIALS_LOGIN',
  SOCIAL_LOGIN = 'SOCIAL_LOGIN',
  SSO_LOGIN = 'SSO_LOGIN',
  API_KEY_LOGIN = 'API_KEY_LOGIN',
  SYSTEM_LOGIN = 'SYSTEM_LOGIN',
}

export enum ServiceAccountSystemInfoDtoRegistrationOriginEnum {
  CA11Y = 'CA11Y',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB',
  BITBUCKET = 'BITBUCKET',
  AZURE = 'AZURE',
  UNKNOWN = 'UNKNOWN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  TEST = 'TEST',
  WIX = 'WIX',
  WORDPRESS = 'WORDPRESS',
  SHOPIFY = 'SHOPIFY',
  SITE_GENERAL = 'SITE_GENERAL',
  SITE = 'SITE',
  SSO = 'SSO',
  SITE_COMPANY_FORM = 'SITE_COMPANY_FORM',
  SITE_CONTACT_US_FORM = 'SITE_CONTACT_US_FORM',
  SITE_RESELLER_FORM = 'SITE_RESELLER_FORM',
  SITE_WEBINAR_FORM = 'SITE_WEBINAR_FORM',
  SITE_SUPPORT_FORM = 'SITE_SUPPORT_FORM',
  SITE_CODE = 'SITE_CODE',
  MANAGE_SIGN_UP = 'MANAGE_SIGN_UP',
  INSPECTOR_SIGN_UP = 'INSPECTOR_SIGN_UP',
  API_REQUEST = 'API_REQUEST',
  AUDIT = 'AUDIT',
  BIG_COMMERCE = 'BIG_COMMERCE',
  DUDA = 'DUDA',
  MAGENTO = 'MAGENTO',
  JOOMLA = 'JOOMLA',
  SEMRUSH = 'SEMRUSH',
  SQUAREUP = 'SQUAREUP',
  SHORTPOINT = 'SHORTPOINT',
  DRUPAL = 'DRUPAL',
  ENVATO = 'ENVATO',
  CAFE24 = 'CAFE24',
  WHITEPAPER_REQUEST = 'WHITEPAPER_REQUEST',
  FACEBOOK_LEAD_AD = 'FACEBOOK_LEAD_AD',
  HANDBOOK = 'HANDBOOK',
  VPAT = 'VPAT',
  PDF = 'PDF',
  WEBINAR_FEEDBACK = 'WEBINAR_FEEDBACK',
  AFFILIATE_SIGNUP_FORM = 'AFFILIATE_SIGNUP_FORM',
  AFFILIATE_MEETING = 'AFFILIATE_MEETING',
  WEBSUMMIT_SIGNUP = 'WEBSUMMIT_SIGNUP',
  COLLISION_SIGNUP = 'COLLISION_SIGNUP',
  STATEMENT_GENERATOR_FORM = 'STATEMENT_GENERATOR_FORM',
  DEMO_REQUEST_FORM = 'DEMO_REQUEST_FORM',
  DEMO_REQUEST_SHORT_FORM = 'DEMO_REQUEST_SHORT_FORM',
  CONTACT_AN_EXPERT = 'CONTACT_AN_EXPERT',
  MANAGED_ACCESSIBILITY = 'MANAGED_ACCESSIBILITY',
  MS_OFFICE_FORM = 'MS_OFFICE_FORM',
  ENTERPRISE_REQUEST = 'ENTERPRISE_REQUEST',
  SCANNER_SIGNUP = 'SCANNER_SIGNUP',
  TUNINGS_REQUEST = 'TUNINGS_REQUEST',
  CALENDLY = 'CALENDLY',
  LINKEDIN_OUTREACH = 'LINKEDIN_OUTREACH',
  LEGAL_SUPPORT = 'LEGAL_SUPPORT',
  SCANNER_SLG = 'SCANNER_SLG',
  ONBOARDING = 'ONBOARDING',
  UNIT_REGISTRATION = 'UNIT_REGISTRATION',
  DASHBOARD = 'DASHBOARD',
  LEVEL_ACCESS = 'LEVEL_ACCESS',
  HUSKY = 'HUSKY',
}

export enum ServiceAccountSystemInfoDtoProtocolTypeEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
}

export enum PopupLoginResultStatusEnum {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export enum AdminEmailVerificationInfoDtoEmailVerificationStatusEnum {
  MANDATORY_VERIFIED = 'MANDATORY_VERIFIED',
  MANDATORY_NOT_VERIFIED = 'MANDATORY_NOT_VERIFIED',
  OPTIONAL_VERIFIED = 'OPTIONAL_VERIFIED',
  OPTIONAL_NOT_VERIFIED = 'OPTIONAL_NOT_VERIFIED',
}

export enum PostponedEmailDtoTypeEnum {
  MANDATORY = 'MANDATORY',
  TRANSACTIONAL = 'TRANSACTIONAL',
  MARKETING = 'MARKETING',
  DEVELOPER_NOTIFICATION = 'DEVELOPER_NOTIFICATION',
  ADMIN_NOTIFICATION = 'ADMIN_NOTIFICATION',
  PROMO = 'PROMO',
  OPERATIONAL = 'OPERATIONAL',
}

export enum UserEmailVerificationCodeInfoDtoVerificationObligationEnum {
  MANDATORY_VERIFICATION = 'MANDATORY_VERIFICATION',
  OPTIONAL_VERIFICATION = 'OPTIONAL_VERIFICATION',
}

export enum UserEmailVerificationCodeInfoDtoVerificationReasonEnum {
  ADMIN_REQUESTED_VERIFICATION = 'ADMIN_REQUESTED_VERIFICATION',
  USER_INITIATED_VERIFICATION = 'USER_INITIATED_VERIFICATION',
  NEW_USER_REGISTRATION_VERIFICATION = 'NEW_USER_REGISTRATION_VERIFICATION',
}

export enum EmailNotificationEventAdmInfoDtoEmailEventTypeEnum {
  Open = 'open',
  Processed = 'processed',
  Dropped = 'dropped',
  Deferred = 'deferred',
  Delivered = 'delivered',
  Click = 'click',
  GroupResubscribe = 'group_resubscribe',
  Bounce = 'bounce',
  Spamreport = 'spamreport',
  Unsubscribe = 'unsubscribe',
  GroupUnsubscribe = 'group_unsubscribe',
  Sendmail = 'sendmail',
}

export enum ApiKeyAdminResponseDtoStatusEnum {
  APPROVED_KEY = 'APPROVED_KEY',
  REJECTED_KEY = 'REJECTED_KEY',
  PENDING_KEY = 'PENDING_KEY',
}

export enum ApiKeyAdminResponseDtoStateEnum {
  ACTIVE = 'ACTIVE',
  NO_ACTIVE = 'NO_ACTIVE',
}

export enum ApiKeyAdminResponseDtoSitesExpectedSizeEnum {
  EXPECTEDSIZESITES110 = 'EXPECTED_SIZE_SITES_1_10',
  EXPECTEDSIZESITES10100 = 'EXPECTED_SIZE_SITES_10_100',
  EXPECTEDSIZESITES1001000 = 'EXPECTED_SIZE_SITES_100_1000',
  EXPECTEDSIZESITES1000PLUS = 'EXPECTED_SIZE_SITES_1000_PLUS',
}

export enum Ca11YUpdateMemberPermissionsDtoAccountMemberRolesEnum {
  ACCOUNT_OWNER = 'ACCOUNT_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  SITES_VIEWER = 'SITES_VIEWER',
  SITES_MANAGER = 'SITES_MANAGER',
  MEMBERS_MANAGER = 'MEMBERS_MANAGER',
  INTEGRATION_MANAGER = 'INTEGRATION_MANAGER',
  WIDGET_APPEARANCE_MANAGER = 'WIDGET_APPEARANCE_MANAGER',
  WIDGET_EXPOSED_API_CALLER = 'WIDGET_EXPOSED_API_CALLER',
  WIDGET_BILLING_VIEWER = 'WIDGET_BILLING_VIEWER',
  WIDGET_BILLING_MANAGER = 'WIDGET_BILLING_MANAGER',
  BILLING_MANAGER = 'BILLING_MANAGER',
  TEAM_AND_UNIT_MANAGER = 'TEAM_AND_UNIT_MANAGER',
  SITE_MANAGER = 'SITE_MANAGER',
  TEAM_MEMBER = 'TEAM_MEMBER',
  SCANS_MANAGER = 'SCANS_MANAGER',
  IMAGE_ALTS_MANAGER = 'IMAGE_ALTS_MANAGER',
  PDFS_MANAGER = 'PDFS_MANAGER',
  CA11YPROJECTSVIEWER = 'CA11Y_PROJECTS_VIEWER',
  CA11YPROJECTSMANAGER = 'CA11Y_PROJECTS_MANAGER',
  CA11YMEMBERSMANAGER = 'CA11Y_MEMBERS_MANAGER',
  CA11YBILLINGMANAGER = 'CA11Y_BILLING_MANAGER',
  CA11YINTEGRATIONMANAGER = 'CA11Y_INTEGRATION_MANAGER',
  LEVEL_ACCESS_MEMBER = 'LEVEL_ACCESS_MEMBER',
  LEVEL_ACCESS_MANAGER = 'LEVEL_ACCESS_MANAGER',
  LABS_DEVELOPER = 'LABS_DEVELOPER',
  LABS_OWNER = 'LABS_OWNER',
}

export enum UserLoginDtoMfaMethodEnum {
  VIRTUAL_MFA = 'VIRTUAL_MFA',
  EMAIL_MFA = 'EMAIL_MFA',
}

export type ErrorSystemData = SsoAbstractResponseDtoVoid;

export type ErrorSystem2Data = SsoAbstractResponseDtoVoid;

export type ErrorSystem1Data = SsoAbstractResponseDtoVoid;

export type ErrorSystem3Data = SsoAbstractResponseDtoVoid;

export type RateLimitErrorData = SsoAbstractResponseDtoVoid;

export type RateLimitError2Data = SsoAbstractResponseDtoVoid;

export type RateLimitError1Data = SsoAbstractResponseDtoVoid;

export type RateLimitError3Data = SsoAbstractResponseDtoVoid;

export type UploadUnitTeamPictureData = SsoAbstractResponseDtoUploadUnitTeamPictureResponseDto;

export type UpdateUnitNameData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SetAgencyMfaConfigurationData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SetAllowedMfaMethodsData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UnsetWidgetMemberRoleRoleAccountOwnerData = SsoAbstractResponseDtoTeamMemberDto;

export type SetWidgetMemberRoleAccountOwnerData = SsoAbstractResponseDtoTeamMemberDto;

export type GetFullSsoConfigurationData = SsoAbstractResponseDtoUserSsoConfigurationDto;

export type CreateSsoConfigurationData = SsoAbstractResponseDtoUserSsoConfigurationDto;

export type DeleteSsoConfigurationData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateSamlConfigurationData = SsoAbstractResponseDtoUserSsoConfigurationDto;

export type UpdateProtocolData = SsoAbstractResponseDtoUserSsoConfigurationDto;

export type UpdateOAuthSsoConfigurationData = SsoAbstractResponseDtoUserSsoConfigurationDto;

export type EnableSsoData = SsoAbstractResponseDtoUserSsoConfigurationDto;

export type DisableSsoData = SsoAbstractResponseDtoUserSsoConfigurationDto;

export interface FindEmailConfigurationParams {
  tag?: TagEnum;
  identifier?: string;
  category?: CategoryEnum;
}

export enum TagEnum {
  WIDGET_SITE = 'WIDGET_SITE',
  SCANNER_SITE = 'SCANNER_SITE',
}

export enum CategoryEnum {
  GENERAL = 'GENERAL',
  BILLING = 'BILLING',
  REPORT_A_PROBLEM = 'REPORT_A_PROBLEM',
  SCANNING_REPORT = 'SCANNING_REPORT',
}

export type FindEmailConfigurationData = SsoAbstractResponseDtoEmailConfigurationDto;

export enum FindEmailConfigurationParams1TagEnum {
  WIDGET_SITE = 'WIDGET_SITE',
  SCANNER_SITE = 'SCANNER_SITE',
}

export enum FindEmailConfigurationParams1CategoryEnum {
  GENERAL = 'GENERAL',
  BILLING = 'BILLING',
  REPORT_A_PROBLEM = 'REPORT_A_PROBLEM',
  SCANNING_REPORT = 'SCANNING_REPORT',
}

export type UpdateEmailConfigurationData = SsoAbstractResponseDtoEmailConfigurationDto;

export type CreateEmailConfigurationData = SsoAbstractResponseDtoEmailConfigurationDto;

export type UpdateServiceAccountInfoData = SsoAbstractResponseDtoPublicAccountInfoDto;

export type UpdateServiceAccountInfo1Data = SsoAbstractResponseDtoPublicAccountInfoDto;

export type UpdateApiKeyStateByUserData = SsoAbstractResponseDtoApiKeyStateDto;

export interface UpdateUserInfoBySystemParams {
  /** @default false */
  'update-display-names'?: boolean;
  accountId: string;
}

export type UpdateUserInfoBySystemData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateEmailConfigurationSystemData = SsoAbstractResponseDtoEmailConfigurationDto;

export type CreateEmailConfigurationSystemData = SsoAbstractResponseDtoEmailConfigurationDto;

export interface SendEmailMfaVerificationParams {
  email: string;
}

export type SendEmailMfaVerificationData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateSamlConfigurationByAdminData = SsoAbstractResponseDtoSsoConfigurationDto;

export type UpdateProtocolByAdminData = SsoAbstractResponseDtoSsoConfigurationDto;

export type UpdateOAuthSsoConfigurationByAdminData = SsoAbstractResponseDtoSsoConfigurationDto;

export type EnableSsoByAdminData = SsoAbstractResponseDtoSsoConfigurationDto;

export type DisableSsoByAdminData = SsoAbstractResponseDtoSsoConfigurationDto;

export type CreateSsoConfigurationByAdminData = SsoAbstractResponseDtoSsoConfigurationDto;

export type UpdateRegistrationIdByAdminData = SsoAbstractResponseDtoSocialConfigurationDto;

export type UpdateOAuthSocialConfigurationByAdminData = SsoAbstractResponseDtoSocialConfigurationDto;

export type EnableSocialByAdminData = SsoAbstractResponseDtoSocialConfigurationDto;

export type DisableSocialLoginByAdminData = SsoAbstractResponseDtoSocialConfigurationDto;

export type UpdateApiKeyStateByAdminData = SsoAbstractResponseDtoApiKeyStateDto;

export type PopulateUnitWithOwnerData = SsoAbstractResponseDtoUnitDto;

export type UpdateUnitMemberPermissionsData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ResendInviteToUnitMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type InviteUnitMemberData = SsoAbstractResponseDtoTeamMemberDto;

export type SetUnitMemberAllowedSitesData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type CreateAccountlessSubunitData = SsoAbstractResponseDtoUnitDto;

export type UpdateWidgetTeamNameData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SwitchWidgetTeamByMemberData = SsoAbstractResponseDtoAuthTokenDto;

export type UploadScannerTeamPictureData = SsoAbstractResponseDtoUploadAccountPictureResponseDto;

export type UpdateScannerMemberPermissionsData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateScannerTeamNameData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UnsuspendScannerMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SwitchScannerTeamByMemberData = SsoAbstractResponseDtoAuthTokenDto;

export type SuspendScannerMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ResendScannerInviteData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RemoveScannerTeamPictureData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RemoveScannerMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RejectScannerTeamInviteData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type InviteScannerMembersData = SsoAbstractResponseDtoInviteTeamMembersResponseDto;

export type CancelScannerInviteData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type AcceptScannerTeamInviteData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ResendInviteToWidgetMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type InviteNewWidgetMemberData = SsoAbstractResponseDtoTeamMemberDto;

export type LeaveCa11YOrganizationData = SsoAbstractResponseDtoAuthTokenDto;

export type SwitchCa11YTeamByMemberData = SsoAbstractResponseDtoAuthTokenDto;

export type RejectCa11YTeamInviteData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type AcceptCa11YTeamInviteData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SetWidgetMemberAllowedSitesData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SetIpWhitelistingData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type DisableIpWhitelistingData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UploadUserPictureData = SsoAbstractResponseDtoUploadUserPictureResponseDto;

export type UpdateUserTimeZoneData = SsoAbstractResponseDtoVoid;

export enum UpdateUserTimeZoneParamsAcceptEnum {
  ApplicationJson = 'application/json',
}

export type RemoveUserPictureData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type InitializeVirtualMfaData = SsoAbstractResponseDtoInitializeVirtualMfaResponseDto;

export type ConfirmVirtualMfaData = SsoAbstractResponseDtoConfirmVirtualMfaResponseDto;

export type DisableVirtualMfaData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type InitializeEmailMfaData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ConfirmEmailMfaData = SsoAbstractResponseDtoSsoMfaActivationResultResponseDto;

export type DisableEmailMfaData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ChangePasswordData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ChangeEmailByUserData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type CreateCa11YOrganizationData = SsoAbstractResponseDtoCa11YMembershipDto;

export type UploadOrganizationPictureData = SsoAbstractResponseDtoUploadAccountPictureResponseDto;

export type UpdateCa11YTeamNameData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UnsuspendCa11YMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SuspendCa11YMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ResendCa11YInviteData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RemoveCa11YMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type InviteSingleCa11YMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type InviteCa11YMembersData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type CancelCa11YInviteData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RemoveOrganizationPictureData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SendVerificationEmailByUserData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type GetApiKeysForUserData = SsoAbstractResponseDtoApiKeysForUserDto;

export type CreateNewApiKeyByUserData = SsoAbstractResponseDtoNewApiKeyResponseDto;

export type GetManageDashboardGroupsOfAccountData = SsoAbstractResponseDtoManageGroupsDto;

export type CreateManageDashboardGroupData = SsoAbstractResponseDtoManageGroupDto;

export type UpdateUnitMemberPermissionsBySystemData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type InviteUnitMemberBySystemData = SsoAbstractResponseDtoTeamMemberDto;

export type SetUnitMemberAllowedSitesBySystemData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateEmailPreferencesBySystemData = SsoAbstractResponseDtoEmailSubscriptionStatusDto;

export type SendPasswordResetData = SsoAbstractResponseDtoSsoMessageResponseDto;

export interface LoginWithEmailInTargetAccountBySystemParams {
  targetAccountIdentifier?: string;
}

export type LoginWithEmailInTargetAccountBySystemData = SsoAbstractResponseDtoAccessCodeDto;

export type LoginWithEmailBySystemData = SsoAbstractResponseDtoAccessCodeDto;

export type LoginIntoAccountBySystemData = SsoAbstractResponseDtoAccessCodeDto;

export type GetAccountCodesListData = SsoAbstractResponseDtoUserAccountListDto;

export type TrackActivityData = SsoAbstractResponseDtoGoogleActivityDto;

export type CheckEmailStatusBySystemData = SsoAbstractResponseDtoEmailStatusDto;

export type SendEmailBySystemData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type AddAccountNotificationBySystemData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type IsWidgetTeamByMemberData = SsoAbstractResponseDtoIsTeamMemberResponseDto;

export type UpdateSubscriptionData = SsoAbstractResponseDtoEmailSubscriptionStatusDto;

export type ToggleSubscriptionData = SsoAbstractResponseDtoEmailSubscriptionStatusDto;

export type CheckSubscriptionData = SsoAbstractResponseDtoEmailSubscriptionStatusDto;

export type SignupData = SsoAbstractResponseDtoUserSignupResponseDto;

export type ResetPasswordData = SsoAbstractResponseDtoAuthTokenDto;

export type ResetPassword1Data = SsoAbstractResponseDtoAuthTokenDto;

export type SendPasswordResetEmailData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ExistsData = SsoAbstractResponseDtoVoid;

export type ContactSignupData = SsoAbstractResponseDtoUserSignupResponseDto;

export type ErrorValidationData = SsoAbstractResponseDtoVoid;

export type GetLinkedInUserDetailsData = SsoAbstractResponseDtoLinkedinUserInfoDto;

export type VerifyEmailByCodeData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type CreateNewApiKeyByAnonData = SsoAbstractResponseDtoNewApiKeyResponseDto;

export type UpdateEmailPrefsByMasterData = SsoAbstractResponseDtoEmailSubscriptionStatusDto;

export type SetPasswordByMasterData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type LoginAsByMasterData = SsoAbstractResponseDtoAdminLoginAsAuthTokenDto;

export type LoginAsOrganizationByMasterData = SsoAbstractResponseDtoAdminLoginAsAuthTokenDto;

export type GetEmailPrefsByMasterData = SsoAbstractResponseDtoEmailSubscriptionStatusDto;

export type ChangeRoleByMasterData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RepublishAllAccountsData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SendVerificationEmailByAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type VerifyEmailByAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UnverifyEmailByAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SendAllPostponedEmailsByAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type GetEmailVerificationStatusByAdminData = SsoAbstractResponseDtoAdminEmailVerificationInfoDto;

export type SetEmailVerificationParamsData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type GetAllSocialRegistrationsInfoByAdminData = SsoAbstractResponseDtoSocialConfigurationsDto;

export type CreateSocialLoginConfigurationByAdminData = SsoAbstractResponseDtoSocialConfigurationDto;

export type ResetPasswordByAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RepublishUserByIdData = SsoAbstractResponseDtoSsoMessageResponseDto;

export interface RepublishAllUsersParams {
  /** @format int32 */
  limit?: number;
}

export type RepublishAllUsersData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RemoveUserData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SimulateUserDeletingByAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ChangeEmailByAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpsertAccountSettingsData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateApiKeyRejectData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateApiKeyApproveData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateUnitInfoData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateUnitInfo1Data = SsoAbstractResponseDtoSsoMessageResponseDto;

export type ChangeDefaultTeamData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type DeleteGroupData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateManageDashboardGroupGeneralInfoData = SsoAbstractResponseDtoManageGroupDto;

export type UpdateSitesOfManageDashboardGroupData = SsoAbstractResponseDtoManageGroupDto;

export type UpdateMembersOfManageDashboardGroupData = SsoAbstractResponseDtoManageGroupDto;

export type RemoveSitesFromAllAccountGroupsData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RemoveSiteFromAllTeamMembersBySystemData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type GetUnitInfoData = SsoAbstractResponseDtoUnitDto;

export type GetChildUnitsByParentIdData = SsoAbstractResponseDtoUnitsDto;

export type GetUnitMembersData = SsoAbstractResponseDtoTeamMembersDto;

export interface SearchUnitMembersParams {
  phrase: string;
  identifier: string;
}

export type SearchUnitMembersData = SsoAbstractResponseDtoMemberSearchResponseDto;

export type GetWidgetTeamMembersData = SsoAbstractResponseDtoTeamMembersDto;

export type GetScannerTeamMembershipsData = SsoAbstractResponseDtoMyMembershipsDto;

export type GetScannerTeamMembersData = SsoAbstractResponseDtoMyTeamMembersDto;

export type GetWidgetTeamMembershipsData = SsoAbstractResponseDtoMyWidgetMembershipsDto;

export type GetCa11YTeamMembershipsData = SsoAbstractResponseDtoCa11YMembershipsDto;

export type GetCa11YTeamMembershipData = SsoAbstractResponseDtoCa11YMembershipDto;

export interface GetTempAuthCodeParams {
  targetSsoUserId?: string;
  scope?: ScopeEnum;
}

export enum ScopeEnum {
  SCANNER_SCOPE = 'SCANNER_SCOPE',
  WIDGET_SCOPE = 'WIDGET_SCOPE',
  CA11YSCOPE = 'CA11Y_SCOPE',
}

export type GetTempAuthCodeData = SsoAbstractResponseDtoTempAuthCodeDto;

export enum GetTempAuthCodeParams1ScopeEnum {
  SCANNER_SCOPE = 'SCANNER_SCOPE',
  WIDGET_SCOPE = 'WIDGET_SCOPE',
  CA11YSCOPE = 'CA11Y_SCOPE',
}

export interface GetPendingNotificationsParams {
  accountNotificationCtx?: AccountNotificationCtxEnum;
}

export enum AccountNotificationCtxEnum {
  TEST = 'TEST',
  SCAN = 'SCAN',
  CA11Y = 'CA11Y',
}

export type GetPendingNotificationsData = SsoAbstractResponseDtoPendingAccountNotificationsDto;

export enum GetPendingNotificationsParams1AccountNotificationCtxEnum {
  TEST = 'TEST',
  SCAN = 'SCAN',
  CA11Y = 'CA11Y',
}

export type DeletePendingNotificationsData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type GetAccountMfaInfoData = SsoAbstractResponseDtoAccountMfaInfoDto;

export type GetUserInfoData = SsoAbstractResponseDtoSsoServiceUserInfoDto;

export type AuthCheckData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type GetCa11YTeamMembersData = SsoAbstractResponseDtoCa11YTeamMembersDto;

export type GetExtendedJwtUserDetailsData = SsoAbstractResponseDtoExtendedJWTUserDetailsDto;

export type GetAllActiveUserMembershipsData = SsoAbstractResponseDtoMyWidgetMembershipsDto;

export type GetUnitInfoBySystemData = SsoAbstractResponseDtoUnitDto;

export type FindScannerTeamMemberByIdBySystemData = SsoAbstractResponseDtoScannerGrantedMemberDto;

export interface GetScannerTeamMembersBySystemParams {
  activeOnly: boolean;
  accountId: string;
}

export type GetScannerTeamMembersBySystemData = SsoAbstractResponseDtoScannerTeamMembersResponseDto;

export type FindCa11YTeamMemberByIdBySystemData = SsoAbstractResponseDtoCa11YGrantedMemberDto;

export interface GetCa11YTeamMembersBySystemParams {
  activeOnly: boolean;
  accountId: string;
}

export type GetCa11YTeamMembersBySystemData = SsoAbstractResponseDtoCa11YTeamMembersResponseDto;

export type GetServiceUserInfoBySystemData = SsoAbstractResponseDtoServiceUserSystemInfoDto;

export interface GetUserInfoEnrichmentParams {
  email: string;
}

export type GetUserInfoEnrichmentData = SsoAbstractResponseDtoClearbitEnrichedDto;

export type GetServiceAccountInfoBySystemData = SsoAbstractResponseDtoServiceAccountSystemInfoDto;

export interface FindEmailConfigurationSystemParams {
  tag?: TagEnum1;
  identifier?: string;
  category?: CategoryEnum1;
  accountId: string;
}

export enum TagEnum1 {
  WIDGET_SITE = 'WIDGET_SITE',
  SCANNER_SITE = 'SCANNER_SITE',
}

export enum CategoryEnum1 {
  GENERAL = 'GENERAL',
  BILLING = 'BILLING',
  REPORT_A_PROBLEM = 'REPORT_A_PROBLEM',
  SCANNING_REPORT = 'SCANNING_REPORT',
}

export type FindEmailConfigurationSystemData = SsoAbstractResponseDtoEmailConfigurationDto;

export enum FindEmailConfigurationSystemParams1TagEnum {
  WIDGET_SITE = 'WIDGET_SITE',
  SCANNER_SITE = 'SCANNER_SITE',
}

export enum FindEmailConfigurationSystemParams1CategoryEnum {
  GENERAL = 'GENERAL',
  BILLING = 'BILLING',
  REPORT_A_PROBLEM = 'REPORT_A_PROBLEM',
  SCANNING_REPORT = 'SCANNING_REPORT',
}

export interface UpdateParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  skip?: number;
}

export type UpdateData = SsoAbstractResponseDtoString;

export interface GetPublicAccountInfoParams {
  accountId?: string;
  accountCode?: string;
  domain?: string;
  slug?: string;
}

export type GetPublicAccountInfoData = SsoAbstractResponseDtoPublicAccountInfoDto;

export type GetSamlRedirectUrlData = string;

export type GetRedirectUrlData = string;

export type GetRsaPublicKeyData = SsoAbstractResponseDtoRsaPublicKeyDto;

export interface PopupLoginResultParams {
  requestId?: string;
}

export type PopupLoginResultData = SsoAbstractResponseDtoPopupLoginResult;

export interface VersionParams {
  version?: string;
}

export type VersionData = SsoAbstractResponseDtoSsoPlatformVersionDto;

export type GetAvailableTimeZonesData = SsoAbstractResponseDtoAvailableTimeZonesDto;

export type TestS3Data = string[];

export type HelloWorldData = string[];

export type HealthData = SsoAbstractResponseDtoSsoHealthDto;

export type GetMyIpData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type GeneratePasswordData = SsoAbstractResponseDtoUserPasswordDto;

export type GetIsSanctionedOriginData = SsoAbstractResponseDtoSanctionedOriginResponseDto;

export interface GetCountryAndCityByIpParams {
  ip: string;
}

export type GetCountryAndCityByIpData = SsoAbstractResponseDtoIpCountryExchangeResultDto;

export type AuthCheckUnauthorizedData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type GetUserEmailVerificationCodeInfoData = SsoAbstractResponseDtoUserEmailVerificationCodeInfoDto;

export type GetAllSsoRegistrationsInfoByAdminData = SsoAbstractResponseDtoSsoConfigurationsDto;

export type GetFullSsoConfigurationByAdminData = SsoAbstractResponseDtoSsoConfigurationDto;

export type GetSocialRegistrationInfoByAdminData = SsoAbstractResponseDtoSocialConfigurationDto;

export type RestoreUserByAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type GetUserInfoByAdminData = SsoAbstractResponseDtoServiceUserAdminInfoDto;

export type GetUserEmailNotificationsByAdminData = SsoAbstractResponseDtoEmailNotificationsAdminResponseDto;

export type GetUserEmailNotificationByAdminData = SsoAbstractResponseDtoSentEmailS3ItemDto;

export type AuthCheckAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export interface GetAllApiKeysByAdminParams {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  perPage?: number;
  searchPhrase?: string;
  status?: StatusEnum;
}

export enum StatusEnum {
  APPROVED_KEY = 'APPROVED_KEY',
  REJECTED_KEY = 'REJECTED_KEY',
  PENDING_KEY = 'PENDING_KEY',
}

export type GetAllApiKeysByAdminData = SsoAbstractResponseDtoApiKeysAdminDto;

export enum GetAllApiKeysByAdminParams1StatusEnum {
  APPROVED_KEY = 'APPROVED_KEY',
  REJECTED_KEY = 'REJECTED_KEY',
  PENDING_KEY = 'PENDING_KEY',
}

export type GetApiKeyByAdminData = SsoAbstractResponseDtoApiKeyAdminResponseDto;

export type GetApiKeysForUserIdByAdminData = SsoAbstractResponseDtoApiKeysForUserIdByAdminDto;

export type DeleteExistingUnitMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type RemoveUnitTeamPictureData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type DeleteUnitData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type DeleteExistingWidgetMemberData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type DeleteOrganizationData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type DeleteApiKeyByUserData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type DeleteExistingUnitMemberBySystemData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type DeleteSsoConfigurationByAdminData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateCa11YMemberPermissionsData = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateCa11YMemberPermissions2Data = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateCa11YMemberPermissions1Data = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateCa11YMemberPermissions3Data = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateCa11YMemberPermissions6Data = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateCa11YMemberPermissions5Data = SsoAbstractResponseDtoSsoMessageResponseDto;

export type UpdateCa11YMemberPermissions4Data = SsoAbstractResponseDtoSsoMessageResponseDto;

export type SsoV0PublicServiceUserLoginCreateData = SsoAbstractResponseDtoAuthTokenDto;

export type SsoV0PublicServiceUserRefreshTokenListData = SsoAbstractResponseDtoAuthTokenDto;

export type SsoV0UserLoginOauthExchangeListData = SsoAbstractResponseDtoAuthTokenDto;

import type {AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({securityWorker, secure, format, ...axiosConfig}: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'http://uw.dev.levelaccess.io/api/sso',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? {'Content-Type': type} : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://uw.dev.levelaccess.io/api/sso
 */
export class SSOApiClient<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  platformRestController = {
    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name ErrorSystem
     * @request GET:/api/sso/v0/public/platform/error/runtime
     */
    errorSystem: (params: RequestParams = {}) =>
      this.request<ErrorSystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/error/runtime`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name ErrorSystem2
     * @request PUT:/api/sso/v0/public/platform/error/runtime
     */
    errorSystem2: (params: RequestParams = {}) =>
      this.request<ErrorSystem2Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/error/runtime`,
        method: 'PUT',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name ErrorSystem1
     * @request POST:/api/sso/v0/public/platform/error/runtime
     */
    errorSystem1: (params: RequestParams = {}) =>
      this.request<ErrorSystem1Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/error/runtime`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name ErrorSystem3
     * @request DELETE:/api/sso/v0/public/platform/error/runtime
     */
    errorSystem3: (params: RequestParams = {}) =>
      this.request<ErrorSystem3Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/error/runtime`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name RateLimitError
     * @request GET:/api/sso/v0/public/platform/error/rate-limit
     */
    rateLimitError: (params: RequestParams = {}) =>
      this.request<RateLimitErrorData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/error/rate-limit`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name RateLimitError2
     * @request PUT:/api/sso/v0/public/platform/error/rate-limit
     */
    rateLimitError2: (params: RequestParams = {}) =>
      this.request<RateLimitError2Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/error/rate-limit`,
        method: 'PUT',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name RateLimitError1
     * @request POST:/api/sso/v0/public/platform/error/rate-limit
     */
    rateLimitError1: (params: RequestParams = {}) =>
      this.request<RateLimitError1Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/error/rate-limit`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name RateLimitError3
     * @request DELETE:/api/sso/v0/public/platform/error/rate-limit
     */
    rateLimitError3: (params: RequestParams = {}) =>
      this.request<RateLimitError3Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/error/rate-limit`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name ErrorValidation
     * @request POST:/api/sso/v0/public/platform/error/validation
     */
    errorValidation: (data: SsoDemoValidationDto, params: RequestParams = {}) =>
      this.request<ErrorValidationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/error/validation`,
        method: 'POST',
        body: data,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name AuthCheck
     * @request GET:/api/sso/v0/user/platform/auth-checker
     */
    authCheck: (params: RequestParams = {}) =>
      this.request<AuthCheckData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/platform/auth-checker`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name GetSamlRedirectUrl
     * @request GET:/api/sso/v0/public/saml-redirect-url/{domainName}
     */
    getSamlRedirectUrl: (domainName: string, params: RequestParams = {}) =>
      this.request<GetSamlRedirectUrlData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/saml-redirect-url/${domainName}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name GetRedirectUrl
     * @request GET:/api/sso/v0/public/redirect-url/{domainName}
     */
    getRedirectUrl: (domainName: string, params: RequestParams = {}) =>
      this.request<GetRedirectUrlData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/redirect-url/${domainName}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name GetRsaPublicKey
     * @request GET:/api/sso/v0/public/public-key
     */
    getRsaPublicKey: (params: RequestParams = {}) =>
      this.request<GetRsaPublicKeyData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/public-key`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name Version
     * @request GET:/api/sso/v0/public/platform/version
     */
    version: (query: VersionParams, params: RequestParams = {}) =>
      this.request<VersionData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/version`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name TestS3
     * @request GET:/api/sso/v0/public/platform/test-s3
     */
    testS3: (params: RequestParams = {}) =>
      this.request<TestS3Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/test-s3`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name HelloWorld
     * @request GET:/api/sso/v0/public/platform/hello-world
     */
    helloWorld: (params: RequestParams = {}) =>
      this.request<HelloWorldData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/hello-world`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name Health
     * @request GET:/api/sso/v0/public/platform/health
     */
    health: (params: RequestParams = {}) =>
      this.request<HealthData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/health`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name GetMyIp
     * @request GET:/api/sso/v0/public/platform/get-my-ip
     */
    getMyIp: (params: RequestParams = {}) =>
      this.request<GetMyIpData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/get-my-ip`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name GeneratePassword
     * @request GET:/api/sso/v0/public/password/generate
     */
    generatePassword: (params: RequestParams = {}) =>
      this.request<GeneratePasswordData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/password/generate`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name AuthCheckUnauthorized
     * @request GET:/api/sso/v0/master/platform/auth-checker
     */
    authCheckUnauthorized: (params: RequestParams = {}) =>
      this.request<AuthCheckUnauthorizedData, SsoErrorResponseDto>({
        path: `/api/sso/v0/master/platform/auth-checker`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags platform-rest-controller
     * @name AuthCheckAdmin
     * @request GET:/api/sso/v0/admin/platform/auth-checker
     */
    authCheckAdmin: (params: RequestParams = {}) =>
      this.request<AuthCheckAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/platform/auth-checker`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  unitTeamController = {
    /**
     * No description
     *
     * @tags unit-team-controller
     * @name UploadUnitTeamPicture
     * @request PUT:/api/sso/v0/user/unit/{identifier}/upload-picture
     */
    uploadUnitTeamPicture: (identifier: string, data: UploadUnitTeamPictureDto, params: RequestParams = {}) =>
      this.request<UploadUnitTeamPictureData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/upload-picture`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name SetAgencyMfaConfiguration
     * @request PUT:/api/sso/v0/user/unit/{identifier}/team/mfa
     */
    setAgencyMfaConfiguration: (identifier: string, data: TeamMfaConfigDto, params: RequestParams = {}) =>
      this.request<SetAgencyMfaConfigurationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/team/mfa`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name UpdateUnitMemberPermissions
     * @request POST:/api/sso/v0/user/unit/{identifier}/team/update-permissions
     */
    updateUnitMemberPermissions: (
      identifier: string,
      data: UpdateUnitTeamMemberPermissionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUnitMemberPermissionsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/team/update-permissions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name ResendInviteToUnitMember
     * @request POST:/api/sso/v0/user/unit/{identifier}/team/resend-invite
     */
    resendInviteToUnitMember: (identifier: string, data: ResendTeamMemberInviteDto, params: RequestParams = {}) =>
      this.request<ResendInviteToUnitMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/team/resend-invite`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name InviteUnitMember
     * @request POST:/api/sso/v0/user/unit/{identifier}/team/invite-member
     */
    inviteUnitMember: (identifier: string, data: InviteTeamMemberDto, params: RequestParams = {}) =>
      this.request<InviteUnitMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/team/invite-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name SetUnitMemberAllowedSites
     * @request POST:/api/sso/v0/user/unit/{identifier}/team/allow-sites/{memberId}
     */
    setUnitMemberAllowedSites: (
      identifier: string,
      memberId: string,
      data: TeamMemberAllowedSitesDto,
      params: RequestParams = {},
    ) =>
      this.request<SetUnitMemberAllowedSitesData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/team/allow-sites/${memberId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name GetUnitMembers
     * @request GET:/api/sso/v0/user/unit/{identifier}/team
     */
    getUnitMembers: (identifier: string, params: RequestParams = {}) =>
      this.request<GetUnitMembersData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/team`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name SearchUnitMembers
     * @request GET:/api/sso/v0/user/unit/{identifier}/team/search
     */
    searchUnitMembers: ({identifier, ...query}: SearchUnitMembersParams, params: RequestParams = {}) =>
      this.request<SearchUnitMembersData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/team/search`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name GetAllActiveUserMemberships
     * @request GET:/api/sso/v0/user/active-memberships
     */
    getAllActiveUserMemberships: (params: RequestParams = {}) =>
      this.request<GetAllActiveUserMembershipsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/active-memberships`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name DeleteExistingUnitMember
     * @request DELETE:/api/sso/v0/user/unit/{identifier}/team/delete-member/{memberId}
     */
    deleteExistingUnitMember: (identifier: string, memberId: string, params: RequestParams = {}) =>
      this.request<DeleteExistingUnitMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/team/delete-member/${memberId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-team-controller
     * @name RemoveUnitTeamPicture
     * @request DELETE:/api/sso/v0/user/unit/{identifier}/remove-picture
     */
    removeUnitTeamPicture: (identifier: string, params: RequestParams = {}) =>
      this.request<RemoveUnitTeamPictureData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/remove-picture`,
        method: 'DELETE',
        ...params,
      }),
  };
  unitController = {
    /**
     * No description
     *
     * @tags unit-controller
     * @name UpdateUnitName
     * @request PUT:/api/sso/v0/user/unit/{identifier}/update-name
     */
    updateUnitName: (identifier: string, data: UpdateTeamNameDto, params: RequestParams = {}) =>
      this.request<UpdateUnitNameData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/update-name`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-controller
     * @name PopulateUnitWithOwner
     * @request POST:/api/sso/v0/user/unit/{parentIdentifier}/subunit/{childIdentifier}/populate-with-owner
     */
    populateUnitWithOwner: (
      parentIdentifier: string,
      childIdentifier: string,
      data: NewUnitOwnerDto,
      params: RequestParams = {},
    ) =>
      this.request<PopulateUnitWithOwnerData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${parentIdentifier}/subunit/${childIdentifier}/populate-with-owner`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-controller
     * @name CreateAccountlessSubunit
     * @request POST:/api/sso/v0/user/unit/{identifier}/create-accountless-subunit
     */
    createAccountlessSubunit: (identifier: string, data: UnitCreationDto, params: RequestParams = {}) =>
      this.request<CreateAccountlessSubunitData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/create-accountless-subunit`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-controller
     * @name UpdateUnitInfo
     * @request PATCH:/api/sso/v0/user/unit/{parentIdentifier}/subunit/{childIdentifier}/update-info
     */
    updateUnitInfo: (
      parentIdentifier: string,
      childIdentifier: string,
      data: UnitUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUnitInfoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${parentIdentifier}/subunit/${childIdentifier}/update-info`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-controller
     * @name UpdateUnitInfo1
     * @request PATCH:/api/sso/v0/user/unit/{parentIdentifier}/update-info
     */
    updateUnitInfo1: (parentIdentifier: string, data: UnitUpdateDto, params: RequestParams = {}) =>
      this.request<UpdateUnitInfo1Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${parentIdentifier}/update-info`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-controller
     * @name GetUnitInfo
     * @request GET:/api/sso/v0/user/unit/{identifier}
     */
    getUnitInfo: (identifier: string, params: RequestParams = {}) =>
      this.request<GetUnitInfoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-controller
     * @name GetChildUnitsByParentId
     * @request GET:/api/sso/v0/user/unit/{identifier}/units
     */
    getChildUnitsByParentId: (identifier: string, params: RequestParams = {}) =>
      this.request<GetChildUnitsByParentIdData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/units`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-controller
     * @name DeleteUnit
     * @request DELETE:/api/sso/v0/user/unit/{identifier}/delete-unit
     */
    deleteUnit: (identifier: string, params: RequestParams = {}) =>
      this.request<DeleteUnitData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/unit/${identifier}/delete-unit`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  teamOwnerController = {
    /**
     * No description
     *
     * @tags team-owner-controller
     * @name SetAllowedMfaMethods
     * @request PUT:/api/sso/v0/user/team/{teamId}/mfa
     */
    setAllowedMfaMethods: (teamId: string, data: TeamMfaConfigDto, params: RequestParams = {}) =>
      this.request<SetAllowedMfaMethodsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/${teamId}/mfa`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  widgetTeamOwnerController = {
    /**
     * No description
     *
     * @tags widget-team-owner-controller
     * @name UnsetWidgetMemberRoleRoleAccountOwner
     * @request PUT:/api/sso/v0/user/team/unset-account-owner-role/{memberId}
     */
    unsetWidgetMemberRoleRoleAccountOwner: (memberId: string, params: RequestParams = {}) =>
      this.request<UnsetWidgetMemberRoleRoleAccountOwnerData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/unset-account-owner-role/${memberId}`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags widget-team-owner-controller
     * @name SetWidgetMemberRoleAccountOwner
     * @request PUT:/api/sso/v0/user/team/set-account-owner-role/{memberId}
     */
    setWidgetMemberRoleAccountOwner: (memberId: string, params: RequestParams = {}) =>
      this.request<SetWidgetMemberRoleAccountOwnerData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/set-account-owner-role/${memberId}`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags widget-team-owner-controller
     * @name UpdateWidgetTeamName
     * @request POST:/api/sso/v0/user/team/update-name
     */
    updateWidgetTeamName: (data: UpdateTeamNameDto, params: RequestParams = {}) =>
      this.request<UpdateWidgetTeamNameData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/update-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags widget-team-owner-controller
     * @name ResendInviteToWidgetMember
     * @request POST:/api/sso/v0/user/team/resend-invite
     */
    resendInviteToWidgetMember: (data: ResendTeamMemberInviteDto, params: RequestParams = {}) =>
      this.request<ResendInviteToWidgetMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/resend-invite`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags widget-team-owner-controller
     * @name InviteNewWidgetMember
     * @request POST:/api/sso/v0/user/team/invite-member
     */
    inviteNewWidgetMember: (data: InviteTeamMemberDto, params: RequestParams = {}) =>
      this.request<InviteNewWidgetMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/invite-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags widget-team-owner-controller
     * @name SetWidgetMemberAllowedSites
     * @request POST:/api/sso/v0/user/team/allow-sites/{memberId}
     */
    setWidgetMemberAllowedSites: (memberId: string, data: TeamMemberAllowedSitesDto, params: RequestParams = {}) =>
      this.request<SetWidgetMemberAllowedSitesData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/allow-sites/${memberId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags widget-team-owner-controller
     * @name GetWidgetTeamMembers
     * @request GET:/api/sso/v0/user/team
     */
    getWidgetTeamMembers: (params: RequestParams = {}) =>
      this.request<GetWidgetTeamMembersData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags widget-team-owner-controller
     * @name DeleteExistingWidgetMember
     * @request DELETE:/api/sso/v0/user/team/delete-member/{memberId}
     */
    deleteExistingWidgetMember: (memberId: string, params: RequestParams = {}) =>
      this.request<DeleteExistingWidgetMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/delete-member/${memberId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  ssoConfigurationUserController = {
    /**
     * No description
     *
     * @tags sso-configuration-user-controller
     * @name GetFullSsoConfiguration
     * @request GET:/api/sso/v0/user/sso-registration
     */
    getFullSsoConfiguration: (params: RequestParams = {}) =>
      this.request<GetFullSsoConfigurationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/sso-registration`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-user-controller
     * @name CreateSsoConfiguration
     * @request PUT:/api/sso/v0/user/sso-registration
     */
    createSsoConfiguration: (data: EnableSsoRequestDto, params: RequestParams = {}) =>
      this.request<CreateSsoConfigurationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/sso-registration`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-user-controller
     * @name DeleteSsoConfiguration
     * @request DELETE:/api/sso/v0/user/sso-registration
     */
    deleteSsoConfiguration: (params: RequestParams = {}) =>
      this.request<DeleteSsoConfigurationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/sso-registration`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-user-controller
     * @name UpdateSamlConfiguration
     * @request PUT:/api/sso/v0/user/sso-registration/saml
     */
    updateSamlConfiguration: (data: UpdateSamlPartDto, params: RequestParams = {}) =>
      this.request<UpdateSamlConfigurationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/sso-registration/saml`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-user-controller
     * @name UpdateProtocol
     * @request PUT:/api/sso/v0/user/sso-registration/protocol
     */
    updateProtocol: (data: UpdateProtocolDto, params: RequestParams = {}) =>
      this.request<UpdateProtocolData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/sso-registration/protocol`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-user-controller
     * @name UpdateOAuthSsoConfiguration
     * @request PUT:/api/sso/v0/user/sso-registration/oauth
     */
    updateOAuthSsoConfiguration: (data: UpdateOAuthPartByUserDto, params: RequestParams = {}) =>
      this.request<UpdateOAuthSsoConfigurationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/sso-registration/oauth`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-user-controller
     * @name EnableSso
     * @request PUT:/api/sso/v0/user/sso-registration/enable
     */
    enableSso: (params: RequestParams = {}) =>
      this.request<EnableSsoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/sso-registration/enable`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-user-controller
     * @name DisableSso
     * @request PUT:/api/sso/v0/user/sso-registration/disable
     */
    disableSso: (params: RequestParams = {}) =>
      this.request<DisableSsoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/sso-registration/disable`,
        method: 'PUT',
        ...params,
      }),
  };
  emailConfigurationController = {
    /**
     * No description
     *
     * @tags email-configuration-controller
     * @name FindEmailConfiguration
     * @request GET:/api/sso/v0/user/service-account/email-config
     */
    findEmailConfiguration: (query: FindEmailConfigurationParams, params: RequestParams = {}) =>
      this.request<FindEmailConfigurationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-account/email-config`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-configuration-controller
     * @name UpdateEmailConfiguration
     * @request PUT:/api/sso/v0/user/service-account/email-config
     */
    updateEmailConfiguration: (data: CreateServiceAccountEmailConfigurationDto, params: RequestParams = {}) =>
      this.request<UpdateEmailConfigurationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-account/email-config`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-configuration-controller
     * @name CreateEmailConfiguration
     * @request POST:/api/sso/v0/user/service-account/email-config
     */
    createEmailConfiguration: (data: CreateServiceAccountEmailConfigurationDto, params: RequestParams = {}) =>
      this.request<CreateEmailConfigurationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-account/email-config`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-configuration-controller
     * @name UpdateEmailConfigurationSystem
     * @request PUT:/api/sso/v0/system/service-account/email-config
     */
    updateEmailConfigurationSystem: (
      data: CreateServiceAccountEmailConfigurationSystemDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateEmailConfigurationSystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-account/email-config`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-configuration-controller
     * @name CreateEmailConfigurationSystem
     * @request POST:/api/sso/v0/system/service-account/email-config
     */
    createEmailConfigurationSystem: (
      data: CreateServiceAccountEmailConfigurationSystemDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateEmailConfigurationSystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-account/email-config`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-configuration-controller
     * @name FindEmailConfigurationSystem
     * @request GET:/api/sso/v0/system/service-account/email-config/{accountId}
     */
    findEmailConfigurationSystem: (
      {accountId, ...query}: FindEmailConfigurationSystemParams,
      params: RequestParams = {},
    ) =>
      this.request<FindEmailConfigurationSystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-account/email-config/${accountId}`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  serviceAccountController = {
    /**
     * No description
     *
     * @tags service-account-controller
     * @name UpdateServiceAccountInfo
     * @request PUT:/api/sso/v0/user/service-account
     */
    updateServiceAccountInfo: (data: UpdateServiceAccountInfoDto, params: RequestParams = {}) =>
      this.request<UpdateServiceAccountInfoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-account`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-account-controller
     * @name UpdateServiceAccountInfo1
     * @request PUT:/api/sso/v0/user/account/{identifier}
     */
    updateServiceAccountInfo1: (identifier: string, data: UpdateServiceAccountInfoDto, params: RequestParams = {}) =>
      this.request<UpdateServiceAccountInfo1Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/account/${identifier}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-account-controller
     * @name CreateCa11YOrganization
     * @request POST:/api/sso/v0/user/service-account/create-ca11y-organization
     */
    createCa11YOrganization: (data: OrganizationCreationDto, params: RequestParams = {}) =>
      this.request<CreateCa11YOrganizationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-account/create-ca11y-organization`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-account-controller
     * @name GetServiceAccountInfoBySystem
     * @request GET:/api/sso/v0/system/service-account/{targetAccountIdentifier}/info
     */
    getServiceAccountInfoBySystem: (targetAccountIdentifier: string, params: RequestParams = {}) =>
      this.request<GetServiceAccountInfoBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-account/${targetAccountIdentifier}/info`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-account-controller
     * @name GetPublicAccountInfo
     * @request GET:/api/sso/v0/public/service-account/info
     */
    getPublicAccountInfo: (query: GetPublicAccountInfoParams, params: RequestParams = {}) =>
      this.request<GetPublicAccountInfoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-account/info`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-account-controller
     * @name DeleteOrganization
     * @request DELETE:/api/sso/v0/user/organization/{identifier}
     */
    deleteOrganization: (identifier: string, params: RequestParams = {}) =>
      this.request<DeleteOrganizationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}`,
        method: 'DELETE',
        ...params,
      }),
  };
  apiKeyController = {
    /**
     * No description
     *
     * @tags api-key-controller
     * @name UpdateApiKeyStateByUser
     * @request PUT:/api/sso/v0/user/api-key/{id}/state
     */
    updateApiKeyStateByUser: (id: string, data: ApiKeyStateDto, params: RequestParams = {}) =>
      this.request<UpdateApiKeyStateByUserData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/api-key/${id}/state`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name UpdateApiKeyStateByAdmin
     * @request PUT:/api/sso/v0/admin/api-key/{id}/state
     */
    updateApiKeyStateByAdmin: (id: string, data: ApiKeyStateDto, params: RequestParams = {}) =>
      this.request<UpdateApiKeyStateByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/api-key/${id}/state`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name GetApiKeysForUser
     * @request GET:/api/sso/v0/user/api-key
     */
    getApiKeysForUser: (params: RequestParams = {}) =>
      this.request<GetApiKeysForUserData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/api-key`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name CreateNewApiKeyByUser
     * @request POST:/api/sso/v0/user/api-key
     */
    createNewApiKeyByUser: (data: NewApiKeyDto, params: RequestParams = {}) =>
      this.request<CreateNewApiKeyByUserData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/api-key`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name CreateNewApiKeyByAnon
     * @request POST:/api/sso/v0/public/api-key
     */
    createNewApiKeyByAnon: (data: NewApiKeyRequestDto, params: RequestParams = {}) =>
      this.request<CreateNewApiKeyByAnonData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/api-key`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name UpdateApiKeyReject
     * @request POST:/api/sso/v0/admin/api-key/{id}/reject
     */
    updateApiKeyReject: (id: string, params: RequestParams = {}) =>
      this.request<UpdateApiKeyRejectData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/api-key/${id}/reject`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name UpdateApiKeyApprove
     * @request POST:/api/sso/v0/admin/api-key/{id}/approve
     */
    updateApiKeyApprove: (id: string, params: RequestParams = {}) =>
      this.request<UpdateApiKeyApproveData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/api-key/${id}/approve`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name GetAllApiKeysByAdmin
     * @request GET:/api/sso/v0/admin/api-key
     */
    getAllApiKeysByAdmin: (query: GetAllApiKeysByAdminParams, params: RequestParams = {}) =>
      this.request<GetAllApiKeysByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/api-key`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name GetApiKeyByAdmin
     * @request GET:/api/sso/v0/admin/api-key/{id}
     */
    getApiKeyByAdmin: (id: string, params: RequestParams = {}) =>
      this.request<GetApiKeyByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/api-key/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name GetApiKeysForUserIdByAdmin
     * @request GET:/api/sso/v0/admin/api-key/user/{userId}
     */
    getApiKeysForUserIdByAdmin: (userId: string, params: RequestParams = {}) =>
      this.request<GetApiKeysForUserIdByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/api-key/user/${userId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-key-controller
     * @name DeleteApiKeyByUser
     * @request DELETE:/api/sso/v0/user/api-key/{id}
     */
    deleteApiKeyByUser: (id: string, params: RequestParams = {}) =>
      this.request<DeleteApiKeyByUserData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/api-key/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  systemUserController = {
    /**
     * No description
     *
     * @tags system-user-controller
     * @name UpdateUserInfoBySystem
     * @request PUT:/api/sso/v0/system/service-user/{accountId}
     */
    updateUserInfoBySystem: (
      {accountId, ...query}: UpdateUserInfoBySystemParams,
      data: UpdateUserInfoDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserInfoBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-user/${accountId}`,
        method: 'PUT',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags system-user-controller
     * @name UpdateEmailPreferencesBySystem
     * @request POST:/api/sso/v0/system/service-user/update-email-preferences
     */
    updateEmailPreferencesBySystem: (data: UpdateEmailSubscriptionsBySystemDto, params: RequestParams = {}) =>
      this.request<UpdateEmailPreferencesBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-user/update-email-preferences`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags system-user-controller
     * @name SendPasswordReset
     * @request POST:/api/sso/v0/system/service-user/request-password-reset
     */
    sendPasswordReset: (data: PasswordResetEmailRequestDto, params: RequestParams = {}) =>
      this.request<SendPasswordResetData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-user/request-password-reset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags system-user-controller
     * @name LoginWithEmailInTargetAccountBySystem
     * @request POST:/api/sso/v0/system/service-user/login-target-account
     */
    loginWithEmailInTargetAccountBySystem: (
      query: LoginWithEmailInTargetAccountBySystemParams,
      data: LoginByEmailRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<LoginWithEmailInTargetAccountBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-user/login-target-account`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags system-user-controller
     * @name LoginWithEmailBySystem
     * @request POST:/api/sso/v0/system/service-user/login-by-email
     */
    loginWithEmailBySystem: (data: LoginByEmailRequestDto, params: RequestParams = {}) =>
      this.request<LoginWithEmailBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-user/login-by-email`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags system-user-controller
     * @name LoginIntoAccountBySystem
     * @request POST:/api/sso/v0/system/service-user/login-by-account
     */
    loginIntoAccountBySystem: (data: LoginByAccountRequestDto, params: RequestParams = {}) =>
      this.request<LoginIntoAccountBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-user/login-by-account`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags system-user-controller
     * @name CheckEmailStatusBySystem
     * @request POST:/api/sso/v0/system/email/subscription-status
     */
    checkEmailStatusBySystem: (data: CheckEmailStatusDto, params: RequestParams = {}) =>
      this.request<CheckEmailStatusBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/email/subscription-status`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags system-user-controller
     * @name SendEmailBySystem
     * @request POST:/api/sso/v0/system/email/send
     */
    sendEmailBySystem: (data: SendEmailDto, params: RequestParams = {}) =>
      this.request<SendEmailBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/email/send`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags system-user-controller
     * @name AddAccountNotificationBySystem
     * @request POST:/api/sso/v0/system/account/notification
     */
    addAccountNotificationBySystem: (data: AddAccountNotificationDto, params: RequestParams = {}) =>
      this.request<AddAccountNotificationBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/account/notification`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags system-user-controller
     * @name GetServiceUserInfoBySystem
     * @request GET:/api/sso/v0/system/service-user/{accountIdOrCode}/info
     */
    getServiceUserInfoBySystem: (accountIdOrCode: string, params: RequestParams = {}) =>
      this.request<GetServiceUserInfoBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-user/${accountIdOrCode}/info`,
        method: 'GET',
        ...params,
      }),
  };
  mfaEmailController = {
    /**
     * No description
     *
     * @tags mfa-email-controller
     * @name SendEmailMfaVerification
     * @request PUT:/api/sso/v0/public/service-user/mfa/email/send
     */
    sendEmailMfaVerification: (query: SendEmailMfaVerificationParams, params: RequestParams = {}) =>
      this.request<SendEmailMfaVerificationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/mfa/email/send`,
        method: 'PUT',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags mfa-email-controller
     * @name InitializeEmailMfa
     * @request GET:/api/sso/v0/user/service-user/mfa/email
     */
    initializeEmailMfa: (params: RequestParams = {}) =>
      this.request<InitializeEmailMfaData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/mfa/email`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags mfa-email-controller
     * @name ConfirmEmailMfa
     * @request POST:/api/sso/v0/user/service-user/mfa/email
     */
    confirmEmailMfa: (data: ConfirmEmailMfaDto, params: RequestParams = {}) =>
      this.request<ConfirmEmailMfaData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/mfa/email`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags mfa-email-controller
     * @name DisableEmailMfa
     * @request DELETE:/api/sso/v0/user/service-user/mfa/email
     */
    disableEmailMfa: (params: RequestParams = {}) =>
      this.request<DisableEmailMfaData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/mfa/email`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  ssoConfigurationController = {
    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name UpdateSamlConfigurationByAdmin
     * @request PUT:/api/sso/v0/admin/sso-registrations/{ssoConfigurationId}/saml
     */
    updateSamlConfigurationByAdmin: (ssoConfigurationId: string, data: UpdateSamlPartDto, params: RequestParams = {}) =>
      this.request<UpdateSamlConfigurationByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/sso-registrations/${ssoConfigurationId}/saml`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name UpdateProtocolByAdmin
     * @request PUT:/api/sso/v0/admin/sso-registrations/{ssoConfigurationId}/protocol
     */
    updateProtocolByAdmin: (ssoConfigurationId: string, data: UpdateProtocolDto, params: RequestParams = {}) =>
      this.request<UpdateProtocolByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/sso-registrations/${ssoConfigurationId}/protocol`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name UpdateOAuthSsoConfigurationByAdmin
     * @request PUT:/api/sso/v0/admin/sso-registrations/{ssoConfigurationId}/oauth
     */
    updateOAuthSsoConfigurationByAdmin: (
      ssoConfigurationId: string,
      data: UpdateOAuthPartDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateOAuthSsoConfigurationByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/sso-registrations/${ssoConfigurationId}/oauth`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name EnableSsoByAdmin
     * @request PUT:/api/sso/v0/admin/sso-registrations/{ssoConfigurationId}/enable
     */
    enableSsoByAdmin: (ssoConfigurationId: string, params: RequestParams = {}) =>
      this.request<EnableSsoByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/sso-registrations/${ssoConfigurationId}/enable`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name DisableSsoByAdmin
     * @request PUT:/api/sso/v0/admin/sso-registrations/{ssoConfigurationId}/disable
     */
    disableSsoByAdmin: (ssoConfigurationId: string, params: RequestParams = {}) =>
      this.request<DisableSsoByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/sso-registrations/${ssoConfigurationId}/disable`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name CreateSsoConfigurationByAdmin
     * @request PUT:/api/sso/v0/admin/sso-registrations/service-user/{ssoUserId}
     */
    createSsoConfigurationByAdmin: (ssoUserId: string, data: EnableSsoAdminRequestDto, params: RequestParams = {}) =>
      this.request<CreateSsoConfigurationByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/sso-registrations/service-user/${ssoUserId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name UpdateRegistrationIdByAdmin
     * @request PUT:/api/sso/v0/admin/social-registrations/{socialConfigurationId}/registrationId
     */
    updateRegistrationIdByAdmin: (
      socialConfigurationId: string,
      data: UpdateRegistrationIdDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateRegistrationIdByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/social-registrations/${socialConfigurationId}/registrationId`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name UpdateOAuthSocialConfigurationByAdmin
     * @request PUT:/api/sso/v0/admin/social-registrations/{socialConfigurationId}/oauth
     */
    updateOAuthSocialConfigurationByAdmin: (
      socialConfigurationId: string,
      data: UpdateOAuthPartDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateOAuthSocialConfigurationByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/social-registrations/${socialConfigurationId}/oauth`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name EnableSocialByAdmin
     * @request PUT:/api/sso/v0/admin/social-registrations/{socialConfigurationId}/enable
     */
    enableSocialByAdmin: (socialConfigurationId: string, params: RequestParams = {}) =>
      this.request<EnableSocialByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/social-registrations/${socialConfigurationId}/enable`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name DisableSocialLoginByAdmin
     * @request PUT:/api/sso/v0/admin/social-registrations/{socialConfigurationId}/disable
     */
    disableSocialLoginByAdmin: (socialConfigurationId: string, params: RequestParams = {}) =>
      this.request<DisableSocialLoginByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/social-registrations/${socialConfigurationId}/disable`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name GetAllSocialRegistrationsInfoByAdmin
     * @request GET:/api/sso/v0/admin/social-registrations
     */
    getAllSocialRegistrationsInfoByAdmin: (params: RequestParams = {}) =>
      this.request<GetAllSocialRegistrationsInfoByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/social-registrations`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name CreateSocialLoginConfigurationByAdmin
     * @request POST:/api/sso/v0/admin/social-registrations
     */
    createSocialLoginConfigurationByAdmin: (data: SocialConfigurationCreationDto, params: RequestParams = {}) =>
      this.request<CreateSocialLoginConfigurationByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/social-registrations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name GetAllSsoRegistrationsInfoByAdmin
     * @request GET:/api/sso/v0/admin/sso-registrations
     */
    getAllSsoRegistrationsInfoByAdmin: (params: RequestParams = {}) =>
      this.request<GetAllSsoRegistrationsInfoByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/sso-registrations`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name GetFullSsoConfigurationByAdmin
     * @request GET:/api/sso/v0/admin/sso-registrations/{ssoUserId}
     */
    getFullSsoConfigurationByAdmin: (ssoUserId: string, params: RequestParams = {}) =>
      this.request<GetFullSsoConfigurationByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/sso-registrations/${ssoUserId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name GetSocialRegistrationInfoByAdmin
     * @request GET:/api/sso/v0/admin/social-registrations/{registrationId}
     */
    getSocialRegistrationInfoByAdmin: (registrationId: string, params: RequestParams = {}) =>
      this.request<GetSocialRegistrationInfoByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/social-registrations/${registrationId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags sso-configuration-controller
     * @name DeleteSsoConfigurationByAdmin
     * @request DELETE:/api/sso/v0/admin/sso-registrations/{ssoConfigurationId}
     */
    deleteSsoConfigurationByAdmin: (ssoConfigurationId: string, params: RequestParams = {}) =>
      this.request<DeleteSsoConfigurationByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/sso-registrations/${ssoConfigurationId}`,
        method: 'DELETE',
        ...params,
      }),
  };
  widgetTeamMemberController = {
    /**
     * No description
     *
     * @tags widget-team-member-controller
     * @name SwitchWidgetTeamByMember
     * @request POST:/api/sso/v0/user/team/switch-team
     */
    switchWidgetTeamByMember: (data: SwitchTeamDto, params: RequestParams = {}) =>
      this.request<SwitchWidgetTeamByMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/switch-team`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags widget-team-member-controller
     * @name IsWidgetTeamByMember
     * @request POST:/api/sso/v0/public/team/is-team-member
     */
    isWidgetTeamByMember: (data: IsTeamMemberDto, params: RequestParams = {}) =>
      this.request<IsWidgetTeamByMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/team/is-team-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags widget-team-member-controller
     * @name GetWidgetTeamMemberships
     * @request GET:/api/sso/v0/user/team/memberships
     */
    getWidgetTeamMemberships: (params: RequestParams = {}) =>
      this.request<GetWidgetTeamMembershipsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/memberships`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  scannerTeamPictureController = {
    /**
     * No description
     *
     * @tags scanner-team-picture-controller
     * @name UploadScannerTeamPicture
     * @request POST:/api/sso/v0/user/team/scanner/upload-picture
     */
    uploadScannerTeamPicture: (data: UploadAccountPictureDto, params: RequestParams = {}) =>
      this.request<UploadScannerTeamPictureData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/upload-picture`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-picture-controller
     * @name RemoveScannerTeamPicture
     * @request POST:/api/sso/v0/user/team/scanner/remove-picture
     */
    removeScannerTeamPicture: (params: RequestParams = {}) =>
      this.request<RemoveScannerTeamPictureData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/remove-picture`,
        method: 'POST',
        ...params,
      }),
  };
  scannerTeamOwnerController = {
    /**
     * No description
     *
     * @tags scanner-team-owner-controller
     * @name UpdateScannerMemberPermissions
     * @request POST:/api/sso/v0/user/team/scanner/update-permissions
     */
    updateScannerMemberPermissions: (data: UpdateMemberPermissionsDto, params: RequestParams = {}) =>
      this.request<UpdateScannerMemberPermissionsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/update-permissions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-owner-controller
     * @name UpdateScannerTeamName
     * @request POST:/api/sso/v0/user/team/scanner/update-name
     */
    updateScannerTeamName: (data: UpdateTeamNameDto, params: RequestParams = {}) =>
      this.request<UpdateScannerTeamNameData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/update-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-owner-controller
     * @name UnsuspendScannerMember
     * @request POST:/api/sso/v0/user/team/scanner/unsuspend-member
     */
    unsuspendScannerMember: (data: UnsuspendTeamMemberDto, params: RequestParams = {}) =>
      this.request<UnsuspendScannerMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/unsuspend-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-owner-controller
     * @name SuspendScannerMember
     * @request POST:/api/sso/v0/user/team/scanner/suspend-member
     */
    suspendScannerMember: (data: SuspendTeamMemberDto, params: RequestParams = {}) =>
      this.request<SuspendScannerMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/suspend-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-owner-controller
     * @name ResendScannerInvite
     * @request POST:/api/sso/v0/user/team/scanner/resend-invite
     */
    resendScannerInvite: (data: ResendTeamInviteDto, params: RequestParams = {}) =>
      this.request<ResendScannerInviteData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/resend-invite`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-owner-controller
     * @name RemoveScannerMember
     * @request POST:/api/sso/v0/user/team/scanner/remove-member
     */
    removeScannerMember: (data: RemoveTeamMemberDto, params: RequestParams = {}) =>
      this.request<RemoveScannerMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/remove-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-owner-controller
     * @name InviteScannerMembers
     * @request POST:/api/sso/v0/user/team/scanner/invite-members
     */
    inviteScannerMembers: (data: InviteTeamMembersDto, params: RequestParams = {}) =>
      this.request<InviteScannerMembersData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/invite-members`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-owner-controller
     * @name CancelScannerInvite
     * @request POST:/api/sso/v0/user/team/scanner/cancel-invite
     */
    cancelScannerInvite: (data: CancelTeamInviteDto, params: RequestParams = {}) =>
      this.request<CancelScannerInviteData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/cancel-invite`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-owner-controller
     * @name GetScannerTeamMembers
     * @request GET:/api/sso/v0/user/team/scanner/members
     */
    getScannerTeamMembers: (params: RequestParams = {}) =>
      this.request<GetScannerTeamMembersData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/members`,
        method: 'GET',
        ...params,
      }),
  };
  scannerTeamMemberController = {
    /**
     * No description
     *
     * @tags scanner-team-member-controller
     * @name SwitchScannerTeamByMember
     * @request POST:/api/sso/v0/user/team/scanner/switch-team
     */
    switchScannerTeamByMember: (data: TeamMemberLoginDto, params: RequestParams = {}) =>
      this.request<SwitchScannerTeamByMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/switch-team`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-member-controller
     * @name RejectScannerTeamInvite
     * @request POST:/api/sso/v0/user/team/scanner/reject-invitation
     */
    rejectScannerTeamInvite: (data: RejectTeamInviteDto, params: RequestParams = {}) =>
      this.request<RejectScannerTeamInviteData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/reject-invitation`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-member-controller
     * @name AcceptScannerTeamInvite
     * @request POST:/api/sso/v0/user/team/scanner/accept-invitation
     */
    acceptScannerTeamInvite: (data: AcceptTeamInviteDto, params: RequestParams = {}) =>
      this.request<AcceptScannerTeamInviteData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/accept-invitation`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-member-controller
     * @name GetScannerTeamMemberships
     * @request GET:/api/sso/v0/user/team/scanner/memberships
     */
    getScannerTeamMemberships: (params: RequestParams = {}) =>
      this.request<GetScannerTeamMembershipsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/scanner/memberships`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  ca11YTeamMemberController = {
    /**
     * No description
     *
     * @tags ca-11y-team-member-controller
     * @name LeaveCa11YOrganization
     * @request POST:/api/sso/v0/user/team/ca11y/{targetAccountIdentifier}/leave
     */
    leaveCa11YOrganization: (targetAccountIdentifier: string, params: RequestParams = {}) =>
      this.request<LeaveCa11YOrganizationData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/ca11y/${targetAccountIdentifier}/leave`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-member-controller
     * @name SwitchCa11YTeamByMember
     * @request POST:/api/sso/v0/user/team/ca11y/switch-team
     */
    switchCa11YTeamByMember: (data: Ca11YTeamMemberLoginDto, params: RequestParams = {}) =>
      this.request<SwitchCa11YTeamByMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/ca11y/switch-team`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-member-controller
     * @name RejectCa11YTeamInvite
     * @request POST:/api/sso/v0/user/team/ca11y/reject-invitation
     */
    rejectCa11YTeamInvite: (data: Ca11YRejectTeamInviteDto, params: RequestParams = {}) =>
      this.request<RejectCa11YTeamInviteData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/ca11y/reject-invitation`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-member-controller
     * @name AcceptCa11YTeamInvite
     * @request POST:/api/sso/v0/user/team/ca11y/accept-invitation
     */
    acceptCa11YTeamInvite: (data: Ca11YAcceptTeamInviteDto, params: RequestParams = {}) =>
      this.request<AcceptCa11YTeamInviteData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/ca11y/accept-invitation`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-member-controller
     * @name GetCa11YTeamMemberships
     * @request GET:/api/sso/v0/user/team/ca11y/memberships
     */
    getCa11YTeamMemberships: (params: RequestParams = {}) =>
      this.request<GetCa11YTeamMembershipsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/ca11y/memberships`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-member-controller
     * @name GetCa11YTeamMembership
     * @request GET:/api/sso/v0/user/team/ca11y/memberships/{targetAccountIdentifier}
     */
    getCa11YTeamMembership: (targetAccountIdentifier: string, params: RequestParams = {}) =>
      this.request<GetCa11YTeamMembershipData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/team/ca11y/memberships/${targetAccountIdentifier}`,
        method: 'GET',
        ...params,
      }),
  };
  serviceUserIpWhitelistController = {
    /**
     * No description
     *
     * @tags service-user-ip-whitelist-controller
     * @name SetIpWhitelisting
     * @request POST:/api/sso/v0/user/service-user/whitelisted-ips
     */
    setIpWhitelisting: (data: UpdateIpWhitelistDto, params: RequestParams = {}) =>
      this.request<SetIpWhitelistingData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/whitelisted-ips`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-ip-whitelist-controller
     * @name DisableIpWhitelisting
     * @request DELETE:/api/sso/v0/user/service-user/whitelisted-ips
     */
    disableIpWhitelisting: (params: RequestParams = {}) =>
      this.request<DisableIpWhitelistingData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/whitelisted-ips`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  serviceUserPictureController = {
    /**
     * No description
     *
     * @tags service-user-picture-controller
     * @name UploadUserPicture
     * @request POST:/api/sso/v0/user/service-user/upload-picture
     */
    uploadUserPicture: (data: UploadUserPictureDto, params: RequestParams = {}) =>
      this.request<UploadUserPictureData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/upload-picture`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-picture-controller
     * @name RemoveUserPicture
     * @request POST:/api/sso/v0/user/service-user/remove-picture
     */
    removeUserPicture: (data: RemoveUserPictureDto, params: RequestParams = {}) =>
      this.request<RemoveUserPictureData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/remove-picture`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  timeZoneRestController = {
    /**
     * No description
     *
     * @tags time-zone-rest-controller
     * @name UpdateUserTimeZone
     * @request POST:/api/sso/v0/user/service-user/timezone
     */
    updateUserTimeZone: (data: UpdateUserTimeZoneDto, params: RequestParams = {}) =>
      this.request<UpdateUserTimeZoneData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/timezone`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags time-zone-rest-controller
     * @name GetAvailableTimeZones
     * @request GET:/api/sso/v0/public/platform/timezones
     */
    getAvailableTimeZones: (params: RequestParams = {}) =>
      this.request<GetAvailableTimeZonesData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/platform/timezones`,
        method: 'GET',
        ...params,
      }),
  };
  mfaVirtualController = {
    /**
     * No description
     *
     * @tags mfa-virtual-controller
     * @name InitializeVirtualMfa
     * @request GET:/api/sso/v0/user/service-user/mfa/virtual
     */
    initializeVirtualMfa: (params: RequestParams = {}) =>
      this.request<InitializeVirtualMfaData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/mfa/virtual`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags mfa-virtual-controller
     * @name ConfirmVirtualMfa
     * @request POST:/api/sso/v0/user/service-user/mfa/virtual
     */
    confirmVirtualMfa: (data: ConfirmVirtualMfaDto, params: RequestParams = {}) =>
      this.request<ConfirmVirtualMfaData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/mfa/virtual`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags mfa-virtual-controller
     * @name DisableVirtualMfa
     * @request DELETE:/api/sso/v0/user/service-user/mfa/virtual
     */
    disableVirtualMfa: (params: RequestParams = {}) =>
      this.request<DisableVirtualMfaData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/mfa/virtual`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  serviceUserController = {
    /**
     * No description
     *
     * @tags service-user-controller
     * @name ChangePassword
     * @request POST:/api/sso/v0/user/service-user/change-password
     */
    changePassword: (data: ChangePasswordDto, params: RequestParams = {}) =>
      this.request<ChangePasswordData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/change-password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name ChangeEmailByUser
     * @request POST:/api/sso/v0/user/service-user/change-email
     */
    changeEmailByUser: (data: ChangeEmailDto, params: RequestParams = {}) =>
      this.request<ChangeEmailByUserData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/change-email`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name Signup
     * @request POST:/api/sso/v0/public/service-user/signup
     */
    signup: (data: UserSignupDto, params: RequestParams = {}) =>
      this.request<SignupData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/signup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name ResetPassword
     * @request POST:/api/sso/v0/public/service-user/reset-password
     */
    resetPassword: (data: ResetPasswordDto, params: RequestParams = {}) =>
      this.request<ResetPasswordData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/reset-password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name ResetPassword1
     * @request POST:/api/sso/v0/public/service-user/reset-password-contact
     */
    resetPassword1: (data: ResetContactPasswordDto, params: RequestParams = {}) =>
      this.request<ResetPassword1Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/reset-password-contact`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name SendPasswordResetEmail
     * @request POST:/api/sso/v0/public/service-user/password-reset-email
     */
    sendPasswordResetEmail: (data: PasswordResetEmailRequestDto, params: RequestParams = {}) =>
      this.request<SendPasswordResetEmailData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/password-reset-email`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name Exists
     * @request POST:/api/sso/v0/public/service-user/exists
     */
    exists: (data: UserExistsRequestDto, params: RequestParams = {}) =>
      this.request<ExistsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/exists`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name ContactSignup
     * @request POST:/api/sso/v0/public/service-user/contact-signup
     */
    contactSignup: (data: UserSignupDto, params: RequestParams = {}) =>
      this.request<ContactSignupData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/contact-signup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name ChangeDefaultTeam
     * @request PATCH:/api/sso/v0/user/service-user/default-team
     */
    changeDefaultTeam: (data: ChangeDefaultTeamDto, params: RequestParams = {}) =>
      this.request<ChangeDefaultTeamData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/default-team`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name GetTempAuthCode
     * @request GET:/api/sso/v0/user/service-user/temp-auth-code
     */
    getTempAuthCode: (query: GetTempAuthCodeParams, params: RequestParams = {}) =>
      this.request<GetTempAuthCodeData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/temp-auth-code`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-controller
     * @name GetUserInfo
     * @request GET:/api/sso/v0/user/service-user/info
     */
    getUserInfo: (params: RequestParams = {}) =>
      this.request<GetUserInfoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/info`,
        method: 'GET',
        ...params,
      }),
  };
  ca11YOrganizationPictureController = {
    /**
     * No description
     *
     * @tags ca-11y-organization-picture-controller
     * @name UploadOrganizationPicture
     * @request POST:/api/sso/v0/user/organization/{identifier}/upload-picture
     */
    uploadOrganizationPicture: (identifier: string, data: UploadAccountPictureDto, params: RequestParams = {}) =>
      this.request<UploadOrganizationPictureData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/upload-picture`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-organization-picture-controller
     * @name RemoveOrganizationPicture
     * @request POST:/api/sso/v0/user/organization/{identifier}/remove-picture
     */
    removeOrganizationPicture: (identifier: string, params: RequestParams = {}) =>
      this.request<RemoveOrganizationPictureData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/remove-picture`,
        method: 'POST',
        ...params,
      }),
  };
  ca11YTeamOwnerController = {
    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name UpdateCa11YTeamName
     * @request POST:/api/sso/v0/user/organization/{identifier}/team/ca11y/update-name
     */
    updateCa11YTeamName: (identifier: string, data: UpdateTeamNameDto, params: RequestParams = {}) =>
      this.request<UpdateCa11YTeamNameData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/update-name`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name UnsuspendCa11YMember
     * @request POST:/api/sso/v0/user/organization/{identifier}/team/ca11y/unsuspend-member
     */
    unsuspendCa11YMember: (identifier: string, data: Ca11YUnsuspendTeamMemberDto, params: RequestParams = {}) =>
      this.request<UnsuspendCa11YMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/unsuspend-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name SuspendCa11YMember
     * @request POST:/api/sso/v0/user/organization/{identifier}/team/ca11y/suspend-member
     */
    suspendCa11YMember: (identifier: string, data: Ca11YSuspendTeamMemberDto, params: RequestParams = {}) =>
      this.request<SuspendCa11YMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/suspend-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name ResendCa11YInvite
     * @request POST:/api/sso/v0/user/organization/{identifier}/team/ca11y/resend-invite
     */
    resendCa11YInvite: (identifier: string, data: Ca11YResendTeamInviteDto, params: RequestParams = {}) =>
      this.request<ResendCa11YInviteData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/resend-invite`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name RemoveCa11YMember
     * @request POST:/api/sso/v0/user/organization/{identifier}/team/ca11y/remove-member
     */
    removeCa11YMember: (identifier: string, data: Ca11YRemoveTeamMemberDto, params: RequestParams = {}) =>
      this.request<RemoveCa11YMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/remove-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name InviteSingleCa11YMember
     * @request POST:/api/sso/v0/user/organization/{identifier}/team/ca11y/invite-single-member
     */
    inviteSingleCa11YMember: (identifier: string, data: Ca11YInviteSingleTeamMemberDto, params: RequestParams = {}) =>
      this.request<InviteSingleCa11YMemberData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/invite-single-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name InviteCa11YMembers
     * @request POST:/api/sso/v0/user/organization/{identifier}/team/ca11y/invite-members
     */
    inviteCa11YMembers: (identifier: string, data: Ca11YInviteManyTeamMembersDto, params: RequestParams = {}) =>
      this.request<InviteCa11YMembersData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/invite-members`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name CancelCa11YInvite
     * @request POST:/api/sso/v0/user/organization/{identifier}/team/ca11y/cancel-invite
     */
    cancelCa11YInvite: (identifier: string, data: Ca11YCancelTeamInviteDto, params: RequestParams = {}) =>
      this.request<CancelCa11YInviteData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/cancel-invite`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name GetCa11YTeamMembers
     * @request GET:/api/sso/v0/user/organization/{identifier}/team/ca11y/members
     */
    getCa11YTeamMembers: (identifier: string, params: RequestParams = {}) =>
      this.request<GetCa11YTeamMembersData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/members`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name UpdateCa11YMemberPermissions
     * @request GET:/api/sso/v0/user/organization/{identifier}/team/ca11y/update-permissions
     */
    updateCa11YMemberPermissions: (
      identifier: string,
      data: Ca11YUpdateMemberPermissionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCa11YMemberPermissionsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/update-permissions`,
        method: 'GET',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name UpdateCa11YMemberPermissions2
     * @request PUT:/api/sso/v0/user/organization/{identifier}/team/ca11y/update-permissions
     */
    updateCa11YMemberPermissions2: (
      identifier: string,
      data: Ca11YUpdateMemberPermissionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCa11YMemberPermissions2Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/update-permissions`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name UpdateCa11YMemberPermissions1
     * @request POST:/api/sso/v0/user/organization/{identifier}/team/ca11y/update-permissions
     */
    updateCa11YMemberPermissions1: (
      identifier: string,
      data: Ca11YUpdateMemberPermissionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCa11YMemberPermissions1Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/update-permissions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name UpdateCa11YMemberPermissions3
     * @request DELETE:/api/sso/v0/user/organization/{identifier}/team/ca11y/update-permissions
     */
    updateCa11YMemberPermissions3: (
      identifier: string,
      data: Ca11YUpdateMemberPermissionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCa11YMemberPermissions3Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/update-permissions`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name UpdateCa11YMemberPermissions6
     * @request OPTIONS:/api/sso/v0/user/organization/{identifier}/team/ca11y/update-permissions
     */
    updateCa11YMemberPermissions6: (
      identifier: string,
      data: Ca11YUpdateMemberPermissionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCa11YMemberPermissions6Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/update-permissions`,
        method: 'OPTIONS',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name UpdateCa11YMemberPermissions5
     * @request HEAD:/api/sso/v0/user/organization/{identifier}/team/ca11y/update-permissions
     */
    updateCa11YMemberPermissions5: (
      identifier: string,
      data: Ca11YUpdateMemberPermissionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCa11YMemberPermissions5Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/update-permissions`,
        method: 'HEAD',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-owner-controller
     * @name UpdateCa11YMemberPermissions4
     * @request PATCH:/api/sso/v0/user/organization/{identifier}/team/ca11y/update-permissions
     */
    updateCa11YMemberPermissions4: (
      identifier: string,
      data: Ca11YUpdateMemberPermissionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCa11YMemberPermissions4Data, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/organization/${identifier}/team/ca11y/update-permissions`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  emailVerificationController = {
    /**
     * No description
     *
     * @tags email-verification-controller
     * @name SendVerificationEmailByUser
     * @request POST:/api/sso/v0/user/email/send-verification
     */
    sendVerificationEmailByUser: (params: RequestParams = {}) =>
      this.request<SendVerificationEmailByUserData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/email/send-verification`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-verification-controller
     * @name VerifyEmailByCode
     * @request POST:/api/sso/v0/public/email/verify/{code}
     */
    verifyEmailByCode: (code: string, params: RequestParams = {}) =>
      this.request<VerifyEmailByCodeData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/email/verify/${code}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-verification-controller
     * @name SendVerificationEmailByAdmin
     * @request POST:/api/sso/v0/admin/user/{userId}/send-verification
     */
    sendVerificationEmailByAdmin: (userId: string, params: RequestParams = {}) =>
      this.request<SendVerificationEmailByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/user/${userId}/send-verification`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-verification-controller
     * @name VerifyEmailByAdmin
     * @request POST:/api/sso/v0/admin/user/{userId}/email/verify
     */
    verifyEmailByAdmin: (userId: string, params: RequestParams = {}) =>
      this.request<VerifyEmailByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/user/${userId}/email/verify`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-verification-controller
     * @name UnverifyEmailByAdmin
     * @request POST:/api/sso/v0/admin/user/{userId}/email/unverify
     */
    unverifyEmailByAdmin: (userId: string, params: RequestParams = {}) =>
      this.request<UnverifyEmailByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/user/${userId}/email/unverify`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-verification-controller
     * @name SendAllPostponedEmailsByAdmin
     * @request POST:/api/sso/v0/admin/user/{userId}/email/send-all-postponed
     */
    sendAllPostponedEmailsByAdmin: (userId: string, params: RequestParams = {}) =>
      this.request<SendAllPostponedEmailsByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/user/${userId}/email/send-all-postponed`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-verification-controller
     * @name GetEmailVerificationStatusByAdmin
     * @request GET:/api/sso/v0/admin/user/{userId}/email-verification
     */
    getEmailVerificationStatusByAdmin: (userId: string, params: RequestParams = {}) =>
      this.request<GetEmailVerificationStatusByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/user/${userId}/email-verification`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-verification-controller
     * @name SetEmailVerificationParams
     * @request POST:/api/sso/v0/admin/user/{userId}/email-verification
     */
    setEmailVerificationParams: (userId: string, data: EmailVerificationParamsDto, params: RequestParams = {}) =>
      this.request<SetEmailVerificationParamsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/user/${userId}/email-verification`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags email-verification-controller
     * @name GetUserEmailVerificationCodeInfo
     * @request GET:/api/sso/v0/admin/user/{userId}/email-verification-info
     */
    getUserEmailVerificationCodeInfo: (userId: string, params: RequestParams = {}) =>
      this.request<GetUserEmailVerificationCodeInfoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/user/${userId}/email-verification-info`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  manageGroupController = {
    /**
     * No description
     *
     * @tags manage-group-controller
     * @name GetManageDashboardGroupsOfAccount
     * @request GET:/api/sso/v0/user/accounts/{identifier}/groups/manage
     */
    getManageDashboardGroupsOfAccount: (identifier: string, params: RequestParams = {}) =>
      this.request<GetManageDashboardGroupsOfAccountData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/accounts/${identifier}/groups/manage`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags manage-group-controller
     * @name CreateManageDashboardGroup
     * @request POST:/api/sso/v0/user/accounts/{identifier}/groups/manage
     */
    createManageDashboardGroup: (identifier: string, data: CreateGroupDto, params: RequestParams = {}) =>
      this.request<CreateManageDashboardGroupData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/accounts/${identifier}/groups/manage`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags manage-group-controller
     * @name DeleteGroup
     * @request DELETE:/api/sso/v0/user/accounts/{identifier}/groups/manage/{groupId}
     */
    deleteGroup: (identifier: string, groupId: string, params: RequestParams = {}) =>
      this.request<DeleteGroupData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/accounts/${identifier}/groups/manage/${groupId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags manage-group-controller
     * @name UpdateManageDashboardGroupGeneralInfo
     * @request PATCH:/api/sso/v0/user/accounts/{identifier}/groups/manage/{groupId}
     */
    updateManageDashboardGroupGeneralInfo: (
      identifier: string,
      groupId: string,
      data: UpdateGroupDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateManageDashboardGroupGeneralInfoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/accounts/${identifier}/groups/manage/${groupId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags manage-group-controller
     * @name UpdateSitesOfManageDashboardGroup
     * @request PATCH:/api/sso/v0/user/accounts/{identifier}/groups/manage/{groupId}/sites
     */
    updateSitesOfManageDashboardGroup: (
      identifier: string,
      groupId: string,
      data: UpdateGroupSitesDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSitesOfManageDashboardGroupData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/accounts/${identifier}/groups/manage/${groupId}/sites`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags manage-group-controller
     * @name UpdateMembersOfManageDashboardGroup
     * @request PATCH:/api/sso/v0/user/accounts/{identifier}/groups/manage/{groupId}/members
     */
    updateMembersOfManageDashboardGroup: (
      identifier: string,
      groupId: string,
      data: UpdateGroupMembersDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateMembersOfManageDashboardGroupData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/accounts/${identifier}/groups/manage/${groupId}/members`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags manage-group-controller
     * @name RemoveSitesFromAllAccountGroups
     * @request PATCH:/api/sso/v0/user/accounts/{identifier}/groups/manage/all-groups-remove-sites
     */
    removeSitesFromAllAccountGroups: (
      identifier: string,
      data: RemoveSitesFromAllGroupsDto,
      params: RequestParams = {},
    ) =>
      this.request<RemoveSitesFromAllAccountGroupsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/accounts/${identifier}/groups/manage/all-groups-remove-sites`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  unitSystemController = {
    /**
     * No description
     *
     * @tags unit-system-controller
     * @name UpdateUnitMemberPermissionsBySystem
     * @request POST:/api/sso/v0/system/unit/{identifier}/team/update-permissions
     */
    updateUnitMemberPermissionsBySystem: (
      identifier: string,
      data: UpdateUnitTeamMemberPermissionsDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUnitMemberPermissionsBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/unit/${identifier}/team/update-permissions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-system-controller
     * @name InviteUnitMemberBySystem
     * @request POST:/api/sso/v0/system/unit/{identifier}/team/invite-member
     */
    inviteUnitMemberBySystem: (identifier: string, data: InviteTeamMemberDto, params: RequestParams = {}) =>
      this.request<InviteUnitMemberBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/unit/${identifier}/team/invite-member`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-system-controller
     * @name SetUnitMemberAllowedSitesBySystem
     * @request POST:/api/sso/v0/system/unit/{identifier}/team/allow-sites/{memberId}
     */
    setUnitMemberAllowedSitesBySystem: (
      identifier: string,
      memberId: string,
      data: TeamMemberAllowedSitesDto,
      params: RequestParams = {},
    ) =>
      this.request<SetUnitMemberAllowedSitesBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/unit/${identifier}/team/allow-sites/${memberId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-system-controller
     * @name RemoveSiteFromAllTeamMembersBySystem
     * @request PATCH:/api/sso/v0/system/unit/{identifier}/team/remove-site
     */
    removeSiteFromAllTeamMembersBySystem: (
      identifier: string,
      data: RemoveSiteForAllMembersDto,
      params: RequestParams = {},
    ) =>
      this.request<RemoveSiteFromAllTeamMembersBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/unit/${identifier}/team/remove-site`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-system-controller
     * @name GetUnitInfoBySystem
     * @request GET:/api/sso/v0/system/unit/{identifier}
     */
    getUnitInfoBySystem: (identifier: string, params: RequestParams = {}) =>
      this.request<GetUnitInfoBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/unit/${identifier}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags unit-system-controller
     * @name DeleteExistingUnitMemberBySystem
     * @request DELETE:/api/sso/v0/system/unit/{identifier}/team/delete-member/{memberId}
     */
    deleteExistingUnitMemberBySystem: (identifier: string, memberId: string, params: RequestParams = {}) =>
      this.request<DeleteExistingUnitMemberBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/unit/${identifier}/team/delete-member/${memberId}`,
        method: 'DELETE',
        ...params,
      }),
  };
  accountMiscController = {
    /**
     * No description
     *
     * @tags account-misc-controller
     * @name GetAccountCodesList
     * @request POST:/api/sso/v0/system/service-user/account-codes
     */
    getAccountCodesList: (data: UserAccountRequestParamsDto, params: RequestParams = {}) =>
      this.request<GetAccountCodesListData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-user/account-codes`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  googleMeasurementController = {
    /**
     * No description
     *
     * @tags google-measurement-controller
     * @name TrackActivity
     * @request POST:/api/sso/v0/system/google-measurement/track-activity
     */
    trackActivity: (data: GoogleMeasurementRequestDto, params: RequestParams = {}) =>
      this.request<TrackActivityData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/google-measurement/track-activity`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  unsubscribeRestController = {
    /**
     * No description
     *
     * @tags unsubscribe-rest-controller
     * @name UpdateSubscription
     * @request POST:/api/sso/v0/public/service-user/unsubscribe/update
     */
    updateSubscription: (data: UpdateEmailSubscriptionsDto, params: RequestParams = {}) =>
      this.request<UpdateSubscriptionData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/unsubscribe/update`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unsubscribe-rest-controller
     * @name ToggleSubscription
     * @request POST:/api/sso/v0/public/service-user/unsubscribe/toggle
     */
    toggleSubscription: (data: ToggleEmailSubscriptionDto, params: RequestParams = {}) =>
      this.request<ToggleSubscriptionData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/unsubscribe/toggle`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags unsubscribe-rest-controller
     * @name CheckSubscription
     * @request POST:/api/sso/v0/public/service-user/unsubscribe/status
     */
    checkSubscription: (data: EmailSubscriptionDto, params: RequestParams = {}) =>
      this.request<CheckSubscriptionData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/unsubscribe/status`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  linkedInRestController = {
    /**
     * No description
     *
     * @tags linked-in-rest-controller
     * @name GetLinkedInUserDetails
     * @request POST:/api/sso/v0/public/linkedin/exchange-user-details
     */
    getLinkedInUserDetails: (data: ExchangeLinkedinAuthCodeDto, params: RequestParams = {}) =>
      this.request<GetLinkedInUserDetailsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/linkedin/exchange-user-details`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  serviceUserAdminController = {
    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name UpdateEmailPrefsByMaster
     * @request POST:/api/sso/v0/master/service-user/update-email-prefs
     */
    updateEmailPrefsByMaster: (data: UpdateEmailSubscriptionsByMasterDto, params: RequestParams = {}) =>
      this.request<UpdateEmailPrefsByMasterData, SsoErrorResponseDto>({
        path: `/api/sso/v0/master/service-user/update-email-prefs`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name SetPasswordByMaster
     * @request POST:/api/sso/v0/master/service-user/set-password
     */
    setPasswordByMaster: (data: SetPasswordByMasterDto, params: RequestParams = {}) =>
      this.request<SetPasswordByMasterData, SsoErrorResponseDto>({
        path: `/api/sso/v0/master/service-user/set-password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name LoginAsByMaster
     * @request POST:/api/sso/v0/master/service-user/login-as
     */
    loginAsByMaster: (data: LoginAsRequestDto, params: RequestParams = {}) =>
      this.request<LoginAsByMasterData, SsoErrorResponseDto>({
        path: `/api/sso/v0/master/service-user/login-as`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name LoginAsOrganizationByMaster
     * @request POST:/api/sso/v0/master/service-user/login-as-organization
     */
    loginAsOrganizationByMaster: (data: LoginAsOrganizationRequestDto, params: RequestParams = {}) =>
      this.request<LoginAsOrganizationByMasterData, SsoErrorResponseDto>({
        path: `/api/sso/v0/master/service-user/login-as-organization`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name GetEmailPrefsByMaster
     * @request POST:/api/sso/v0/master/service-user/get-email-prefs
     */
    getEmailPrefsByMaster: (data: GetEmailSubscriptionsByMasterDto, params: RequestParams = {}) =>
      this.request<GetEmailPrefsByMasterData, SsoErrorResponseDto>({
        path: `/api/sso/v0/master/service-user/get-email-prefs`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name ChangeRoleByMaster
     * @request POST:/api/sso/v0/master/service-user/change-role
     */
    changeRoleByMaster: (data: ChangeRoleByMasterDto, params: RequestParams = {}) =>
      this.request<ChangeRoleByMasterData, SsoErrorResponseDto>({
        path: `/api/sso/v0/master/service-user/change-role`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name ResetPasswordByAdmin
     * @request POST:/api/sso/v0/admin/service-user/reset-password
     */
    resetPasswordByAdmin: (data: ResetPasswordByMasterDto, params: RequestParams = {}) =>
      this.request<ResetPasswordByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/reset-password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name RepublishUserById
     * @request POST:/api/sso/v0/admin/service-user/republish/{userId}
     */
    republishUserById: (userId: string, params: RequestParams = {}) =>
      this.request<RepublishUserByIdData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/republish/${userId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name RepublishAllUsers
     * @request POST:/api/sso/v0/admin/service-user/republish-all
     */
    republishAllUsers: (query: RepublishAllUsersParams, params: RequestParams = {}) =>
      this.request<RepublishAllUsersData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/republish-all`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name RemoveUser
     * @request POST:/api/sso/v0/admin/service-user/remove-user
     */
    removeUser: (data: UserRemoveDto, params: RequestParams = {}) =>
      this.request<RemoveUserData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/remove-user`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name SimulateUserDeletingByAdmin
     * @request POST:/api/sso/v0/admin/service-user/delete/{accCode}
     */
    simulateUserDeletingByAdmin: (accCode: string, data: SimulateUserDeletingDto, params: RequestParams = {}) =>
      this.request<SimulateUserDeletingByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/delete/${accCode}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name ChangeEmailByAdmin
     * @request POST:/api/sso/v0/admin/service-user/change-email
     */
    changeEmailByAdmin: (data: ChangeEmailByAdminDto, params: RequestParams = {}) =>
      this.request<ChangeEmailByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/change-email`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name RestoreUserByAdmin
     * @request GET:/api/sso/v0/admin/service-user/restore/{accCode}
     */
    restoreUserByAdmin: (accCode: string, params: RequestParams = {}) =>
      this.request<RestoreUserByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/restore/${accCode}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name GetUserInfoByAdmin
     * @request GET:/api/sso/v0/admin/service-user/info/{accCode}
     */
    getUserInfoByAdmin: (accCode: string, params: RequestParams = {}) =>
      this.request<GetUserInfoByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/info/${accCode}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name GetUserEmailNotificationsByAdmin
     * @request GET:/api/sso/v0/admin/service-user/email-notifications/{email}
     */
    getUserEmailNotificationsByAdmin: (email: string, params: RequestParams = {}) =>
      this.request<GetUserEmailNotificationsByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/email-notifications/${email}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-user-admin-controller
     * @name GetUserEmailNotificationByAdmin
     * @request GET:/api/sso/v0/admin/service-user/email-notification/{sentEmailId}
     */
    getUserEmailNotificationByAdmin: (sentEmailId: string, params: RequestParams = {}) =>
      this.request<GetUserEmailNotificationByAdminData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-user/email-notification/${sentEmailId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  serviceAccountAdminController = {
    /**
     * No description
     *
     * @tags service-account-admin-controller
     * @name RepublishAllAccounts
     * @request POST:/api/sso/v0/master/service-account/republish-all
     */
    republishAllAccounts: (params: RequestParams = {}) =>
      this.request<RepublishAllAccountsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/master/service-account/republish-all`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags service-account-admin-controller
     * @name UpsertAccountSettings
     * @request POST:/api/sso/v0/admin/service-account/settings
     */
    upsertAccountSettings: (data: ServiceAccountSettingsDto, params: RequestParams = {}) =>
      this.request<UpsertAccountSettingsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/admin/service-account/settings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  accountNotificationsController = {
    /**
     * No description
     *
     * @tags account-notifications-controller
     * @name GetPendingNotifications
     * @request GET:/api/sso/v0/user/service-user/notification
     */
    getPendingNotifications: (query: GetPendingNotificationsParams, params: RequestParams = {}) =>
      this.request<GetPendingNotificationsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/notification`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags account-notifications-controller
     * @name DeletePendingNotifications
     * @request DELETE:/api/sso/v0/user/service-user/notification
     */
    deletePendingNotifications: (data: DeleteAccountNotificationsDto, params: RequestParams = {}) =>
      this.request<DeletePendingNotificationsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/notification`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mfaController = {
    /**
     * No description
     *
     * @tags mfa-controller
     * @name GetAccountMfaInfo
     * @request GET:/api/sso/v0/user/service-user/mfa
     */
    getAccountMfaInfo: (params: RequestParams = {}) =>
      this.request<GetAccountMfaInfoData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/service-user/mfa`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  extendedJwtController = {
    /**
     * No description
     *
     * @tags extended-jwt-controller
     * @name GetExtendedJwtUserDetails
     * @request GET:/api/sso/v0/user/extended-jwt
     */
    getExtendedJwtUserDetails: (params: RequestParams = {}) =>
      this.request<GetExtendedJwtUserDetailsData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/extended-jwt`,
        method: 'GET',
        ...params,
      }),
  };
  scannerTeamSystemController = {
    /**
     * No description
     *
     * @tags scanner-team-system-controller
     * @name FindScannerTeamMemberByIdBySystem
     * @request GET:/api/sso/v0/system/team/scanner/members/{memberId}
     */
    findScannerTeamMemberByIdBySystem: (memberId: string, params: RequestParams = {}) =>
      this.request<FindScannerTeamMemberByIdBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/team/scanner/members/${memberId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags scanner-team-system-controller
     * @name GetScannerTeamMembersBySystem
     * @request GET:/api/sso/v0/system/team/scanner/account-members/{accountId}
     */
    getScannerTeamMembersBySystem: (
      {accountId, ...query}: GetScannerTeamMembersBySystemParams,
      params: RequestParams = {},
    ) =>
      this.request<GetScannerTeamMembersBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/team/scanner/account-members/${accountId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  ca11YTeamSystemController = {
    /**
     * No description
     *
     * @tags ca-11y-team-system-controller
     * @name FindCa11YTeamMemberByIdBySystem
     * @request GET:/api/sso/v0/system/team/ca11y/members/{memberId}
     */
    findCa11YTeamMemberByIdBySystem: (memberId: string, params: RequestParams = {}) =>
      this.request<FindCa11YTeamMemberByIdBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/team/ca11y/members/${memberId}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ca-11y-team-system-controller
     * @name GetCa11YTeamMembersBySystem
     * @request GET:/api/sso/v0/system/team/ca11y/account-members/{accountId}
     */
    getCa11YTeamMembersBySystem: (
      {accountId, ...query}: GetCa11YTeamMembersBySystemParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCa11YTeamMembersBySystemData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/team/ca11y/account-members/${accountId}`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  clearbitController = {
    /**
     * No description
     *
     * @tags clearbit-controller
     * @name GetUserInfoEnrichment
     * @request GET:/api/sso/v0/system/service-user/enrichment
     */
    getUserInfoEnrichment: (query: GetUserInfoEnrichmentParams, params: RequestParams = {}) =>
      this.request<GetUserInfoEnrichmentData, SsoErrorResponseDto>({
        path: `/api/sso/v0/system/service-user/enrichment`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags clearbit-controller
     * @name Update
     * @request GET:/api/sso/v0/public/service-users/update
     */
    update: (query: UpdateParams, params: RequestParams = {}) =>
      this.request<UpdateData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-users/update`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  oAuthCallbackController = {
    /**
     * No description
     *
     * @tags o-auth-callback-controller
     * @name PopupLoginResult
     * @request GET:/api/sso/v0/public/popup-login-result
     */
    popupLoginResult: (query: PopupLoginResultParams, params: RequestParams = {}) =>
      this.request<PopupLoginResultData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/popup-login-result`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  geoController = {
    /**
     * No description
     *
     * @tags geo-controller
     * @name GetIsSanctionedOrigin
     * @request GET:/api/sso/v0/public/is-sanctioned-origin
     */
    getIsSanctionedOrigin: (params: RequestParams = {}) =>
      this.request<GetIsSanctionedOriginData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/is-sanctioned-origin`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags geo-controller
     * @name GetCountryAndCityByIp
     * @request GET:/api/sso/v0/public/ip-country-exchange
     */
    getCountryAndCityByIp: (query: GetCountryAndCityByIpParams, params: RequestParams = {}) =>
      this.request<GetCountryAndCityByIpData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/ip-country-exchange`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @name SsoV0PublicServiceUserLoginCreate
     * @request POST:/api/sso/v0/public/service-user/login
     */
    ssoV0PublicServiceUserLoginCreate: (data: UserLoginDto, params: RequestParams = {}) =>
      this.request<SsoV0PublicServiceUserLoginCreateData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name SsoV0PublicServiceUserRefreshTokenList
     * @request GET:/api/sso/v0/public/service-user/refresh-token
     */
    ssoV0PublicServiceUserRefreshTokenList: (params: RequestParams = {}) =>
      this.request<SsoV0PublicServiceUserRefreshTokenListData, SsoErrorResponseDto>({
        path: `/api/sso/v0/public/service-user/refresh-token`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name SsoV0UserLoginOauthExchangeList
     * @request GET:/api/sso/v0/user/login/oauth-exchange
     */
    ssoV0UserLoginOauthExchangeList: (params: RequestParams = {}) =>
      this.request<SsoV0UserLoginOauthExchangeListData, SsoErrorResponseDto>({
        path: `/api/sso/v0/user/login/oauth-exchange`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
}
